/**
 * Dev Career Simulator — Text-based career game
 * Easter egg: create a Ghost page with the "dev-sim" template to play.
 * IIFE, ES5-compatible, no dependencies.
 */
(function () {
    'use strict';

    var root = document.getElementById('dev-sim');
    if (!root) return;

    // ==================== SECTION 1: PRNG ====================

    function mulberry32(seed) {
        var state = seed | 0;
        return function () {
            state = (state + 0x6D2B79F5) | 0;
            var t = Math.imul(state ^ (state >>> 15), 1 | state);
            t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
            return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
        };
    }

    var rng;
    var rngCalls = 0;

    function rand() {
        rngCalls++;
        return rng();
    }

    function randInt(min, max) {
        return Math.floor(rand() * (max - min + 1)) + min;
    }

    function pick(arr) {
        return arr[Math.floor(rand() * arr.length)];
    }

    function initRng(seed) {
        rng = mulberry32(seed);
        rngCalls = 0;
    }

    function restoreRng(seed, calls) {
        rng = mulberry32(seed);
        rngCalls = 0;
        for (var i = 0; i < calls; i++) rng();
        rngCalls = calls;
    }

    // ==================== SECTION 2: GAME DATA ====================

    var BASE_LEVELS = [
        { id: 'junior', name: 'Junior Developer', index: 0 },
        { id: 'mid', name: 'Mid-Level Developer', index: 1 },
        { id: 'senior', name: 'Senior Developer', index: 2 }
    ];

    var IC_LEVELS = [
        { id: 'junior', name: 'Junior Developer', index: 0 },
        { id: 'mid', name: 'Mid-Level Developer', index: 1 },
        { id: 'senior', name: 'Senior Developer', index: 2 },
        { id: 'staff', name: 'Staff Engineer', index: 3 },
        { id: 'principal', name: 'Principal Engineer', index: 4 }
    ];

    var MGMT_LEVELS = [
        { id: 'junior', name: 'Junior Developer', index: 0 },
        { id: 'mid', name: 'Mid-Level Developer', index: 1 },
        { id: 'senior', name: 'Senior Developer', index: 2 },
        { id: 'techlead', name: 'Tech Lead', index: 3 },
        { id: 'engmanager', name: 'Engineering Manager', index: 4 },
        { id: 'vpe', name: 'VP of Engineering', index: 5 }
    ];

    var LEVELS = BASE_LEVELS;

    var PROMO_REQS = {
        junior: { skill: 35, reputation: 20, prs: 15, needsReview: true },
        mid: { skill: 55, reputation: 40, features: 5, designDocs: 1, needsReview: true },
        senior_ic: { skill: 70, reputation: 55, features: 10, designDocs: 3, mentorships: 2, techTalks: 2, needsReview: true },
        staff: { skill: 85, reputation: 75, designDocs: 5, mentorships: 4, techTalks: 4, patents: 1, conferencetalks: 2, needsReview: true },
        senior_mgmt: { skill: 60, reputation: 50, features: 8, designDocs: 2, mentorships: 3, managerRel: 65, needsReview: true },
        techlead: { skill: 70, reputation: 65, mentorships: 5, managerRel: 70, designDocs: 4, needsReview: true },
        engmanager: { skill: 75, reputation: 80, mentorships: 8, managerRel: 75, conferencetalks: 1, needsReview: true }
    };

    var ITEM_DEFS = [
        { id: 'prs',        name: 'PRs Merged',       icon: '\uD83D\uDD00', minLevel: 0 },
        { id: 'features',   name: 'Features Shipped',  icon: '\uD83D\uDE80', minLevel: 0 },
        { id: 'hotfixes',   name: 'Bug Hotfixes',      icon: '\uD83D\uDC1B', minLevel: 0 },
        { id: 'designDocs', name: 'Design Docs',       icon: '\uD83D\uDCC4', minLevel: 1 },
        { id: 'techTalks',  name: 'Tech Talks',        icon: '\uD83C\uDF99', minLevel: 0 },
        { id: 'blogPosts',  name: 'Blog Posts',        icon: '\u270D\uFE0F', minLevel: 0 },
        { id: 'mentorships',name: 'Mentorships',       icon: '\uD83E\uDDD1\u200D\uD83C\uDFEB', minLevel: 2 },
        { id: 'patents',    name: 'Patents',           icon: '\uD83D\uDCDC', minLevel: 2 },
        { id: 'conferencetalks', name: 'Conf. Talks',  icon: '\uD83C\uDFE4', minLevel: 1 }
    ];

    var STATUS_DEFS = {
        newJobEnergy:    { name: 'New Job Energy',    type: 'good',    moraleMod: 2,  defaultDur: 3 },
        onCall:          { name: 'On-Call',            type: 'bad',     moraleMod: -3, defaultDur: 1 },
        crunchMode:      { name: 'Crunch Mode',       type: 'bad',     moraleMod: -4, defaultDur: 2 },
        burnoutStatus:   { name: 'Burnout',            type: 'bad',     moraleMod: -5, defaultDur: 99 },
        flowState:       { name: 'Flow State',         type: 'good',    moraleMod: 0,  defaultDur: 2 },
        imposterSyndrome:{ name: 'Imposter Syndrome',  type: 'neutral', moraleMod: 0,  defaultDur: 3 },
        pip:             { name: 'PIP',                type: 'bad',     moraleMod: -2, defaultDur: 3 },
        badManager:      { name: 'Bad Manager',        type: 'bad',     moraleMod: -2, defaultDur: 99 },
        jobHunting:      { name: 'Job Hunting',       type: 'neutral', moraleMod: 1,  defaultDur: 3 },
        remoteWork:      { name: 'Remote Work',       type: 'good',    moraleMod: 1,  defaultDur: 99 },
        mentorBonus:     { name: 'Mentor Bonus',      type: 'good',    moraleMod: 0,  defaultDur: 6 },
        greatTeam:       { name: 'Great Team',        type: 'good',    moraleMod: 2,  defaultDur: 99 },
        coachBonus:      { name: 'Professional Coach', type: 'good',    moraleMod: 0,  defaultDur: 6 }
    };

    var COMPANY_TYPES = {
        startup: {
            id: 'startup', name: 'Startup', icon: '\uD83D\uDE80', desc: 'Fast-paced, equity-heavy, chaos-friendly. Ship or die.',
            startOverrides: { morale: 75, skill: 15, reputation: 5, managerRel: 60 },
            monthlyMods: { skill: 1, morale: -1, reputation: 0, managerRel: 0 },
            eventProbMult: { sprintOvercommit: 1.5, hackathon: 1.5, layoffs: 1.3 },
            salaryMult: 0.75, promoSpeedMult: 0.7, scoreMod: 200, crunchRiskMult: 1.5
        },
        bigtech: {
            id: 'bigtech', name: 'Big Tech', icon: '\uD83C\uDFE2', desc: 'Process-heavy, well-paid, promo-committee politics.',
            startOverrides: { morale: 70, skill: 15, reputation: 5, managerRel: 50 },
            monthlyMods: { skill: 0, morale: 0, reputation: 0, managerRel: 0 },
            eventProbMult: { teamReorg: 1.5, skipLevelMeeting: 1.5, companyAcquisition: 1.3 },
            salaryMult: 1.4, promoSpeedMult: 1.3, scoreMod: 300, crunchRiskMult: 0.8
        },
        agency: {
            id: 'agency', name: 'Agency', icon: '\uD83C\uDFA8', desc: 'Client-driven, variety of projects, deadline hell.',
            startOverrides: { morale: 65, skill: 20, reputation: 5, managerRel: 50 },
            monthlyMods: { skill: 1, morale: -1, reputation: 0, managerRel: 0 },
            eventProbMult: { sprintOvercommit: 1.4, frameworkMigration: 1.3, badDeploy: 1.3 },
            salaryMult: 0.9, promoSpeedMult: 1.0, scoreMod: 100, crunchRiskMult: 1.4
        },
        remote: {
            id: 'remote', name: 'Remote-First', icon: '\uD83C\uDFE0', desc: 'Async culture, flexible hours, occasional loneliness.',
            startOverrides: { morale: 75, skill: 15, reputation: 5, managerRel: 45 },
            monthlyMods: { skill: 0, morale: 1, reputation: 0, managerRel: 0 },
            eventProbMult: { slackOutage: 1.5, wfhPolicyChange: 0.3, openFloorPlan: 0.1 },
            salaryMult: 1.05, promoSpeedMult: 1.1, scoreMod: 100, crunchRiskMult: 0.6
        },
        nonprofit: {
            id: 'nonprofit', name: 'Non-Profit', icon: '\u2764\uFE0F', desc: 'Mission-driven, low pay, legacy systems, high purpose.',
            startOverrides: { morale: 80, skill: 15, reputation: 10, managerRel: 55 },
            monthlyMods: { skill: 0, morale: 1, reputation: 0, managerRel: 0 },
            eventProbMult: { layoffs: 0.5, companyAcquisition: 0.2, recruiterDM: 0.5 },
            salaryMult: 0.65, promoSpeedMult: 1.4, scoreMod: 0, crunchRiskMult: 0.3
        }
    };

    // ---- World Events ----
    var WORLD_EVENTS = [
        {
            id: 'recession', name: 'Economic Recession', icon: '\uD83D\uDCC9',
            desc: 'Markets are crashing. Hiring freezes, budget cuts, and uncertainty everywhere.',
            durationRange: [6, 10], triggerProb: 0.04,
            monthlyMods: { morale: -2, managerRel: -1 },
            companyMods: {
                startup:   { salaryMult: 0.85, crunchRiskMult: 1.3, moraleMod: -1 },
                bigtech:   { salaryMult: 0.95, crunchRiskMult: 1.0, moraleMod: 0 },
                agency:    { salaryMult: 0.80, crunchRiskMult: 1.5, moraleMod: -2 },
                remote:    { salaryMult: 0.90, crunchRiskMult: 0.8, moraleMod: 0 },
                nonprofit: { salaryMult: 0.75, crunchRiskMult: 0.5, moraleMod: -1 }
            },
            eventProbMods: { layoffs: 2.0, recruiterDM: 0.3, companyAcquisition: 1.5 },
            promoSpeedMod: 1.5,
            startText: 'The economy is tanking. Stocks are plummeting, layoffs are everywhere, and your CEO sends a "belt-tightening" email. How do you adapt?',
            endText: 'The recession is easing. Markets stabilize, hiring resumes, and cautious optimism returns to the office.',
            startChoices: [
                {
                    label: 'Hunker down and become indispensable',
                    hint: '+Skill, -Morale, show loyalty',
                    apply: function (s) {
                        addStat(s, 'skill', 5); addStat(s, 'morale', -3); addStat(s, 'managerRel', 4);
                        return { lines: ['+5 Skill', '-3 Morale', '+4 Manager Rel', 'You become the go-to person. Job security through competence.'] };
                    }
                },
                {
                    label: 'Start building your safety net',
                    hint: '+Morale, prep for worst case',
                    apply: function (s) {
                        addStat(s, 'morale', 3); addStatus(s, 'jobHunting', 3);
                        return { lines: ['+3 Morale', 'Status: Job Hunting (3mo)', 'You quietly update your resume and LinkedIn. Just in case.'] };
                    }
                }
            ]
        },
        {
            id: 'aiBoom', name: 'AI Industry Boom', icon: '\uD83E\uDD16',
            desc: 'AI is transforming everything. Companies are scrambling to adopt or be left behind.',
            durationRange: [6, 12], triggerProb: 0.04,
            monthlyMods: { skill: 1, morale: -1 },
            companyMods: {
                startup:   { salaryMult: 1.15, crunchRiskMult: 1.3, moraleMod: 1 },
                bigtech:   { salaryMult: 1.20, crunchRiskMult: 1.2, moraleMod: 0 },
                agency:    { salaryMult: 1.0, crunchRiskMult: 1.0, moraleMod: -1 },
                remote:    { salaryMult: 1.05, crunchRiskMult: 0.9, moraleMod: 0 },
                nonprofit: { salaryMult: 0.95, crunchRiskMult: 0.5, moraleMod: -1 }
            },
            eventProbMods: { aiThreat: 2.0, recruiterDM: 1.5, hackathon: 1.5 },
            promoSpeedMod: 0.9,
            startText: 'AI is the hottest topic in tech. Every company wants "AI-powered" everything. The pressure to adapt is intense. What\'s your play?',
            endText: 'The AI hype cycle normalizes. AI is now just another tool in the toolkit, not a magic wand.',
            startChoices: [
                {
                    label: 'Go all-in on AI skills',
                    hint: '+Skill (big), -Morale',
                    apply: function (s) {
                        addStat(s, 'skill', 7); addStat(s, 'morale', -2); addStat(s, 'reputation', 3);
                        return { lines: ['+7 Skill', '-2 Morale', '+3 Reputation', 'You dive deep into ML and LLMs. Exhausting but future-proof.'] };
                    }
                },
                {
                    label: 'Focus on what AI can\'t replace',
                    hint: '+Rep, steady approach',
                    apply: function (s) {
                        addStat(s, 'reputation', 5); addStat(s, 'morale', 2);
                        return { lines: ['+5 Reputation', '+2 Morale', 'You double down on system design and leadership. Humans still matter.'] };
                    }
                }
            ]
        },
        {
            id: 'pandemic', name: 'Global Pandemic', icon: '\uD83C\uDFE0',
            desc: 'A global health crisis forces everyone remote. Offices close, routines shatter.',
            durationRange: [8, 12], triggerProb: 0.03,
            monthlyMods: { morale: -2, managerRel: -2 },
            companyMods: {
                startup:   { salaryMult: 0.90, crunchRiskMult: 1.2, moraleMod: -1 },
                bigtech:   { salaryMult: 1.0, crunchRiskMult: 0.9, moraleMod: -1 },
                agency:    { salaryMult: 0.85, crunchRiskMult: 1.3, moraleMod: -2 },
                remote:    { salaryMult: 1.0, crunchRiskMult: 0.7, moraleMod: 1 },
                nonprofit: { salaryMult: 0.80, crunchRiskMult: 0.4, moraleMod: 0 }
            },
            eventProbMods: { slackOutage: 1.5, wfhPolicyChange: 0.1, lonelyRemote: 1.5 },
            promoSpeedMod: 1.3,
            startText: 'A global pandemic hits. Offices are closing, everyone is working from home. The world has changed overnight. How do you cope?',
            endText: 'The pandemic eases. Some normalcy returns, though the workplace is changed forever.',
            startChoices: [
                {
                    label: 'Embrace remote and build new routines',
                    hint: '+Morale, +Skill',
                    apply: function (s) {
                        addStat(s, 'morale', 3); addStat(s, 'skill', 3);
                        return { lines: ['+3 Morale', '+3 Skill', 'You adapt quickly. Home office life suits you.'] };
                    }
                },
                {
                    label: 'Focus on supporting your team',
                    hint: '+Rep, +Manager Rel',
                    apply: function (s) {
                        addStat(s, 'reputation', 4); addStat(s, 'managerRel', 4);
                        return { lines: ['+4 Reputation', '+4 Manager Rel', 'You become the team\'s emotional anchor. Leadership notices.'] };
                    }
                }
            ]
        },
        {
            id: 'bullMarket', name: 'Bull Market', icon: '\uD83D\uDCC8',
            desc: 'Tech stocks are soaring. Funding is flowing. Everyone is hiring.',
            durationRange: [4, 8], triggerProb: 0.05,
            monthlyMods: { morale: 1, reputation: 1 },
            companyMods: {
                startup:   { salaryMult: 1.20, crunchRiskMult: 1.0, moraleMod: 2 },
                bigtech:   { salaryMult: 1.15, crunchRiskMult: 0.8, moraleMod: 1 },
                agency:    { salaryMult: 1.10, crunchRiskMult: 0.9, moraleMod: 1 },
                remote:    { salaryMult: 1.10, crunchRiskMult: 0.7, moraleMod: 1 },
                nonprofit: { salaryMult: 1.0, crunchRiskMult: 0.3, moraleMod: 0 }
            },
            eventProbMods: { recruiterDM: 3.0, stockVest: 2.0, layoffs: 0.2 },
            promoSpeedMod: 0.8,
            startText: 'Tech is booming! Stocks are up, funding rounds are massive, and recruiters are desperate. How do you capitalize?',
            endText: 'The bull market cools off. Things return to a more sustainable pace.',
            startChoices: [
                {
                    label: 'Negotiate a raise while you have leverage',
                    hint: '+Morale, salary leverage',
                    apply: function (s) {
                        addStat(s, 'morale', 6); addStat(s, 'managerRel', -2);
                        return { lines: ['+6 Morale', '-2 Manager Rel', 'You negotiate a market adjustment. Your manager grudgingly approves.'] };
                    }
                },
                {
                    label: 'Build your brand while attention is high',
                    hint: '+Rep (big)',
                    apply: function (s) {
                        addStat(s, 'reputation', 7); addStat(s, 'morale', 2);
                        return { lines: ['+7 Reputation', '+2 Morale', 'You publish, speak, and network. Your profile is rising fast.'] };
                    }
                }
            ]
        },
        {
            id: 'regulation', name: 'Tech Regulation Wave', icon: '\u2696\uFE0F',
            desc: 'New regulations are hitting the tech industry. Compliance is now everyone\'s problem.',
            durationRange: [6, 8], triggerProb: 0.03,
            monthlyMods: { skill: 1, morale: -1 },
            companyMods: {
                startup:   { salaryMult: 0.95, crunchRiskMult: 1.2, moraleMod: -1 },
                bigtech:   { salaryMult: 1.0, crunchRiskMult: 1.1, moraleMod: -1 },
                agency:    { salaryMult: 1.0, crunchRiskMult: 1.5, moraleMod: -2 },
                remote:    { salaryMult: 1.0, crunchRiskMult: 1.0, moraleMod: 0 },
                nonprofit: { salaryMult: 1.05, crunchRiskMult: 0.3, moraleMod: 1 }
            },
            eventProbMods: { securityBreach: 0.5, frameworkMigration: 1.5 },
            promoSpeedMod: 1.1,
            startText: 'New tech regulations are sweeping through. Data privacy, AI ethics, and security compliance are now mandatory. How do you respond?',
            endText: 'The regulatory dust settles. Compliance is now baked into processes and the panic subsides.',
            startChoices: [
                {
                    label: 'Become the compliance expert',
                    hint: '+Skill, +Rep, tedious',
                    apply: function (s) {
                        addStat(s, 'skill', 5); addStat(s, 'reputation', 4); addStat(s, 'morale', -3);
                        return { lines: ['+5 Skill', '+4 Reputation', '-3 Morale', 'You become the go-to for regulatory questions. Boring but valuable.'] };
                    }
                },
                {
                    label: 'Keep building, let legal sort it out',
                    hint: 'Business as usual',
                    apply: function (s) {
                        addStat(s, 'morale', 1);
                        return { lines: ['+1 Morale', 'You stay focused on shipping. Someone else can read the fine print.'] };
                    }
                }
            ]
        },
        {
            id: 'techBubbleBurst', name: 'Tech Bubble Burst', icon: '\uD83D\uDCA5',
            desc: 'The bubble pops. Valuations crater, startups fold, and big tech freezes hiring.',
            durationRange: [4, 6], triggerProb: 0.03,
            monthlyMods: { morale: -3, reputation: -1 },
            companyMods: {
                startup:   { salaryMult: 0.70, crunchRiskMult: 1.8, moraleMod: -3 },
                bigtech:   { salaryMult: 0.90, crunchRiskMult: 1.0, moraleMod: -1 },
                agency:    { salaryMult: 0.80, crunchRiskMult: 1.3, moraleMod: -2 },
                remote:    { salaryMult: 0.85, crunchRiskMult: 1.0, moraleMod: -1 },
                nonprofit: { salaryMult: 0.90, crunchRiskMult: 0.3, moraleMod: 0 }
            },
            eventProbMods: { layoffs: 3.0, recruiterDM: 0.1, stockVest: 0.3, runwayPanic: 2.0 },
            promoSpeedMod: 1.8,
            startText: 'The tech bubble has burst. Unicorns are dying, layoffs are massive, and the mood is grim. What\'s your survival strategy?',
            endText: 'The worst is over. The industry begins to rebuild, leaner and more cautious.',
            startChoices: [
                {
                    label: 'Diversify your skills for resilience',
                    hint: '+Skill, prepare for anything',
                    apply: function (s) {
                        addStat(s, 'skill', 6); addStat(s, 'morale', -2);
                        return { lines: ['+6 Skill', '-2 Morale', 'You learn infra, security, and data. A Swiss Army knife engineer.'] };
                    }
                },
                {
                    label: 'Network hard while everyone is vulnerable',
                    hint: '+Rep, +Manager Rel',
                    apply: function (s) {
                        addStat(s, 'reputation', 5); addStat(s, 'managerRel', 3);
                        return { lines: ['+5 Reputation', '+3 Manager Rel', 'Helping others in hard times builds lasting bonds.'] };
                    }
                }
            ]
        }
    ];

    function getWorldEvent(id) {
        for (var i = 0; i < WORLD_EVENTS.length; i++) {
            if (WORLD_EVENTS[i].id === id) return WORLD_EVENTS[i];
        }
        return null;
    }

    // ---- Shop Items ----
    var SHOP_ITEMS = [
        {
            id: 'onlineCourses', name: 'Online Courses', icon: '\uD83D\uDCDA',
            desc: '+3 Skill instantly', cost: 3000,
            apply: function (s) { addStat(s, 'skill', 3); }
        },
        {
            id: 'homeOffice', name: 'Home Office Setup', icon: '\uD83E\uDE91',
            desc: '+1 Morale/month (permanent)', cost: 8000
        },
        {
            id: 'conferenceTickets', name: 'Conference Tickets', icon: '\uD83C\uDFAB',
            desc: '+1 Conf Talk, +3 Rep instantly', cost: 5000,
            apply: function (s) { s.items.conferencetalks = (s.items.conferencetalks || 0) + 1; addStat(s, 'reputation', 3); }
        },
        {
            id: 'professionalCoach', name: 'Professional Coach', icon: '\uD83C\uDFAF',
            desc: 'coachBonus status 6mo (+2 MgrRel/month)', cost: 10000,
            apply: function (s) { addStatus(s, 'coachBonus', 6); }
        },
        {
            id: 'coworkingMembership', name: 'Coworking Membership', icon: '\uD83C\uDFE2',
            desc: '+1 Rep/month, negates remote isolation', cost: 2000
        },
        {
            id: 'sideProjectHosting', name: 'Side Project Hosting', icon: '\uD83D\uDDA5\uFE0F',
            desc: 'Doubles OSS bonus chance on sideProject', cost: 1000
        },
        {
            id: 'ergonomicSetup', name: 'Ergonomic Setup', icon: '\u2328\uFE0F',
            desc: 'Halves crunchMode morale penalty', cost: 4000
        },
        {
            id: 'resumeService', name: 'Resume Service', icon: '\uD83D\uDCDD',
            desc: 'Next job hop has no rep penalty', cost: 2000
        },
        {
            id: 'financialAdvisor', name: 'Financial Advisor', icon: '\uD83D\uDCB0',
            desc: 'Savings rate 30% \u2192 33%', cost: 6000
        },
        {
            id: 'meditationApp', name: 'Meditation App', icon: '\uD83E\uDDD8',
            desc: 'Burnout status duration -1 month', cost: 500
        }
    ];

    function hasPurchase(s, itemId) {
        return s.meta.purchases && s.meta.purchases.indexOf(itemId) !== -1;
    }

    // ---- Achievements ----
    var ACHIEVEMENTS = [
        // Career Milestones (6)
        {
            id: 'first_promo', name: 'First Rung', icon: '\uD83E\uDE9C',
            desc: 'Got your first promotion.', hint: 'Get promoted once.',
            check: function (s) { return s.levelIndex >= 1; }
        },
        {
            id: 'reach_staff', name: 'Staff Material', icon: '\u2B50',
            desc: 'Reached Staff Engineer on the IC track.', hint: 'Reach Staff Engineer.',
            check: function (s) { return s.meta.track === 'ic' && s.levelIndex >= 3; }
        },
        {
            id: 'reach_principal', name: 'Principal Club', icon: '\uD83C\uDFC6',
            desc: 'Reached Principal Engineer.', hint: 'Reach Principal Engineer.',
            check: function (s) { return s.meta.track === 'ic' && s.levelIndex >= 4; }
        },
        {
            id: 'reach_vpe', name: 'VP of Engineering', icon: '\uD83D\uDCBC',
            desc: 'Reached VP of Engineering on the management track.', hint: 'Reach VP of Engineering.',
            check: function (s) { return s.meta.track === 'mgmt' && s.levelIndex >= 5; }
        },
        {
            id: 'took_ic_track', name: 'Individual Contributor', icon: '\uD83D\uDCBB',
            desc: 'Chose the IC track at Senior.', hint: 'Choose a career path at Senior.'
        },
        {
            id: 'took_mgmt_track', name: 'People Manager', icon: '\uD83D\uDC65',
            desc: 'Chose the Management track at Senior.', hint: 'Choose a career path at Senior.'
        },
        // Endings (7)
        {
            id: 'ending_burnout', name: 'Flames Out', icon: '\uD83D\uDD25',
            desc: 'Burned out and left the industry.', hint: 'Reach 0 morale.'
        },
        {
            id: 'ending_fired', name: 'Pink Slip', icon: '\uD83D\uDCDC',
            desc: 'Got fired after failing a PIP.', hint: 'Fail a performance plan.'
        },
        {
            id: 'ending_quit', name: 'Rage Quit IRL', icon: '\uD83D\uDEAA',
            desc: 'Quit tech entirely.', hint: 'Reach a breaking point.'
        },
        {
            id: 'ending_founder', name: 'Founder Mode', icon: '\uD83D\uDE80',
            desc: 'Left to start your own company.', hint: 'Find the startup ending.'
        },
        {
            id: 'ending_devadvocate', name: 'Dev Advocate', icon: '\uD83C\uDF99\uFE0F',
            desc: 'Became a Developer Advocate.', hint: 'Build enough reputation and content.'
        },
        {
            id: 'ending_exit', name: 'Acquired!', icon: '\uD83D\uDCB0',
            desc: 'Your startup got acquired.', hint: 'Find the startup exit ending.'
        },
        {
            id: 'ending_plateau', name: 'Plateaued', icon: '\u23F3',
            desc: '10 years passed without reaching the top.', hint: 'Run out of time.'
        },
        // Stats (2)
        {
            id: 'max_stat', name: 'Maxed Out', icon: '\uD83D\uDCAF',
            desc: 'Pushed a stat to 100.', hint: 'Max out any stat.',
            check: function (s) {
                return s.vars.morale === 100 || s.vars.skill === 100 || s.vars.reputation === 100 || s.vars.managerRel === 100;
            }
        },
        {
            id: 'all_stats_high', name: 'Balanced', icon: '\u2696\uFE0F',
            desc: 'All four stats at 70 or above.', hint: 'Keep all stats high at once.',
            check: function (s) {
                return s.vars.morale >= 70 && s.vars.skill >= 70 && s.vars.reputation >= 70 && s.vars.managerRel >= 70;
            }
        },
        // Specialization (2)
        {
            id: 'spec_expert', name: 'Expert Mode', icon: '\uD83E\uDD13',
            desc: 'Reached Expert specialization level.', hint: 'Reach 50 spec XP.',
            check: function (s) { return s.specXP >= 50; }
        },
        {
            id: 'spec_master', name: 'Master of the Craft', icon: '\uD83E\uDD47',
            desc: 'Reached Master specialization level.', hint: 'Reach 75 spec XP.',
            check: function (s) { return s.specXP >= 75; }
        },
        // Economy (3)
        {
            id: 'first_purchase', name: 'Retail Therapy', icon: '\uD83D\uDED2',
            desc: 'Bought your first shop item.', hint: 'Visit the shop.'
        },
        {
            id: 'all_purchases', name: 'Maximalist', icon: '\uD83C\uDFEC',
            desc: 'Bought every item in the shop.', hint: 'Buy all 10 shop items.',
            check: function (s) { return s.meta.purchases && s.meta.purchases.length >= 10; }
        },
        {
            id: 'rich', name: 'F.I.R.E.', icon: '\uD83D\uDCB8',
            desc: 'Saved up $50,000.', hint: 'Accumulate savings.',
            check: function (s) { return (s.meta.savings || 0) >= 50000; }
        },
        // Misc (1)
        {
            id: 'survive_world_event', name: 'Weathered the Storm', icon: '\u26C8\uFE0F',
            desc: 'Survived a world event.', hint: 'Endure a macro crisis.'
        },
        // Prestige (2)
        {
            id: 'first_prestige', name: 'Second Career', icon: '\uD83D\uDD04',
            desc: 'Prestiged for the first time.', hint: 'Win and start a new career.'
        },
        {
            id: 'max_prestige', name: 'Living Legend', icon: '\uD83C\uDF1F',
            desc: 'Reached maximum prestige level.', hint: 'Prestige to the highest level.'
        },
        // Statistics (4)
        { id: 'played_10', name: 'Veteran Player', icon: '\uD83C\uDFAE', desc: 'Played 10 games.', hint: 'Keep playing!' },
        { id: 'win_streak_3', name: 'Hot Streak', icon: '\uD83D\uDD25', desc: 'Won 3 games in a row.', hint: 'Win consecutively.' },
        { id: 'all_endings', name: 'Seen It All', icon: '\uD83D\uDC41\uFE0F', desc: 'Experienced every ending.', hint: 'Try all 9 endings.' },
        { id: 'all_companies', name: 'Corporate Tourist', icon: '\uD83C\uDFE2', desc: 'Played at every company type.', hint: 'Try all 5 companies.' },
        // Skill Tree (2)
        { id: 'first_perk', name: 'Skill Unlocked', icon: '\uD83D\uDD13', desc: 'Unlocked your first perk.', hint: 'Use the skill tree.' },
        { id: 'full_tree', name: 'Talent Maxed', icon: '\uD83C\uDF33', desc: 'Unlocked 5 perks in one game.', hint: 'Max out your skill tree.' },
        // Polish (2)
        { id: 'speed_run', name: 'Speed Runner', icon: '\u26A1', desc: 'Won in 36 months or less.', hint: 'Win fast.' },
        { id: 'played_25', name: 'Dedicated', icon: '\uD83D\uDC8E', desc: 'Played 25 games.', hint: 'Keep coming back.' }
    ];

    function getAchievementDef(id) {
        for (var i = 0; i < ACHIEVEMENTS.length; i++) {
            if (ACHIEVEMENTS[i].id === id) return ACHIEVEMENTS[i];
        }
        return null;
    }

    // ---- Prestige Levels ----
    var PRESTIGE_LEVELS = [
        { level: 1, name: 'Sophomore',   perk: '+5 starting Skill',      stat: 'skill',      bonus: 5, scoreMult: 1.1 },
        { level: 2, name: 'Seasoned',    perk: '+5 starting Reputation', stat: 'reputation',  bonus: 5, scoreMult: 1.2 },
        { level: 3, name: 'Established', perk: '+$3,000 starting savings', stat: 'savings',   bonus: 3000, scoreMult: 1.3 },
        { level: 4, name: 'Veteran',     perk: '+5 starting Morale',     stat: 'morale',      bonus: 5, scoreMult: 1.4 },
        { level: 5, name: 'Legend',       perk: '+5 starting Manager Rel', stat: 'managerRel', bonus: 5, scoreMult: 1.5 }
    ];
    var PRESTIGE_MAX = 5;

    var STAT_DEFAULTS = {
        totalGames: 0, totalWins: 0, totalLosses: 0,
        bestScore: 0, worstScore: 999999, totalScore: 0,
        totalMonthsPlayed: 0, fastestWin: 999,
        totalEarnings: 0, highestLevelIndex: 0, highestLevelName: '',
        endings: { burnout:0, fired:0, won:0, startup:0, devAdvocate:0, startupExit:0, quitTech:0, serialHopper:0, plateau:0 },
        companyPicks: { startup:0, bigtech:0, agency:0, remote:0, nonprofit:0 },
        specPicks: { frontend:0, backend:0, devops:0, dataml:0, mobile:0 },
        trackPicks: { ic:0, mgmt:0 },
        totalPrestigeRuns: 0,
        currentWinStreak: 0, bestWinStreak: 0
    };

    // ---- Specializations ----
    var SPEC_TYPES = {
        frontend: {
            id: 'frontend', name: 'Frontend', icon: '\uD83C\uDFA8',
            desc: 'UI/UX obsessed. Components, accessibility, and pixel-perfect design.',
            salaryMult: 1.0,
            monthlyMods: { morale: 1 },
            alignedTasks: ['writeBlog', 'beVisible', 'sideProject', 'codeReview'],
            taskBonus: { reputation: 1 }
        },
        backend: {
            id: 'backend', name: 'Backend', icon: '\u2699\uFE0F',
            desc: 'APIs, databases, and distributed systems. Performance is everything.',
            salaryMult: 1.05,
            monthlyMods: { skill: 1 },
            alignedTasks: ['writeCode', 'refactorDebt', 'writeDesignDoc'],
            taskBonus: { skill: 1 }
        },
        devops: {
            id: 'devops', name: 'DevOps', icon: '\uD83D\uDD27',
            desc: 'CI/CD, infrastructure, and reliability. You keep the lights on.',
            salaryMult: 1.1,
            monthlyMods: { reputation: 1 },
            alignedTasks: ['refactorDebt', 'writeCode'],
            taskBonus: { skill: 1 }
        },
        dataml: {
            id: 'dataml', name: 'Data/ML', icon: '\uD83D\uDCCA',
            desc: 'Pipelines, models, and insights. Data is the new oil.',
            salaryMult: 1.15,
            monthlyMods: { skill: 1, morale: -1 },
            alignedTasks: ['study', 'writeDesignDoc', 'writeBlog'],
            taskBonus: { skill: 1 }
        },
        mobile: {
            id: 'mobile', name: 'Mobile', icon: '\uD83D\uDCF1',
            desc: 'iOS, Android, cross-platform. Ship to millions of pockets.',
            salaryMult: 1.0,
            monthlyMods: { managerRel: 1 },
            alignedTasks: ['sideProject', 'writeCode', 'writeBlog'],
            taskBonus: { reputation: 1 }
        }
    };

    var SPEC_LEVELS = [
        { name: 'Novice', minXP: 0 },
        { name: 'Competent', minXP: 25 },
        { name: 'Expert', minXP: 50 },
        { name: 'Master', minXP: 75 }
    ];

    function getSpecLevel(xp) {
        for (var i = SPEC_LEVELS.length - 1; i >= 0; i--) {
            if (xp >= SPEC_LEVELS[i].minXP) return SPEC_LEVELS[i];
        }
        return SPEC_LEVELS[0];
    }

    function getSpecLevelIndex(xp) {
        for (var i = SPEC_LEVELS.length - 1; i >= 0; i--) {
            if (xp >= SPEC_LEVELS[i].minXP) return i;
        }
        return 0;
    }

    // ---- Skill Trees ----
    var SKILL_TREES = {
        frontend: [
            { id: 'fe_css_wizard', name: 'CSS Wizard', icon: '\uD83D\uDD8C\uFE0F', desc: '+1 morale/month', tier: 1, cost: 10, effect: { type: 'monthly', stat: 'morale', amount: 1 } },
            { id: 'fe_component_king', name: 'Component King', icon: '\uD83E\uDDE9', desc: '+1 rep from aligned tasks', tier: 1, cost: 10, effect: { type: 'taskBonus', stat: 'reputation', amount: 1 } },
            { id: 'fe_design_system', name: 'Design System', icon: '\uD83C\uDFAF', desc: '+2 rep from features shipped', tier: 2, cost: 20, effect: { type: 'featureBonus', stat: 'reputation', amount: 2 } },
            { id: 'fe_a11y_champion', name: 'A11y Champion', icon: '\u267F', desc: '+2 rep/month', tier: 2, cost: 20, effect: { type: 'monthly', stat: 'reputation', amount: 2 } },
            { id: 'fe_ui_architect', name: 'UI Architect', icon: '\uD83C\uDFDB\uFE0F', desc: '+500 score', tier: 3, cost: 25, effect: { type: 'scoreMod', amount: 500 } },
            { id: 'fe_pixel_perfect', name: 'Pixel Perfect', icon: '\u2728', desc: 'Immune to imposter syndrome', tier: 3, cost: 25, effect: { type: 'passive', flag: 'imposterImmune' } }
        ],
        backend: [
            { id: 'be_query_optimizer', name: 'Query Optimizer', icon: '\u26A1', desc: '+1 skill/month', tier: 1, cost: 10, effect: { type: 'monthly', stat: 'skill', amount: 1 } },
            { id: 'be_api_craftsman', name: 'API Craftsman', icon: '\uD83D\uDD17', desc: '+1 rep from aligned tasks', tier: 1, cost: 10, effect: { type: 'taskBonus', stat: 'reputation', amount: 1 } },
            { id: 'be_system_designer', name: 'System Designer', icon: '\uD83D\uDCD0', desc: '+2 skill from design docs', tier: 2, cost: 20, effect: { type: 'contextBonus', context: 'writeDesignDoc', stat: 'skill', amount: 2 } },
            { id: 'be_scale_master', name: 'Scale Master', icon: '\uD83D\uDCC8', desc: '+5% salary', tier: 2, cost: 20, effect: { type: 'salaryMult', amount: 1.05 } },
            { id: 'be_distributed_guru', name: 'Distributed Guru', icon: '\uD83C\uDF10', desc: '+500 score', tier: 3, cost: 25, effect: { type: 'scoreMod', amount: 500 } },
            { id: 'be_zero_downtime', name: 'Zero Downtime', icon: '\uD83D\uDEE1\uFE0F', desc: 'Crunch morale penalty halved', tier: 3, cost: 25, effect: { type: 'passive', flag: 'crunchHalve' } }
        ],
        devops: [
            { id: 'do_pipeline_pro', name: 'Pipeline Pro', icon: '\uD83D\uDD04', desc: '+1 rep/month', tier: 1, cost: 10, effect: { type: 'monthly', stat: 'reputation', amount: 1 } },
            { id: 'do_container_expert', name: 'Container Expert', icon: '\uD83D\uDCE6', desc: '+1 skill from aligned tasks', tier: 1, cost: 10, effect: { type: 'taskBonus', stat: 'skill', amount: 1 } },
            { id: 'do_sre_mindset', name: 'SRE Mindset', icon: '\uD83D\uDD0D', desc: 'World event penalties halved', tier: 2, cost: 20, effect: { type: 'passive', flag: 'worldEventHalve' } },
            { id: 'do_iac_master', name: 'IaC Master', icon: '\uD83D\uDCDD', desc: '+2 rep from tech talks', tier: 2, cost: 20, effect: { type: 'contextBonus', context: 'techTalk', stat: 'reputation', amount: 2 } },
            { id: 'do_platform_architect', name: 'Platform Architect', icon: '\uD83C\uDFD7\uFE0F', desc: '+500 score', tier: 3, cost: 25, effect: { type: 'scoreMod', amount: 500 } },
            { id: 'do_chaos_engineer', name: 'Chaos Engineer', icon: '\uD83C\uDFB2', desc: 'Bad status durations -1 month', tier: 3, cost: 25, effect: { type: 'passive', flag: 'statusShorten' } }
        ],
        dataml: [
            { id: 'dm_data_wrangler', name: 'Data Wrangler', icon: '\uD83E\uDDF9', desc: '+1 skill/month', tier: 1, cost: 10, effect: { type: 'monthly', stat: 'skill', amount: 1 } },
            { id: 'dm_feature_engineer', name: 'Feature Engineer', icon: '\uD83D\uDD2C', desc: '+1 spec XP from study', tier: 1, cost: 10, effect: { type: 'passive', flag: 'studyXPBonus' } },
            { id: 'dm_ml_pipeline', name: 'ML Pipeline', icon: '\uD83D\uDD17', desc: '+2 rep from blog posts', tier: 2, cost: 20, effect: { type: 'contextBonus', context: 'writeBlog', stat: 'reputation', amount: 2 } },
            { id: 'dm_analytics_brain', name: 'Analytics Brain', icon: '\uD83E\uDDE0', desc: '+5% salary', tier: 2, cost: 20, effect: { type: 'salaryMult', amount: 1.05 } },
            { id: 'dm_ai_architect', name: 'AI Architect', icon: '\uD83E\uDD16', desc: '+500 score', tier: 3, cost: 25, effect: { type: 'scoreMod', amount: 500 } },
            { id: 'dm_research_lead', name: 'Research Lead', icon: '\uD83D\uDCDA', desc: '+2 spec XP from mentorships', tier: 3, cost: 25, effect: { type: 'passive', flag: 'mentorXPBonus' } }
        ],
        mobile: [
            { id: 'mo_native_expert', name: 'Native Expert', icon: '\uD83D\uDCF2', desc: '+1 rep/month', tier: 1, cost: 10, effect: { type: 'monthly', stat: 'reputation', amount: 1 } },
            { id: 'mo_cross_platform', name: 'Cross-Platform', icon: '\uD83D\uDD00', desc: '+1 morale from aligned tasks', tier: 1, cost: 10, effect: { type: 'taskBonus', stat: 'morale', amount: 1 } },
            { id: 'mo_app_store_hero', name: 'App Store Hero', icon: '\u2B50', desc: '+3 rep from side projects', tier: 2, cost: 20, effect: { type: 'contextBonus', context: 'sideProject', stat: 'reputation', amount: 3 } },
            { id: 'mo_offline_first', name: 'Offline First', icon: '\uD83D\uDCE1', desc: '+1 managerRel/month', tier: 2, cost: 20, effect: { type: 'monthly', stat: 'managerRel', amount: 1 } },
            { id: 'mo_mobile_architect', name: 'Mobile Architect', icon: '\uD83C\uDFDB\uFE0F', desc: '+500 score', tier: 3, cost: 25, effect: { type: 'scoreMod', amount: 500 } },
            { id: 'mo_launch_day', name: 'Launch Day', icon: '\uD83C\uDF89', desc: '+2 rep from features shipped', tier: 3, cost: 25, effect: { type: 'featureBonus', stat: 'reputation', amount: 2 } }
        ]
    };

    var SALARY_TABLE = {
        junior: 80000, mid: 120000, senior: 165000, staff: 210000,
        principal: 260000, techlead: 185000, engmanager: 200000, vpe: 280000
    };

    function getMonthlySalary(s) {
        var activeLevels = getActiveLevels(s);
        var levelId = activeLevels[s.levelIndex].id;
        var base = SALARY_TABLE[levelId] || 80000;
        var ct = COMPANY_TYPES[s.company] || COMPANY_TYPES.bigtech;
        var salaryMult = ct.salaryMult;
        // World event salary modifier
        if (s.meta.worldEvent) {
            var we = getWorldEvent(s.meta.worldEvent);
            if (we && we.companyMods[s.company]) {
                salaryMult *= we.companyMods[s.company].salaryMult;
            }
        }
        // Specialization salary modifier
        if (s.spec && SPEC_TYPES[s.spec]) {
            salaryMult *= SPEC_TYPES[s.spec].salaryMult;
            // Master bonus: +10% salary
            if (s.specXP >= 75) salaryMult *= 1.10;
        }
        // Perk salary multipliers
        if (s.meta && s.meta.perks) {
            var tree = SKILL_TREES[s.spec] || [];
            for (var pi = 0; pi < s.meta.perks.length; pi++) {
                for (var pj = 0; pj < tree.length; pj++) {
                    if (tree[pj].id === s.meta.perks[pi] && tree[pj].effect.type === 'salaryMult') {
                        salaryMult *= tree[pj].effect.amount;
                    }
                }
            }
        }
        return Math.round((base * salaryMult) / 12);
    }

    function formatSalary(annual) {
        return '$' + Math.round(annual / 1000) + 'k';
    }

    var MONTHLY_TASKS = [
        {
            id: 'writeCode',
            name: 'Write code',
            hint: '+Skill, chance of PR',
            minLevel: 0,
            apply: function (s) {
                var gain = randInt(2, 5);
                addStat(s, 'skill', gain);
                var r = { lines: ['+' + gain + ' Skill'] };
                if (rand() < 0.5) {
                    s.items.prs++;
                    r.lines.push('+1 PR Merged');
                }
                return r;
            }
        },
        {
            id: 'study',
            name: 'Study / learn new tech',
            hint: '+Skill (big), slight morale cost',
            minLevel: 0,
            apply: function (s) {
                var gain = randInt(4, 8);
                addStat(s, 'skill', gain);
                addStat(s, 'morale', -2);
                return { lines: ['+' + gain + ' Skill', '-2 Morale'] };
            }
        },
        {
            id: 'codeReview',
            name: 'Do code reviews',
            hint: '+Reputation, +Skill small',
            minLevel: 0,
            apply: function (s) {
                var sk = randInt(1, 3);
                var rep = randInt(2, 4);
                addStat(s, 'skill', sk);
                addStat(s, 'reputation', rep);
                return { lines: ['+' + sk + ' Skill', '+' + rep + ' Reputation'] };
            }
        },
        {
            id: 'beVisible',
            name: 'Be visible / network',
            hint: '+Reputation, +Manager Rel',
            minLevel: 0,
            apply: function (s) {
                var rep = randInt(3, 6);
                var mgr = randInt(2, 4);
                addStat(s, 'reputation', rep);
                addStat(s, 'managerRel', mgr);
                return { lines: ['+' + rep + ' Reputation', '+' + mgr + ' Manager Rel'] };
            }
        },
        {
            id: 'sideProject',
            name: 'Side project / OSS contribution',
            hint: '+Skill, +Reputation small, chance of blog/talk',
            minLevel: 0,
            apply: function (s) {
                var sk = randInt(2, 4);
                var rep = randInt(1, 3);
                addStat(s, 'skill', sk);
                addStat(s, 'reputation', rep);
                s.items.prs++;
                var r = { lines: ['+' + sk + ' Skill', '+' + rep + ' Reputation', '+1 PR Merged'] };
                s.meta.ossContributions = (s.meta.ossContributions || 0) + 1;
                return r;
            }
        },
        {
            id: 'writeBlog',
            name: 'Write a blog post',
            hint: '+Reputation, takes effort',
            minLevel: 0,
            apply: function (s) {
                var rep = randInt(4, 7);
                addStat(s, 'reputation', rep);
                addStat(s, 'morale', -1);
                s.items.blogPosts++;
                return { lines: ['+' + rep + ' Reputation', '-1 Morale', '+1 Blog Post'] };
            }
        },
        {
            id: 'takePTO',
            name: 'Take PTO / rest',
            hint: '+Morale (big), clears Burnout',
            minLevel: 0,
            apply: function (s) {
                var gain = randInt(8, 15);
                addStat(s, 'morale', gain);
                if (s.statuses.burnoutStatus) {
                    delete s.statuses.burnoutStatus;
                    return { lines: ['+' + gain + ' Morale', 'Burnout cleared!'] };
                }
                return { lines: ['+' + gain + ' Morale'] };
            }
        },
        {
            id: 'slackOff',
            name: 'Slack off',
            hint: '+Morale small, risk of reputation loss',
            minLevel: 0,
            apply: function (s) {
                addStat(s, 'morale', randInt(2, 5));
                var r = { lines: ['+Morale (small)'] };
                if (rand() < 0.3) {
                    var loss = randInt(2, 4);
                    addStat(s, 'reputation', -loss);
                    addStat(s, 'managerRel', -loss);
                    r.lines.push('-' + loss + ' Reputation (caught slacking!)');
                    r.lines.push('-' + loss + ' Manager Rel');
                }
                return r;
            }
        },
        {
            id: 'writeDesignDoc',
            name: 'Write a design doc',
            hint: '+Skill, +Reputation, +Design Doc item',
            minLevel: 1,
            apply: function (s) {
                var sk = randInt(2, 4);
                var rep = randInt(3, 5);
                addStat(s, 'skill', sk);
                addStat(s, 'reputation', rep);
                s.items.designDocs++;
                return { lines: ['+' + sk + ' Skill', '+' + rep + ' Reputation', '+1 Design Doc'] };
            }
        },
        {
            id: 'mentorJunior',
            name: 'Mentor a junior dev',
            hint: '+Reputation (big), +Manager Rel',
            minLevel: 2,
            apply: function (s) {
                var rep = randInt(5, 8);
                var mgr = randInt(3, 5);
                addStat(s, 'reputation', rep);
                addStat(s, 'managerRel', mgr);
                s.items.mentorships++;
                return { lines: ['+' + rep + ' Reputation', '+' + mgr + ' Manager Rel', '+1 Mentorship'] };
            }
        },
        {
            id: 'refactorDebt',
            name: 'Refactor / pay tech debt',
            hint: '+Skill, reduces tech debt',
            minLevel: 1,
            apply: function (s) {
                var sk = randInt(3, 6);
                addStat(s, 'skill', sk);
                var debtReduced = Math.min(s.meta.techDebt || 0, 2);
                s.meta.techDebt = Math.max(0, (s.meta.techDebt || 0) - debtReduced);
                var r = { lines: ['+' + sk + ' Skill'] };
                if (debtReduced > 0) r.lines.push('Tech debt reduced by ' + debtReduced);
                else r.lines.push('Codebase is clean. Good refactoring practice.');
                return r;
            }
        },
        {
            id: 'bePolitical',
            name: 'Attend meetings / be political',
            hint: '+Manager Rel, -Morale, chance of +Rep',
            minLevel: 1,
            apply: function (s) {
                var mgr = randInt(3, 6);
                addStat(s, 'managerRel', mgr);
                addStat(s, 'morale', -2);
                var r = { lines: ['+' + mgr + ' Manager Rel', '-2 Morale'] };
                if (rand() < 0.4) {
                    var rep = randInt(2, 4);
                    addStat(s, 'reputation', rep);
                    r.lines.push('+' + rep + ' Reputation (good visibility)');
                }
                return r;
            }
        },
        {
            id: 'prepInterviews',
            name: 'Prep for interviews',
            hint: '+Morale, +Skill, risk of discovery',
            minLevel: 0,
            apply: function (s) {
                var sk = randInt(2, 4);
                addStat(s, 'skill', sk);
                addStat(s, 'morale', 3);
                addStatus(s, 'jobHunting', 3);
                var r = { lines: ['+' + sk + ' Skill', '+3 Morale', 'Status: Job Hunting (3mo)'] };
                if (rand() < 0.15) {
                    addStat(s, 'managerRel', -5);
                    r.lines.push('-5 Manager Rel (your manager heard a rumor!)');
                }
                return r;
            }
        },
        {
            id: 'lookForNewJob',
            name: 'Look for a new job',
            hint: '+Morale, triggers company switch offers',
            minLevel: 1,
            apply: function (s) {
                addStat(s, 'morale', 3);
                s.meta.pendingJobSwitch = true;
                return { lines: ['+3 Morale', 'You start exploring other opportunities...'] };
            }
        }
    ];

    var COMPANY_TASKS = [
        {
            id: 'sprintDemo',
            name: 'Demo to investors',
            hint: '+Rep, -Morale, chance of feature',
            minLevel: 0,
            company: 'startup',
            apply: function (s) {
                var rep = randInt(3, 6);
                addStat(s, 'reputation', rep);
                addStat(s, 'morale', -2);
                var r = { lines: ['+' + rep + ' Reputation', '-2 Morale'] };
                if (rand() < 0.4) {
                    s.items.features++;
                    r.lines.push('+1 Feature Shipped (investor loved it!)');
                }
                return r;
            }
        },
        {
            id: 'writePromoPacket',
            name: 'Write promo packet',
            hint: '+Rep (big), +Manager Rel, -Morale',
            minLevel: 1,
            company: 'bigtech',
            apply: function (s) {
                var rep = randInt(5, 8);
                var mgr = randInt(3, 5);
                addStat(s, 'reputation', rep);
                addStat(s, 'managerRel', mgr);
                addStat(s, 'morale', -3);
                return { lines: ['+' + rep + ' Reputation', '+' + mgr + ' Manager Rel', '-3 Morale', 'Self-promotion doc submitted.'] };
            }
        },
        {
            id: 'clientHandoff',
            name: 'Client project handoff',
            hint: '+Feature, +Rep, chance of skill boost',
            minLevel: 0,
            company: 'agency',
            apply: function (s) {
                var rep = randInt(3, 5);
                addStat(s, 'reputation', rep);
                s.items.features++;
                var r = { lines: ['+' + rep + ' Reputation', '+1 Feature Shipped'] };
                if (rand() < 0.3) {
                    var sk = randInt(3, 5);
                    addStat(s, 'skill', sk);
                    r.lines.push('+' + sk + ' Skill (new stack learned!)');
                }
                return r;
            }
        },
        {
            id: 'writeDocumentation',
            name: 'Write async documentation',
            hint: '+Rep, +Skill, +Morale, +Design Doc',
            minLevel: 0,
            company: 'remote',
            apply: function (s) {
                var rep = randInt(3, 5);
                var sk = randInt(2, 4);
                addStat(s, 'reputation', rep);
                addStat(s, 'skill', sk);
                addStat(s, 'morale', 2);
                s.items.designDocs++;
                return { lines: ['+' + rep + ' Reputation', '+' + sk + ' Skill', '+2 Morale', '+1 Design Doc'] };
            }
        },
        {
            id: 'communityOutreach',
            name: 'Community outreach / impact report',
            hint: '+Morale (big), +Rep',
            minLevel: 0,
            company: 'nonprofit',
            apply: function (s) {
                var rep = randInt(3, 5);
                addStat(s, 'reputation', rep);
                addStat(s, 'morale', randInt(5, 8));
                return { lines: ['+' + rep + ' Reputation', '+Morale (big)', 'Your work is making a real difference.'] };
            }
        }
    ];

    // ---- Specialization Tasks ----
    var SPEC_TASKS = [
        // Frontend
        {
            id: 'buildComponentLib', name: 'Build component library',
            hint: '+Skill, +Rep, +PR, +3 Spec XP',
            minLevel: 0, spec: 'frontend', specLevel: 0,
            apply: function (s) {
                addStat(s, 'skill', 3); addStat(s, 'reputation', 3); s.items.prs++;
                addSpecXP(s, 3);
                return { lines: ['+3 Skill', '+3 Reputation', '+1 PR Merged', '+3 Spec XP'] };
            }
        },
        {
            id: 'accessibilityAudit', name: 'Accessibility audit',
            hint: '+Skill, +Rep (big), +Feature, +3 Spec XP — requires Competent',
            minLevel: 0, spec: 'frontend', specLevel: 1,
            apply: function (s) {
                addStat(s, 'skill', 2); addStat(s, 'reputation', 4); s.items.features++;
                addSpecXP(s, 3);
                return { lines: ['+2 Skill', '+4 Reputation', '+1 Feature Shipped', '+3 Spec XP'] };
            }
        },
        // Backend
        {
            id: 'optimizeQueries', name: 'Optimize database queries',
            hint: '+Skill (big), +Rep, +PR, +3 Spec XP',
            minLevel: 0, spec: 'backend', specLevel: 0,
            apply: function (s) {
                addStat(s, 'skill', 4); addStat(s, 'reputation', 2); s.items.prs++;
                addSpecXP(s, 3);
                return { lines: ['+4 Skill', '+2 Reputation', '+1 PR Merged', '+3 Spec XP'] };
            }
        },
        {
            id: 'designMicroservice', name: 'Design microservice architecture',
            hint: '+Skill (big), +Rep, +Design Doc, +3 Spec XP — requires Competent',
            minLevel: 1, spec: 'backend', specLevel: 1,
            apply: function (s) {
                addStat(s, 'skill', 4); addStat(s, 'reputation', 3); s.items.designDocs++;
                addSpecXP(s, 3);
                return { lines: ['+4 Skill', '+3 Reputation', '+1 Design Doc', '+3 Spec XP'] };
            }
        },
        // DevOps
        {
            id: 'setupCICD', name: 'Set up CI/CD pipeline',
            hint: '+Skill, +Rep, +PR, +3 Spec XP',
            minLevel: 0, spec: 'devops', specLevel: 0,
            apply: function (s) {
                addStat(s, 'skill', 3); addStat(s, 'reputation', 3); s.items.prs++;
                addSpecXP(s, 3);
                return { lines: ['+3 Skill', '+3 Reputation', '+1 PR Merged', '+3 Spec XP'] };
            }
        },
        {
            id: 'automateInfra', name: 'Automate infrastructure',
            hint: '+Skill (big), +Rep, +Design Doc, +3 Spec XP — requires Competent',
            minLevel: 1, spec: 'devops', specLevel: 1,
            apply: function (s) {
                addStat(s, 'skill', 4); addStat(s, 'reputation', 2); s.items.designDocs++;
                addSpecXP(s, 3);
                return { lines: ['+4 Skill', '+2 Reputation', '+1 Design Doc', '+3 Spec XP'] };
            }
        },
        // Data/ML
        {
            id: 'buildDataPipeline', name: 'Build data pipeline',
            hint: '+Skill, +Rep, +PR, +3 Spec XP',
            minLevel: 0, spec: 'dataml', specLevel: 0,
            apply: function (s) {
                addStat(s, 'skill', 3); addStat(s, 'reputation', 3); s.items.prs++;
                addSpecXP(s, 3);
                return { lines: ['+3 Skill', '+3 Reputation', '+1 PR Merged', '+3 Spec XP'] };
            }
        },
        {
            id: 'trainMLModel', name: 'Train ML model',
            hint: '+Skill (big), +Rep, -Morale, +3 Spec XP — requires Competent',
            minLevel: 0, spec: 'dataml', specLevel: 1,
            apply: function (s) {
                addStat(s, 'skill', 5); addStat(s, 'reputation', 2); addStat(s, 'morale', -1);
                addSpecXP(s, 3);
                return { lines: ['+5 Skill', '+2 Reputation', '-1 Morale', '+3 Spec XP'] };
            }
        },
        // Mobile
        {
            id: 'shipAppUpdate', name: 'Ship app update',
            hint: '+Skill, +Rep, +Feature, +3 Spec XP',
            minLevel: 0, spec: 'mobile', specLevel: 0,
            apply: function (s) {
                addStat(s, 'skill', 2); addStat(s, 'reputation', 3); s.items.features++;
                addSpecXP(s, 3);
                return { lines: ['+2 Skill', '+3 Reputation', '+1 Feature Shipped', '+3 Spec XP'] };
            }
        },
        {
            id: 'appStoreOptimize', name: 'Handle app store optimization',
            hint: '+Skill, +Rep (big), +Morale, +3 Spec XP — requires Competent',
            minLevel: 0, spec: 'mobile', specLevel: 1,
            apply: function (s) {
                addStat(s, 'skill', 2); addStat(s, 'reputation', 4); addStat(s, 'morale', 1);
                addSpecXP(s, 3);
                return { lines: ['+2 Skill', '+4 Reputation', '+1 Morale', '+3 Spec XP'] };
            }
        }
    ];

    // ==================== SECTION 3: EVENT DATA ====================

    var RANDOM_EVENTS = [
        {
            id: 'productionOutage',
            name: 'Production Outage!',
            prob: 0.08,
            text: 'Alert! The production servers are on fire. PagerDuty is going off non-stop. The team lead is looking around for someone to jump on it.',
            choices: [
                {
                    label: 'Jump on the incident',
                    hint: 'Risky but visible',
                    apply: function (s) {
                        if (rand() < 0.6) {
                            addStat(s, 'skill', 4);
                            addStat(s, 'reputation', 6);
                            addStat(s, 'morale', -3);
                            s.items.hotfixes++;
                            return { lines: ['You fixed it! The team is grateful.', '+4 Skill', '+6 Reputation', '-3 Morale', '+1 Hotfix'] };
                        }
                        addStat(s, 'skill', 2);
                        addStat(s, 'morale', -5);
                        addStat(s, 'reputation', -2);
                        return { lines: ['You tried but it spiraled. Another engineer had to step in.', '+2 Skill', '-5 Morale', '-2 Reputation'] };
                    }
                },
                {
                    label: 'Stay quiet and hope someone else handles it',
                    hint: 'Safe but invisible',
                    apply: function (s) {
                        addStat(s, 'reputation', -2);
                        return { lines: ['Someone else fixed it. Your manager noticed you didn\'t volunteer.', '-2 Reputation'] };
                    }
                }
            ]
        },
        {
            id: 'sprintOvercommit',
            name: 'Sprint Overcommit',
            prob: 0.10,
            text: 'The PM just committed the team to delivering 3x the normal workload this sprint. "We promised the stakeholders," they say apologetically.',
            choices: [
                {
                    label: 'Push back in the standup',
                    hint: 'Reputation risk but sets boundaries',
                    apply: function (s) {
                        if (s.vars.reputation >= 25) {
                            addStat(s, 'reputation', 3);
                            addStat(s, 'morale', 2);
                            return { lines: ['Your reputation gives weight to your pushback. Sprint scope is reduced.', '+3 Reputation', '+2 Morale'] };
                        }
                        addStat(s, 'reputation', -2);
                        addStat(s, 'managerRel', -3);
                        return { lines: ['You\'re overruled. "Let\'s just try our best," the PM says.', '-2 Reputation', '-3 Manager Rel'] };
                    }
                },
                {
                    label: 'Grind through it',
                    hint: 'Morale hit but shows commitment',
                    apply: function (s) {
                        addStat(s, 'morale', -6);
                        addStat(s, 'skill', 2);
                        s.items.prs += 2;
                        addStat(s, 'managerRel', 3);
                        return { lines: ['You power through late nights. Everything ships, barely.', '-6 Morale', '+2 Skill', '+2 PRs', '+3 Manager Rel'] };
                    }
                },
                {
                    label: 'Quietly cut corners',
                    hint: 'Ship fast but tech debt',
                    apply: function (s) {
                        s.items.prs += 2;
                        addStat(s, 'morale', -2);
                        s.meta.techDebt = (s.meta.techDebt || 0) + 2;
                        return { lines: ['You skip tests and reviews. It ships, but the code is fragile.', '+2 PRs', '-2 Morale', 'Tech debt accumulates...'] };
                    }
                }
            ]
        },
        {
            id: 'recruiterDM',
            name: 'Recruiter Slides Into Your DMs',
            prob: 0.06,
            text: '"Hi! I found your profile and think you\'d be a great fit for an exciting opportunity at a Series B startup!" Your LinkedIn is blowing up.',
            choices: [
                {
                    label: 'Explore the opportunity',
                    hint: 'Morale boost, possible leverage',
                    apply: function (s) {
                        addStat(s, 'morale', 4);
                        if (rand() < 0.3) {
                            addStat(s, 'managerRel', -3);
                            return { lines: ['Your manager finds out you\'re interviewing. Awkward.', '+4 Morale', '-3 Manager Rel'] };
                        }
                        return { lines: ['The interview process is flattering. You feel valued.', '+4 Morale'] };
                    }
                },
                {
                    label: 'Ignore it',
                    hint: 'No risk, no reward',
                    apply: function (s) {
                        return { lines: ['You archive the message and get back to work.'] };
                    }
                }
            ]
        },
        {
            id: 'coworkerQuits',
            name: 'Coworker Quits',
            prob: 0.05,
            text: 'Your closest work friend just put in their two weeks. "I got an offer I couldn\'t refuse," they say. The team feels the loss.',
            choices: [
                {
                    label: 'Step up and take on their work',
                    hint: 'More responsibility, more stress',
                    apply: function (s) {
                        addStat(s, 'skill', 3);
                        addStat(s, 'reputation', 4);
                        addStat(s, 'morale', -5);
                        addStat(s, 'managerRel', 3);
                        return { lines: ['You absorb their responsibilities. Management is impressed.', '+3 Skill', '+4 Reputation', '-5 Morale', '+3 Manager Rel'] };
                    }
                },
                {
                    label: 'Keep your scope the same',
                    hint: 'Protect yourself',
                    apply: function (s) {
                        addStat(s, 'morale', -2);
                        return { lines: ['You miss your friend. The team is stretched thin.', '-2 Morale'] };
                    }
                }
            ]
        },
        {
            id: 'conferenceInvite',
            name: 'Conference Speaking Invite',
            prob: 0.04,
            condition: function (s) { return s.vars.reputation >= 30; },
            text: 'A tech conference noticed your blog posts and OSS contributions. They want you to give a talk! This could be huge for your career.',
            choices: [
                {
                    label: 'Accept and prepare a talk',
                    hint: 'Big reputation boost, time investment',
                    apply: function (s) {
                        addStat(s, 'reputation', 10);
                        addStat(s, 'morale', 3);
                        addStat(s, 'skill', 2);
                        s.items.techTalks++;
                        s.items.conferencetalks = (s.items.conferencetalks || 0) + 1;
                        return { lines: ['Your talk goes great! People are coming up to chat afterwards.', '+10 Reputation', '+3 Morale', '+2 Skill', '+1 Tech Talk', '+1 Conf. Talk'] };
                    }
                },
                {
                    label: 'Decline — too busy',
                    hint: 'No pressure',
                    apply: function (s) {
                        return { lines: ['You politely decline. Maybe next time.'] };
                    }
                }
            ]
        },
        {
            id: 'techDebtExplosion',
            name: 'Tech Debt Explosion',
            prob: 0.06,
            text: 'Remember those corners someone cut last quarter? The whole module is now unmaintainable. Builds are failing, and nobody wants to touch it.',
            choices: [
                {
                    label: 'Champion a refactor sprint',
                    hint: 'Skill + reputation but morale cost',
                    apply: function (s) {
                        addStat(s, 'skill', 5);
                        addStat(s, 'reputation', 4);
                        addStat(s, 'morale', -4);
                        s.meta.techDebt = Math.max(0, (s.meta.techDebt || 0) - 3);
                        return { lines: ['You lead the cleanup effort. The codebase improves significantly.', '+5 Skill', '+4 Reputation', '-4 Morale'] };
                    }
                },
                {
                    label: 'Patch it and move on',
                    hint: 'Quick fix',
                    apply: function (s) {
                        addStat(s, 'skill', 1);
                        s.items.hotfixes++;
                        s.meta.techDebt = (s.meta.techDebt || 0) + 1;
                        return { lines: ['You slap a band-aid on it. It\'ll hold... for now.', '+1 Skill', '+1 Hotfix'] };
                    }
                }
            ]
        },
        {
            id: 'companyOffsite',
            name: 'Company Offsite',
            prob: 0.05,
            text: 'The team is going on a 3-day offsite. There will be team-building activities, strategy sessions, and an open bar.',
            choices: [
                {
                    label: 'Network aggressively',
                    hint: 'Reputation + Manager Rel',
                    apply: function (s) {
                        addStat(s, 'reputation', 5);
                        addStat(s, 'managerRel', 5);
                        addStat(s, 'morale', 3);
                        return { lines: ['You schmooze with leadership. They remember your name now.', '+5 Reputation', '+5 Manager Rel', '+3 Morale'] };
                    }
                },
                {
                    label: 'Hang with your immediate team',
                    hint: 'Morale boost, chill',
                    apply: function (s) {
                        addStat(s, 'morale', 6);
                        addStat(s, 'managerRel', 2);
                        return { lines: ['Great bonding time. You feel recharged and closer to your team.', '+6 Morale', '+2 Manager Rel'] };
                    }
                },
                {
                    label: 'Skip it — "I have a dentist appointment"',
                    hint: 'Save energy, miss out',
                    apply: function (s) {
                        addStat(s, 'reputation', -3);
                        addStat(s, 'managerRel', -3);
                        addStat(s, 'morale', 2);
                        return { lines: ['Nobody buys the dentist excuse. Your absence is noted.', '-3 Reputation', '-3 Manager Rel', '+2 Morale'] };
                    }
                }
            ]
        },
        {
            id: 'internAssigned',
            name: 'Intern Assigned to You',
            prob: 0.04,
            condition: function (s) { return s.levelIndex >= 1; },
            text: 'Congrats! You\'ve been assigned an intern for the summer. They\'re eager but have never used Git. Your manager says "it\'ll be a great growth opportunity for you."',
            choices: [
                {
                    label: 'Invest in mentoring them',
                    hint: 'Time-consuming but rewarding',
                    apply: function (s) {
                        addStat(s, 'reputation', 5);
                        addStat(s, 'managerRel', 4);
                        addStat(s, 'morale', -2);
                        addStat(s, 'skill', 2);
                        s.items.mentorships++;
                        return { lines: ['The intern thrives. Your mentoring skills are recognized.', '+5 Reputation', '+4 Manager Rel', '-2 Morale', '+2 Skill', '+1 Mentorship'] };
                    }
                },
                {
                    label: 'Give them busy work and focus on your stuff',
                    hint: 'Preserve your time',
                    apply: function (s) {
                        addStat(s, 'reputation', -2);
                        addStat(s, 'managerRel', -2);
                        return { lines: ['The intern is bored and learns nothing. HR is not impressed.', '-2 Reputation', '-2 Manager Rel'] };
                    }
                }
            ]
        },
        {
            id: 'newFrameworkHype',
            name: 'New Framework Hype',
            prob: 0.05,
            text: 'Everyone on Twitter is raving about a shiny new framework. Your tech lead is "evaluating" it. Half the team wants to rewrite everything.',
            choices: [
                {
                    label: 'Dive in and become the team expert',
                    hint: 'Skill + Flow State',
                    apply: function (s) {
                        addStat(s, 'skill', 5);
                        addStat(s, 'morale', 2);
                        addStatus(s, 'flowState', randInt(1, 3));
                        return { lines: ['You go deep. The new paradigm clicks and you\'re on fire.', '+5 Skill', '+2 Morale', 'Gained: Flow State'] };
                    }
                },
                {
                    label: 'Wait and see',
                    hint: 'No risk',
                    apply: function (s) {
                        return { lines: ['You wisely wait. Three months later the hype dies down.'] };
                    }
                },
                {
                    label: 'Write a "hot take" blog post about it',
                    hint: 'Reputation gamble',
                    apply: function (s) {
                        if (rand() < 0.5) {
                            addStat(s, 'reputation', 6);
                            s.items.blogPosts++;
                            return { lines: ['Your take goes semi-viral! Great engagement.', '+6 Reputation', '+1 Blog Post'] };
                        }
                        addStat(s, 'reputation', -3);
                        s.items.blogPosts++;
                        return { lines: ['The framework\'s creator quote-tweets you with a clown emoji.', '-3 Reputation', '+1 Blog Post'] };
                    }
                }
            ]
        },
        {
            id: 'ossGoesViral',
            name: 'Your OSS Project Goes Viral!',
            prob: 0.03,
            once: true,
            condition: function (s) { return (s.meta.ossContributions || 0) >= 3; },
            text: 'Your open-source side project just hit the front page of Hacker News! Stars are flooding in. Your DMs are full of "great work!" messages.',
            choices: [
                {
                    label: 'Ride the wave — maintain and promote it',
                    hint: 'Huge reputation, ongoing commitment',
                    apply: function (s) {
                        addStat(s, 'reputation', 12);
                        addStat(s, 'morale', 5);
                        addStat(s, 'skill', 3);
                        return { lines: ['You become a known figure in the community!', '+12 Reputation', '+5 Morale', '+3 Skill'] };
                    }
                },
                {
                    label: 'Add "not actively maintained" to the README',
                    hint: 'Realistic',
                    apply: function (s) {
                        addStat(s, 'reputation', 5);
                        addStat(s, 'morale', 2);
                        return { lines: ['You set expectations. Still a nice feather in your cap.', '+5 Reputation', '+2 Morale'] };
                    }
                }
            ]
        },
        {
            id: 'slackOutage',
            name: 'Slack is Down!',
            prob: 0.05,
            text: 'Slack is experiencing a global outage. The office is eerily quiet. People are actually... talking to each other?',
            choices: [
                {
                    label: 'Enjoy the deep focus time',
                    hint: 'Skill + Morale',
                    apply: function (s) {
                        addStat(s, 'skill', 4);
                        addStat(s, 'morale', 3);
                        s.items.prs++;
                        return { lines: ['Most productive day in months!', '+4 Skill', '+3 Morale', '+1 PR Merged'] };
                    }
                },
                {
                    label: 'Panic and refresh the status page',
                    hint: 'Relatable but wasteful',
                    apply: function (s) {
                        addStat(s, 'morale', -1);
                        return { lines: ['You spent 2 hours refreshing status.slack.com.', '-1 Morale'] };
                    }
                }
            ]
        },
        {
            id: 'onCallRotation',
            name: 'On-Call Rotation',
            prob: 0.08,
            text: 'It\'s your turn on the on-call rotation. You get the pager. Sleep well... if you can.',
            choices: [
                {
                    label: 'Accept and be diligent',
                    hint: 'Status effect, shows reliability',
                    apply: function (s) {
                        addStatus(s, 'onCall', 1);
                        addStat(s, 'managerRel', 3);
                        addStat(s, 'skill', 2);
                        return { lines: ['You take the pager. Your manager appreciates it.', 'Status: On-Call (1 month)', '+3 Manager Rel', '+2 Skill'] };
                    }
                },
                {
                    label: 'Try to swap with someone',
                    hint: 'Might work, might not',
                    apply: function (s) {
                        if (rand() < 0.4) {
                            return { lines: ['A teammate agrees to swap. You owe them one.'] };
                        }
                        addStatus(s, 'onCall', 1);
                        addStat(s, 'managerRel', -2);
                        return { lines: ['Nobody bites. You\'re stuck with it, and your manager noticed you tried to bail.', 'Status: On-Call (1 month)', '-2 Manager Rel'] };
                    }
                }
            ]
        },
        {
            id: 'badDeploy',
            name: 'Bad Deploy on a Friday',
            prob: 0.06,
            text: 'Someone (maybe you?) pushed to production at 4:55 PM on a Friday. Monitoring dashboards are lighting up red.',
            choices: [
                {
                    label: 'Roll it back immediately',
                    hint: 'Quick fix, slight reputation hit',
                    apply: function (s) {
                        addStat(s, 'skill', 2);
                        addStat(s, 'morale', -2);
                        s.items.hotfixes++;
                        return { lines: ['Quick rollback. Crisis averted. Everyone goes home.', '+2 Skill', '-2 Morale', '+1 Hotfix'] };
                    }
                },
                {
                    label: 'Try to forward-fix it',
                    hint: 'Heroic or disastrous',
                    apply: function (s) {
                        if (rand() < 0.5) {
                            addStat(s, 'skill', 5);
                            addStat(s, 'reputation', 5);
                            addStat(s, 'morale', -4);
                            s.items.hotfixes++;
                            return { lines: ['You fix it forward! Heroic Friday night save.', '+5 Skill', '+5 Reputation', '-4 Morale', '+1 Hotfix'] };
                        }
                        addStat(s, 'morale', -8);
                        addStat(s, 'reputation', -3);
                        addStatus(s, 'crunchMode', 1);
                        return { lines: ['It gets worse. You\'re here until 2 AM.', '-8 Morale', '-3 Reputation', 'Status: Crunch Mode'] };
                    }
                }
            ]
        },
        {
            id: 'teamReorg',
            name: 'Team Reorg',
            prob: 0.04,
            text: 'Management is "restructuring for efficiency." Your team is being split up. New manager, new teammates, new priorities.',
            choices: [
                {
                    label: 'Embrace the change',
                    hint: 'Fresh start, new connections',
                    apply: function (s) {
                        addStat(s, 'morale', -3);
                        addStat(s, 'reputation', 2);
                        s.vars.managerRel = 50;
                        if (s.statuses.badManager) delete s.statuses.badManager;
                        return { lines: ['New team, who dis? Manager Rel reset to 50.', '-3 Morale', '+2 Reputation', 'Manager Rel reset'] };
                    }
                },
                {
                    label: 'Resist and try to stay on your team',
                    hint: 'Might backfire',
                    apply: function (s) {
                        if (rand() < 0.3) {
                            addStat(s, 'morale', 3);
                            return { lines: ['You make your case and stay put. Stability preserved.', '+3 Morale'] };
                        }
                        addStat(s, 'morale', -5);
                        addStat(s, 'managerRel', -5);
                        return { lines: ['You\'re moved anyway, and your new manager knows you fought it.', '-5 Morale', '-5 Manager Rel'] };
                    }
                }
            ]
        },
        {
            id: 'salaryBenchmark',
            name: 'Salary Benchmark Leak',
            prob: 0.03,
            condition: function (s) { return s.month % 12 >= 10; },
            text: 'Someone shared a spreadsheet with salary data. You discover you\'re paid 20% below market rate for your level.',
            choices: [
                {
                    label: 'Negotiate a raise with your manager',
                    hint: 'Depends on relationship',
                    apply: function (s) {
                        if (s.vars.managerRel >= 60 && s.vars.reputation >= 30) {
                            addStat(s, 'morale', 8);
                            return { lines: ['Your manager advocates for you. Raise approved!', '+8 Morale'] };
                        }
                        addStat(s, 'morale', -3);
                        addStat(s, 'managerRel', -3);
                        return { lines: ['"The budget is tight this quarter." Empty promises.', '-3 Morale', '-3 Manager Rel'] };
                    }
                },
                {
                    label: 'Start interviewing elsewhere',
                    hint: 'Morale boost from options',
                    apply: function (s) {
                        addStat(s, 'morale', 5);
                        return { lines: ['Having options feels empowering.', '+5 Morale'] };
                    }
                },
                {
                    label: 'Ignore it and keep grinding',
                    hint: 'Morale hit',
                    apply: function (s) {
                        addStat(s, 'morale', -4);
                        return { lines: ['The knowledge gnaws at you. Hard to stay motivated.', '-4 Morale'] };
                    }
                }
            ]
        },
        {
            id: 'layoffs',
            name: 'Layoffs Announced',
            prob: 0.05,
            text: 'The CEO sends a company-wide email: "Difficult decisions... restructuring for efficiency..." Half the Slack channels go silent.',
            choices: [
                {
                    label: 'Step up and fill the gaps',
                    hint: 'More work, more visibility',
                    apply: function (s) {
                        addStat(s, 'morale', -8);
                        addStat(s, 'reputation', 6);
                        addStat(s, 'skill', 3);
                        addStat(s, 'managerRel', 4);
                        return { lines: ['You absorb two roles. Exhausting but management notices.', '-8 Morale', '+6 Reputation', '+3 Skill', '+4 Manager Rel'] };
                    }
                },
                {
                    label: 'Keep your head down',
                    hint: 'Survive mode',
                    apply: function (s) {
                        addStat(s, 'morale', -5);
                        return { lines: ['You watch friends pack their desks. Survivor guilt hits hard.', '-5 Morale'] };
                    }
                },
                {
                    label: 'Start looking elsewhere',
                    hint: 'Maybe it\'s time',
                    apply: function (s) {
                        addStat(s, 'morale', -3);
                        addStatus(s, 'jobHunting', 3);
                        return { lines: ['You quietly update your resume. Just in case.', '-3 Morale', 'Status: Job Hunting (3mo)'] };
                    }
                }
            ]
        },
        {
            id: 'companyAcquisition',
            name: 'Company Acquired!',
            prob: 0.03,
            once: true,
            text: 'Breaking news: your company is being acquired by BigCorp. "Nothing will change," the CEO says. Everything will change.',
            choices: [
                {
                    label: 'Embrace the new regime',
                    hint: 'Adapt and survive',
                    apply: function (s) {
                        s.vars.managerRel = 40;
                        addStat(s, 'morale', -5);
                        addStat(s, 'reputation', -3);
                        return { lines: ['New org chart, new processes, new everything.', 'Manager Rel reset to 40', '-5 Morale', '-3 Reputation'] };
                    }
                },
                {
                    label: 'Ride out the golden handcuffs',
                    hint: 'Stay for the retention package',
                    apply: function (s) {
                        addStat(s, 'morale', -3);
                        addStat(s, 'skill', 2);
                        return { lines: ['The retention bonus is nice. The bureaucracy is not.', '-3 Morale', '+2 Skill'] };
                    }
                }
            ]
        },
        {
            id: 'newManager',
            name: 'New Manager',
            prob: 0.04,
            text: 'Your manager just left for a "new opportunity." A stranger from another team is now your boss.',
            choices: [
                {
                    label: 'Set up a 1:1 and build rapport',
                    hint: 'Invest in the relationship',
                    apply: function (s) {
                        s.vars.managerRel = 50;
                        addStat(s, 'morale', -2);
                        if (s.statuses.badManager) delete s.statuses.badManager;
                        return { lines: ['Fresh start. Manager Rel reset to 50.', '-2 Morale'] };
                    }
                },
                {
                    label: 'Wait and see what they\'re like',
                    hint: 'Risky — might be a bad manager',
                    apply: function (s) {
                        s.vars.managerRel = 40;
                        if (rand() < 0.35) {
                            addStatus(s, 'badManager', 99);
                            return { lines: ['They micromanage everything. This is going to be rough.', 'Manager Rel reset to 40', 'Status: Bad Manager'] };
                        }
                        return { lines: ['They seem okay so far. Time will tell.', 'Manager Rel reset to 40'] };
                    }
                }
            ]
        },
        {
            id: 'frameworkMigration',
            name: 'Framework Migration',
            prob: 0.05,
            condition: function (s) { return s.levelIndex >= 1; },
            text: 'The architecture team mandates migrating to a new framework. The old codebase needs a complete rewrite.',
            choices: [
                {
                    label: 'Lead the migration effort',
                    hint: 'Big skill gain, crunch risk',
                    apply: function (s) {
                        addStat(s, 'skill', 7);
                        addStat(s, 'reputation', 5);
                        addStat(s, 'morale', -4);
                        if (rand() < 0.4) {
                            addStatus(s, 'crunchMode', 2);
                            return { lines: ['You\'re leading the charge but the timeline is brutal.', '+7 Skill', '+5 Reputation', '-4 Morale', 'Status: Crunch Mode'] };
                        }
                        return { lines: ['Migration is going well. Your expertise is recognized.', '+7 Skill', '+5 Reputation', '-4 Morale'] };
                    }
                },
                {
                    label: 'Focus on your own module only',
                    hint: 'Safe contribution',
                    apply: function (s) {
                        addStat(s, 'skill', 4);
                        addStat(s, 'morale', -1);
                        return { lines: ['You handle your piece cleanly.', '+4 Skill', '-1 Morale'] };
                    }
                }
            ]
        },
        {
            id: 'diversityInitiative',
            name: 'Diversity & Inclusion Initiative',
            prob: 0.03,
            text: 'The company launches a new D&I program. They\'re looking for allies and champions.',
            choices: [
                {
                    label: 'Volunteer as a champion',
                    hint: 'Reputation + morale',
                    apply: function (s) {
                        addStat(s, 'reputation', 4);
                        addStat(s, 'morale', 3);
                        addStat(s, 'managerRel', 2);
                        return { lines: ['Your involvement is appreciated by many.', '+4 Reputation', '+3 Morale', '+2 Manager Rel'] };
                    }
                },
                {
                    label: 'Support quietly',
                    hint: 'Low-key involvement',
                    apply: function (s) {
                        addStat(s, 'morale', 1);
                        return { lines: ['You show up and participate. Small actions matter.', '+1 Morale'] };
                    }
                }
            ]
        },
        {
            id: 'openFloorPlan',
            name: 'Open Floor Plan Redesign',
            prob: 0.04,
            once: true,
            text: 'The office is getting an "open floor plan redesign." Your private desk is being replaced with hot-desking pods.',
            choices: [
                {
                    label: 'Push for WFH days instead',
                    hint: 'Might get remote work',
                    apply: function (s) {
                        addStat(s, 'morale', -2);
                        if (rand() < 0.6) {
                            addStatus(s, 'remoteWork', 99);
                            return { lines: ['You negotiate WFH 3 days a week. Major win!', '-2 Morale', 'Status: Remote Work (permanent)'] };
                        }
                        return { lines: ['Request denied. "We value collaboration."', '-2 Morale'] };
                    }
                },
                {
                    label: 'Adapt to the noise',
                    hint: 'Morale hit',
                    apply: function (s) {
                        addStat(s, 'morale', -4);
                        return { lines: ['Noise-canceling headphones become your best friend.', '-4 Morale'] };
                    }
                }
            ]
        },
        {
            id: 'wfhPolicyChange',
            name: 'WFH Policy Change',
            prob: 0.04,
            text: function (s) {
                return s.statuses.remoteWork
                    ? 'The CEO announces: "Return to office! Innovation happens in person." Your WFH days are under threat.'
                    : 'The company announces a new flexible remote work policy! Work from anywhere Wednesdays.';
            },
            choices: [
                {
                    label: 'Accept the new policy',
                    hint: 'Go with the flow',
                    apply: function (s) {
                        if (s.statuses.remoteWork) {
                            delete s.statuses.remoteWork;
                            addStat(s, 'morale', -5);
                            return { lines: ['Back to the office full time. RIP your routine.', 'Lost: Remote Work', '-5 Morale'] };
                        }
                        addStatus(s, 'remoteWork', 99);
                        addStat(s, 'morale', 4);
                        return { lines: ['Remote work acquired! No more commute.', 'Status: Remote Work (permanent)', '+4 Morale'] };
                    }
                },
                {
                    label: 'Push back',
                    hint: 'Fight for what you want',
                    apply: function (s) {
                        if (s.statuses.remoteWork) {
                            if (rand() < 0.5) {
                                addStat(s, 'managerRel', -3);
                                return { lines: ['You negotiate an exception. WFH preserved!', '-3 Manager Rel'] };
                            }
                            delete s.statuses.remoteWork;
                            addStat(s, 'morale', -4);
                            addStat(s, 'managerRel', -4);
                            return { lines: ['Override denied. You lost WFH and some goodwill.', 'Lost: Remote Work', '-4 Morale', '-4 Manager Rel'] };
                        }
                        addStat(s, 'morale', -1);
                        return { lines: ['You already don\'t have WFH. Nothing changes.', '-1 Morale'] };
                    }
                }
            ]
        },
        {
            id: 'companyParty',
            name: 'Holiday Party!',
            prob: 0.05,
            seasonal: 11,
            text: 'It\'s the annual holiday party! Open bar, awkward dancing, and the CEO doing karaoke.',
            choices: [
                {
                    label: 'Network with leadership',
                    hint: 'Reputation + Manager Rel',
                    apply: function (s) {
                        addStat(s, 'reputation', 4);
                        addStat(s, 'managerRel', 4);
                        addStat(s, 'morale', 3);
                        return { lines: ['You chat with the CTO. They remember your name!', '+4 Reputation', '+4 Manager Rel', '+3 Morale'] };
                    }
                },
                {
                    label: 'Party hard with the team',
                    hint: 'Morale boost, mild risk',
                    apply: function (s) {
                        addStat(s, 'morale', 7);
                        if (rand() < 0.2) {
                            addStat(s, 'reputation', -2);
                            return { lines: ['Great night! ...but someone recorded you doing karaoke.', '+7 Morale', '-2 Reputation'] };
                        }
                        return { lines: ['Best party in years. The team bonded hard.', '+7 Morale'] };
                    }
                },
                {
                    label: 'Skip it',
                    hint: 'Introvert recharge',
                    apply: function (s) {
                        addStat(s, 'morale', 2);
                        addStat(s, 'reputation', -1);
                        return { lines: ['A quiet evening at home. Sometimes self-care wins.', '+2 Morale', '-1 Reputation'] };
                    }
                }
            ]
        },
        {
            id: 'hackathon',
            name: 'Internal Hackathon',
            prob: 0.05,
            text: 'The company is hosting a 48-hour hackathon! Prizes include a bonus and a chance to pitch to the CEO.',
            choices: [
                {
                    label: 'Go all in',
                    hint: 'Skill gamble, possible patent',
                    apply: function (s) {
                        addStat(s, 'morale', -3);
                        if (rand() < 0.5) {
                            addStat(s, 'skill', 6);
                            addStat(s, 'reputation', 8);
                            if (rand() < 0.3) {
                                s.items.patents++;
                                return { lines: ['Your project wins! The company wants to patent it.', '+6 Skill', '+8 Reputation', '-3 Morale', '+1 Patent'] };
                            }
                            return { lines: ['Your demo blows everyone away!', '+6 Skill', '+8 Reputation', '-3 Morale'] };
                        }
                        addStat(s, 'skill', 3);
                        return { lines: ['Your hack was cool but didn\'t win. Still learned a lot.', '+3 Skill', '-3 Morale'] };
                    }
                },
                {
                    label: 'Join casually',
                    hint: 'Fun without the stress',
                    apply: function (s) {
                        addStat(s, 'skill', 2);
                        addStat(s, 'morale', 2);
                        return { lines: ['You build something small and fun. Good times.', '+2 Skill', '+2 Morale'] };
                    }
                },
                {
                    label: 'Skip — use the quiet office to focus',
                    hint: 'Productive but boring',
                    apply: function (s) {
                        addStat(s, 'skill', 3);
                        s.items.prs++;
                        return { lines: ['While everyone hacks, you clear your backlog.', '+3 Skill', '+1 PR Merged'] };
                    }
                }
            ]
        },
        {
            id: 'securityBreach',
            name: 'Security Breach!',
            prob: 0.04,
            text: 'CRITICAL: A security vulnerability has been exploited. Customer data may be compromised. All hands on deck.',
            choices: [
                {
                    label: 'Join the incident response',
                    hint: 'High stakes, high reward',
                    apply: function (s) {
                        if (rand() < 0.6) {
                            addStat(s, 'skill', 5);
                            addStat(s, 'reputation', 8);
                            addStat(s, 'morale', -5);
                            s.items.hotfixes++;
                            return { lines: ['You help identify and patch the vulnerability. Hero status.', '+5 Skill', '+8 Reputation', '-5 Morale', '+1 Hotfix'] };
                        }
                        addStat(s, 'skill', 3);
                        addStat(s, 'morale', -6);
                        return { lines: ['It was beyond your depth. The security team handled it.', '+3 Skill', '-6 Morale'] };
                    }
                },
                {
                    label: 'Stay in your lane',
                    hint: 'Let the experts handle it',
                    apply: function (s) {
                        addStat(s, 'morale', -3);
                        return { lines: ['You watch from the sidelines. The breach is contained.', '-3 Morale'] };
                    }
                }
            ]
        },
        {
            id: 'startupOffer',
            name: 'Startup Offer',
            prob: 0.02,
            once: true,
            condition: function (s) { return s.levelIndex >= 2; },
            text: 'A hot startup reaches out: "We need a technical co-founder. Equity, autonomy, and the chance to build something from scratch."',
            choices: [
                {
                    label: 'Seriously consider it',
                    hint: 'Sets up startup path',
                    apply: function (s) {
                        addStat(s, 'morale', 5);
                        addStatus(s, 'jobHunting', 3);
                        s.meta.startupInterest = true;
                        return { lines: ['The idea is exciting. You start doing due diligence.', '+5 Morale', 'Status: Job Hunting (3mo)', 'Flag: Startup Interest'] };
                    }
                },
                {
                    label: 'Flattering, but no',
                    hint: 'Stay the course',
                    apply: function (s) {
                        addStat(s, 'morale', 2);
                        return { lines: ['You decline politely. Stability has its value.', '+2 Morale'] };
                    }
                }
            ]
        },
        {
            id: 'aiThreat',
            name: 'AI is Coming for Your Job',
            prob: 0.03,
            condition: function (s) { return s.levelIndex >= 1; },
            text: 'AI coding assistants are everywhere. Management is talking about "doing more with less." The team is nervous.',
            choices: [
                {
                    label: 'Learn to work with AI tools',
                    hint: 'Adapt and thrive',
                    apply: function (s) {
                        addStat(s, 'skill', 5);
                        addStat(s, 'morale', 2);
                        addStat(s, 'reputation', 3);
                        return { lines: ['You become the team\'s AI-augmented development expert.', '+5 Skill', '+2 Morale', '+3 Reputation'] };
                    }
                },
                {
                    label: 'Ignore it — AI can\'t do real engineering',
                    hint: 'Risk falling behind',
                    apply: function (s) {
                        if (rand() < 0.4) {
                            addStat(s, 'skill', -3);
                            addStat(s, 'reputation', -2);
                            return { lines: ['Colleagues who adopted AI tools are shipping 2x faster.', '-3 Skill', '-2 Reputation'] };
                        }
                        return { lines: ['For now, your deep expertise still matters more.'] };
                    }
                },
                {
                    label: 'Write a thought-piece about it',
                    hint: 'Blog + reputation',
                    apply: function (s) {
                        addStat(s, 'reputation', 5);
                        s.items.blogPosts++;
                        return { lines: ['Your nuanced take gets shared widely.', '+5 Reputation', '+1 Blog Post'] };
                    }
                }
            ]
        },
        {
            id: 'skipLevelMeeting',
            name: 'Skip-Level Meeting',
            prob: 0.04,
            condition: function (s) { return s.levelIndex >= 1; },
            text: 'Your manager\'s boss wants to have a 1:1 with you. "Just checking in on the team." Your manager looks nervous.',
            choices: [
                {
                    label: 'Be honest about team dynamics',
                    hint: 'Reputation up, manager risk',
                    apply: function (s) {
                        addStat(s, 'reputation', 5);
                        if (rand() < 0.3) {
                            addStat(s, 'managerRel', -5);
                            return { lines: ['Your candor is appreciated upward, but your manager heard.', '+5 Reputation', '-5 Manager Rel'] };
                        }
                        return { lines: ['The skip-level goes well. You\'re on leadership\'s radar.', '+5 Reputation'] };
                    }
                },
                {
                    label: 'Keep it positive and vague',
                    hint: 'Safe play',
                    apply: function (s) {
                        addStat(s, 'reputation', 2);
                        addStat(s, 'managerRel', 2);
                        return { lines: ['"Everything\'s great!" You played it safe.', '+2 Reputation', '+2 Manager Rel'] };
                    }
                }
            ]
        },
        {
            id: 'visaImmigration',
            name: 'Colleague Visa Issues',
            prob: 0.02,
            once: true,
            text: 'Your talented colleague is facing visa issues and might have to leave the country. The team rallies around them.',
            choices: [
                {
                    label: 'Advocate for company sponsorship',
                    hint: 'Solidarity, reputation',
                    apply: function (s) {
                        addStat(s, 'reputation', 4);
                        addStat(s, 'morale', 2);
                        addStat(s, 'managerRel', 3);
                        return { lines: ['You help organize support. HR agrees to sponsor their visa.', '+4 Reputation', '+2 Morale', '+3 Manager Rel'] };
                    }
                },
                {
                    label: 'Support them privately',
                    hint: 'Quiet solidarity',
                    apply: function (s) {
                        addStat(s, 'morale', 1);
                        return { lines: ['You check in on them regularly. Small gestures matter.', '+1 Morale'] };
                    }
                }
            ]
        },
        {
            id: 'stockVest',
            name: 'Stock Options Vest!',
            prob: 0.03,
            condition: function (s) { return s.month >= 12 && s.month % 12 < 2; },
            text: 'Your annual stock options just vested. Time to check the stock price...',
            choices: [
                {
                    label: 'Check the price and celebrate',
                    hint: 'Morale boost',
                    apply: function (s) {
                        if (rand() < 0.6) {
                            addStat(s, 'morale', 6);
                            return { lines: ['The stock is up! Your net worth just jumped.', '+6 Morale'] };
                        }
                        addStat(s, 'morale', -2);
                        return { lines: ['The stock is down. Your options are underwater.', '-2 Morale'] };
                    }
                },
                {
                    label: 'Ignore it — focus on the work',
                    hint: 'Zen approach',
                    apply: function (s) {
                        addStat(s, 'morale', 1);
                        return { lines: ['You don\'t check. What you don\'t know can\'t hurt you.', '+1 Morale'] };
                    }
                }
            ]
        }
    ];

    // Company-specific random events (3 per company type)
    var COMPANY_EVENTS = [
        // --- Startup ---
        {
            id: 'runwayPanic', name: 'Runway Panic', prob: 0.07, company: 'startup',
            text: 'The CFO reveals the company has 6 months of runway left. The all-hands is tense. "We need to ship faster or raise again."',
            choices: [
                {
                    label: 'Rally the team and crunch',
                    hint: 'Skill + Rep, heavy morale cost',
                    apply: function (s) {
                        addStat(s, 'skill', 4); addStat(s, 'reputation', 5); addStat(s, 'morale', -8);
                        addStatus(s, 'crunchMode', 2);
                        return { lines: ['+4 Skill', '+5 Reputation', '-8 Morale', 'Status: Crunch Mode', 'The team ships a miracle release.'] };
                    }
                },
                {
                    label: 'Start quietly job hunting',
                    hint: 'Morale boost, exit plan',
                    apply: function (s) {
                        addStat(s, 'morale', 3); addStatus(s, 'jobHunting', 3);
                        return { lines: ['+3 Morale', 'Status: Job Hunting (3mo)', 'Always have a backup plan.'] };
                    }
                }
            ]
        },
        {
            id: 'equityCliff', name: 'Equity Cliff Vests!', prob: 0.05, company: 'startup', once: true,
            condition: function (s) { return s.month >= 12; },
            text: 'Your 1-year cliff just vested! You now own actual equity in the company. Time to check the cap table.',
            choices: [
                {
                    label: 'Celebrate and stay motivated',
                    hint: 'Morale boost',
                    apply: function (s) {
                        addStat(s, 'morale', 8);
                        return { lines: ['+8 Morale', 'You\'re an owner now! (Sort of.)'] };
                    }
                },
                {
                    label: 'Ask about the cap table details',
                    hint: '50/50 dilution news',
                    apply: function (s) {
                        if (rand() < 0.5) {
                            addStat(s, 'morale', 5);
                            return { lines: ['+5 Morale', 'The cap table looks solid. Your shares could be worth something!'] };
                        }
                        addStat(s, 'morale', -4);
                        return { lines: ['-4 Morale', 'Turns out you\'ve been diluted to 0.03%. Cool cool cool.'] };
                    }
                }
            ]
        },
        {
            id: 'founderDisagree', name: 'Founder Disagreement', prob: 0.05, company: 'startup',
            text: 'The two cofounders are openly clashing about product direction. The team is picking sides. It\'s getting political.',
            choices: [
                {
                    label: 'Stay neutral',
                    hint: 'Safe but invisible',
                    apply: function (s) {
                        addStat(s, 'morale', -2);
                        return { lines: ['-2 Morale', 'You keep your head down. The tension is exhausting.'] };
                    }
                },
                {
                    label: 'Back the CEO\'s vision',
                    hint: '50/50 political gamble',
                    apply: function (s) {
                        if (rand() < 0.5) {
                            addStat(s, 'reputation', 6); addStat(s, 'managerRel', 5);
                            return { lines: ['+6 Reputation', '+5 Manager Rel', 'The CEO wins the argument. They remember your loyalty.'] };
                        }
                        addStat(s, 'reputation', -4); addStat(s, 'managerRel', -3);
                        return { lines: ['-4 Reputation', '-3 Manager Rel', 'The other founder prevails. You bet on the wrong horse.'] };
                    }
                }
            ]
        },
        // --- Big Tech ---
        {
            id: 'promoCommittee', name: 'Promo Committee Rejection', prob: 0.06, company: 'bigtech',
            condition: function (s) { return s.levelIndex >= 1; },
            text: 'Your promo packet was rejected by the committee. Reason: "Lacks cross-functional impact." Your manager looks apologetic.',
            choices: [
                {
                    label: 'Start a cross-team project',
                    hint: 'Long game, skill + rep',
                    apply: function (s) {
                        addStat(s, 'skill', 4); addStat(s, 'reputation', 5); addStat(s, 'morale', -3);
                        return { lines: ['+4 Skill', '+5 Reputation', '-3 Morale', 'You launch a cross-org initiative. The committee will notice next time.'] };
                    }
                },
                {
                    label: 'Vent on Blind',
                    hint: 'Morale recovery, reputation risk',
                    apply: function (s) {
                        addStat(s, 'morale', 3);
                        if (rand() < 0.3) {
                            addStat(s, 'reputation', -3);
                            return { lines: ['+3 Morale', '-3 Reputation', 'Your post goes semi-viral. Someone figured out it was you.'] };
                        }
                        return { lines: ['+3 Morale', 'Anonymous venting is therapeutic. Many upvotes.'] };
                    }
                }
            ]
        },
        {
            id: 'peerCalibration', name: 'Peer Calibration Season', prob: 0.05, company: 'bigtech',
            text: 'It\'s stack-ranking season. Managers are calibrating employees against each other. Your ranking matters for bonus and promo.',
            choices: [
                {
                    label: 'Prepare a detailed self-promo doc',
                    hint: 'Rep + Manager Rel, morale cost',
                    apply: function (s) {
                        addStat(s, 'reputation', 4); addStat(s, 'managerRel', 4); addStat(s, 'morale', -2);
                        return { lines: ['+4 Reputation', '+4 Manager Rel', '-2 Morale', 'Your manager has ammo to fight for you in calibration.'] };
                    }
                },
                {
                    label: 'Let your work speak for itself',
                    hint: 'Depends on reputation',
                    apply: function (s) {
                        if (s.vars.reputation >= 50) {
                            addStat(s, 'morale', 2);
                            return { lines: ['+2 Morale', 'Your reputation precedes you. Ranked well.'] };
                        }
                        addStat(s, 'morale', -3); addStat(s, 'reputation', -2);
                        return { lines: ['-3 Morale', '-2 Reputation', 'Work doesn\'t speak. People do. You ranked low.'] };
                    }
                }
            ]
        },
        {
            id: 'reorgShuffle', name: 'Reorg Shuffle', prob: 0.04, company: 'bigtech',
            text: 'A VP just left and the entire org is being reshuffled. Your team might get absorbed, split, or reorganized under someone new.',
            choices: [
                {
                    label: 'Pitch yourself to the new VP',
                    hint: '50/50 gamble',
                    apply: function (s) {
                        if (rand() < 0.5) {
                            addStat(s, 'reputation', 6); addStat(s, 'managerRel', 5);
                            return { lines: ['+6 Reputation', '+5 Manager Rel', 'The new VP is impressed. You\'re on the priority team.'] };
                        }
                        addStat(s, 'reputation', -2); addStat(s, 'managerRel', -3);
                        return { lines: ['-2 Reputation', '-3 Manager Rel', 'The new VP has their own people. You\'re sidelined.'] };
                    }
                },
                {
                    label: 'Go with the flow',
                    hint: 'Stable but passive',
                    apply: function (s) {
                        addStat(s, 'morale', -2);
                        s.vars.managerRel = 45;
                        return { lines: ['-2 Morale', 'Manager Rel reset to 45', 'New team, new dynamics. Time to adapt.'] };
                    }
                }
            ]
        },
        // --- Agency ---
        {
            id: 'clientEscalation', name: 'Client Escalation!', prob: 0.08, company: 'agency',
            text: 'The client CEO is furious. The demo failed, the timeline slipped, and they\'re threatening to pull the contract. Your PM is in panic mode.',
            choices: [
                {
                    label: 'Demo the progress yourself',
                    hint: '60% chance to save it',
                    apply: function (s) {
                        if (rand() < 0.6) {
                            addStat(s, 'reputation', 7); addStat(s, 'skill', 3); addStat(s, 'morale', -3);
                            return { lines: ['+7 Reputation', '+3 Skill', '-3 Morale', 'Your demo saves the account. The PM owes you one.'] };
                        }
                        addStat(s, 'morale', -6); addStat(s, 'reputation', -3);
                        return { lines: ['-6 Morale', '-3 Reputation', 'The demo tanks. The client is exploring other agencies.'] };
                    }
                },
                {
                    label: 'Let the PM handle it',
                    hint: 'Not your problem',
                    apply: function (s) {
                        addStat(s, 'morale', -2);
                        return { lines: ['-2 Morale', 'The PM handles it... poorly. But it\'s not on your record.'] };
                    }
                }
            ]
        },
        {
            id: 'newClientProject', name: 'New Greenfield Project', prob: 0.06, company: 'agency',
            text: 'A new client wants a greenfield project in a completely different tech stack. It\'s exciting but would mean context-switching hard.',
            choices: [
                {
                    label: 'Lead the new project',
                    hint: 'Big skill gain, reputation',
                    apply: function (s) {
                        addStat(s, 'skill', 6); addStat(s, 'reputation', 4); addStat(s, 'morale', -2);
                        s.items.features++;
                        return { lines: ['+6 Skill', '+4 Reputation', '-2 Morale', '+1 Feature', 'New stack, new challenges, new growth.'] };
                    }
                },
                {
                    label: 'Stay on current engagement',
                    hint: 'Stability, less growth',
                    apply: function (s) {
                        addStat(s, 'morale', 2); addStat(s, 'skill', 1);
                        return { lines: ['+2 Morale', '+1 Skill', 'You stay in your comfort zone. Reliable, if predictable.'] };
                    }
                }
            ]
        },
        {
            id: 'scopeCreep', name: 'Scope Creep Crisis', prob: 0.07, company: 'agency',
            text: 'The SOW is a distant memory. The project is 40% over budget and the client keeps adding "small" features. Something has to give.',
            choices: [
                {
                    label: 'Document and push back',
                    hint: 'Rep + skill, political risk',
                    apply: function (s) {
                        addStat(s, 'reputation', 5); addStat(s, 'skill', 2);
                        if (rand() < 0.3) {
                            addStat(s, 'managerRel', -3);
                            return { lines: ['+5 Reputation', '+2 Skill', '-3 Manager Rel', 'Client agreed to a change order, but your PM is annoyed you went over their head.'] };
                        }
                        return { lines: ['+5 Reputation', '+2 Skill', 'Your documentation saves the day. Change order approved.'] };
                    }
                },
                {
                    label: 'Crunch through it',
                    hint: 'Ship it, pay the price',
                    apply: function (s) {
                        addStat(s, 'morale', -6); addStat(s, 'skill', 3);
                        addStatus(s, 'crunchMode', 2);
                        s.items.features++;
                        return { lines: ['-6 Morale', '+3 Skill', '+1 Feature', 'Status: Crunch Mode', 'You ship everything. At what cost?'] };
                    }
                }
            ]
        },
        // --- Remote ---
        {
            id: 'asyncMiscomm', name: 'Async Miscommunication', prob: 0.07, company: 'remote',
            text: 'A 3 AM Slack thread made major architecture decisions without you. By the time you wake up, the PR is already merged.',
            choices: [
                {
                    label: 'Write an RFC to course-correct',
                    hint: 'Skill + Rep, design doc',
                    apply: function (s) {
                        addStat(s, 'skill', 3); addStat(s, 'reputation', 4);
                        s.items.designDocs++;
                        return { lines: ['+3 Skill', '+4 Reputation', '+1 Design Doc', 'Your RFC establishes better async decision-making processes.'] };
                    }
                },
                {
                    label: 'Adapt and move on',
                    hint: 'Pick your battles',
                    apply: function (s) {
                        addStat(s, 'morale', -2);
                        return { lines: ['-2 Morale', 'You swallow it. Not every hill is worth dying on.'] };
                    }
                }
            ]
        },
        {
            id: 'lonelyRemote', name: 'Remote Isolation', prob: 0.06, company: 'remote',
            condition: function (s) { return !hasPurchase(s, 'coworkingMembership'); },
            text: 'It\'s been 3 weeks since you\'ve seen another human in person. Your social skills are atrophying. The cat is your only coworker.',
            choices: [
                {
                    label: 'Join a coworking space',
                    hint: 'Morale + reputation',
                    apply: function (s) {
                        addStat(s, 'morale', 5); addStat(s, 'reputation', 2);
                        return { lines: ['+5 Morale', '+2 Reputation', 'Human contact! You even make some industry connections.'] };
                    }
                },
                {
                    label: 'Lean into solitude',
                    hint: '50/50 flow state or morale hit',
                    apply: function (s) {
                        if (rand() < 0.5) {
                            addStatus(s, 'flowState', randInt(2, 4));
                            addStat(s, 'skill', 3);
                            return { lines: ['+3 Skill', 'Gained: Flow State', 'Solitude unlocks deep focus. You\'re in the zone.'] };
                        }
                        addStat(s, 'morale', -5);
                        return { lines: ['-5 Morale', 'The loneliness is crushing. You should probably go outside.'] };
                    }
                }
            ]
        },
        {
            id: 'videoFatigue', name: 'Video Call Fatigue', prob: 0.06, company: 'remote',
            text: '8 hours of back-to-back Zoom calls. Your face hurts from smiling. Your brain is mush. "Can you see my screen?"',
            choices: [
                {
                    label: 'Propose no-meeting Wednesdays',
                    hint: 'Rep + morale',
                    apply: function (s) {
                        addStat(s, 'reputation', 4); addStat(s, 'morale', 4);
                        return { lines: ['+4 Reputation', '+4 Morale', 'The team loves it. Productivity soars on Wednesdays.'] };
                    }
                },
                {
                    label: 'Turn off camera and zone out',
                    hint: 'Morale recovery, small rep risk',
                    apply: function (s) {
                        addStat(s, 'morale', 2);
                        if (rand() < 0.2) {
                            addStat(s, 'reputation', -2);
                            return { lines: ['+2 Morale', '-2 Reputation', '"Hey, are you still there?" Busted.'] };
                        }
                        return { lines: ['+2 Morale', 'Camera off, multitasking on. Nobody notices.'] };
                    }
                }
            ]
        },
        // --- Non-Profit ---
        {
            id: 'grantFunding', name: 'Major Grant Approved!', prob: 0.05, company: 'nonprofit', once: true,
            text: 'A major foundation just approved a $2M grant for your organization! There\'s actually budget for modernization now.',
            choices: [
                {
                    label: 'Propose a tech modernization plan',
                    hint: 'Skill + Rep + Design Doc',
                    apply: function (s) {
                        addStat(s, 'skill', 5); addStat(s, 'reputation', 6); addStat(s, 'morale', 3);
                        s.items.designDocs++;
                        return { lines: ['+5 Skill', '+6 Reputation', '+3 Morale', '+1 Design Doc', 'Your modernization proposal is approved! Time to upgrade.'] };
                    }
                },
                {
                    label: 'Focus on current projects',
                    hint: 'Stable, mission-focused',
                    apply: function (s) {
                        addStat(s, 'morale', 4);
                        s.items.features++;
                        return { lines: ['+4 Morale', '+1 Feature', 'You pour the funding into delivering more impact.'] };
                    }
                }
            ]
        },
        {
            id: 'legacySystem', name: 'Legacy System Crash', prob: 0.06, company: 'nonprofit',
            text: 'The 15-year-old system just crashed. It\'s written in a language nobody on the team knows. Thousands of beneficiaries are affected.',
            choices: [
                {
                    label: 'Reverse-engineer and fix it',
                    hint: 'Big skill gain, painful',
                    apply: function (s) {
                        addStat(s, 'skill', 8); addStat(s, 'morale', -5); addStat(s, 'reputation', 5);
                        s.items.hotfixes++;
                        return { lines: ['+8 Skill', '-5 Morale', '+5 Reputation', '+1 Hotfix', 'You spent a week reading ancient code. But you fixed it.'] };
                    }
                },
                {
                    label: 'Recommend hiring a contractor',
                    hint: 'Safe, slower fix',
                    apply: function (s) {
                        addStat(s, 'morale', -1);
                        return { lines: ['-1 Morale', 'The contractor takes 3 weeks and charges a fortune. But it works.'] };
                    }
                }
            ]
        },
        {
            id: 'missionTrip', name: 'Field Visit', prob: 0.04, company: 'nonprofit',
            text: 'You\'re invited to visit the communities your software actually serves. It\'s a chance to see real impact.',
            choices: [
                {
                    label: 'Go on the field trip',
                    hint: 'Morale + purpose',
                    apply: function (s) {
                        addStat(s, 'morale', 10); addStat(s, 'reputation', 3);
                        return { lines: ['+10 Morale', '+3 Reputation', 'Meeting the people your code helps is incredibly motivating.'] };
                    }
                },
                {
                    label: 'Stay and keep coding',
                    hint: 'Productive but disconnected',
                    apply: function (s) {
                        addStat(s, 'skill', 3);
                        s.items.prs++;
                        return { lines: ['+3 Skill', '+1 PR Merged', 'You ship code while others travel. Efficient, if soulless.'] };
                    }
                }
            ]
        }
    ];

    // ---- Specialization Events ----
    var SPEC_EVENTS = [
        // Frontend
        {
            id: 'designSystemDebate', name: 'Design System Debate', prob: 0.06, spec: 'frontend',
            text: 'The design team wants to overhaul the component library. Engineering says the current system works fine. You\'re caught in the middle as the frontend specialist.',
            choices: [
                {
                    label: 'Champion the new design system',
                    hint: '+Rep, +Spec XP, political risk',
                    apply: function (s) {
                        addStat(s, 'reputation', 5); addStat(s, 'managerRel', -2); addSpecXP(s, 2);
                        return { lines: ['+5 Reputation', '-2 Manager Rel', '+2 Spec XP', 'You lead the migration. Designers love you, some engineers grumble.'] };
                    }
                },
                {
                    label: 'Propose an incremental approach',
                    hint: '+Skill, +Spec XP, diplomatic',
                    apply: function (s) {
                        addStat(s, 'skill', 3); addStat(s, 'managerRel', 2); addSpecXP(s, 2);
                        return { lines: ['+3 Skill', '+2 Manager Rel', '+2 Spec XP', 'You bridge both sides with a phased plan. Everyone\'s satisfied.'] };
                    }
                }
            ]
        },
        {
            id: 'browserCompatCrisis', name: 'Browser Compat Crisis', prob: 0.05, spec: 'frontend',
            text: 'A critical feature is broken in Safari and Edge. Users are complaining. QA is panicking. Your frontend expertise is needed NOW.',
            choices: [
                {
                    label: 'Deep dive and fix cross-browser issues',
                    hint: '+Skill (big), +Spec XP, -Morale',
                    apply: function (s) {
                        addStat(s, 'skill', 5); addStat(s, 'morale', -3); addSpecXP(s, 2);
                        return { lines: ['+5 Skill', '-3 Morale', '+2 Spec XP', 'You wrestle with vendor prefixes and polyfills. Fixed across all browsers.'] };
                    }
                },
                {
                    label: 'Drop support for problematic browsers',
                    hint: '+Morale, +Spec XP, -Rep',
                    apply: function (s) {
                        addStat(s, 'morale', 3); addStat(s, 'reputation', -2); addSpecXP(s, 2);
                        return { lines: ['+3 Morale', '-2 Reputation', '+2 Spec XP', 'You convince the team to drop old browser support. Pragmatic but controversial.'] };
                    }
                }
            ]
        },
        // Backend
        {
            id: 'apiBreakingChange', name: 'API Breaking Change', prob: 0.06, spec: 'backend',
            text: 'A major API version bump is needed but 200+ clients depend on the current contract. Backward compatibility vs. clean architecture — your call.',
            choices: [
                {
                    label: 'Build a compatibility layer',
                    hint: '+Skill, +Rep, +Spec XP',
                    apply: function (s) {
                        addStat(s, 'skill', 4); addStat(s, 'reputation', 3); addSpecXP(s, 2);
                        return { lines: ['+4 Skill', '+3 Reputation', '+2 Spec XP', 'You write an adapter layer. Clients migrate smoothly over 3 months.'] };
                    }
                },
                {
                    label: 'Hard cut — force migration with deadline',
                    hint: '+Skill (big), +Spec XP, -Manager Rel',
                    apply: function (s) {
                        addStat(s, 'skill', 6); addStat(s, 'managerRel', -3); addSpecXP(s, 2);
                        return { lines: ['+6 Skill', '-3 Manager Rel', '+2 Spec XP', 'Clean break. Some clients are upset but the new API is beautiful.'] };
                    }
                }
            ]
        },
        {
            id: 'scalingCrisis', name: 'Scaling Crisis', prob: 0.05, spec: 'backend',
            text: 'Traffic spiked 10x overnight. The database is melting, queues are backed up, and the CEO is asking for ETAs. Your backend knowledge is critical.',
            choices: [
                {
                    label: 'Emergency horizontal scaling',
                    hint: '+Skill, +Rep, +Spec XP, -Morale',
                    apply: function (s) {
                        addStat(s, 'skill', 4); addStat(s, 'reputation', 4); addStat(s, 'morale', -3); addSpecXP(s, 2);
                        return { lines: ['+4 Skill', '+4 Reputation', '-3 Morale', '+2 Spec XP', 'You spin up replicas, add caching, and survive the spike.'] };
                    }
                },
                {
                    label: 'Implement rate limiting and queue throttling',
                    hint: '+Skill, +Spec XP, steady approach',
                    apply: function (s) {
                        addStat(s, 'skill', 3); addStat(s, 'morale', 1); addSpecXP(s, 2);
                        return { lines: ['+3 Skill', '+1 Morale', '+2 Spec XP', 'You gracefully degrade under load. Not glamorous but it works.'] };
                    }
                }
            ]
        },
        // DevOps
        {
            id: 'cicdPipelineFailure', name: 'CI/CD Pipeline Failure', prob: 0.06, spec: 'devops',
            text: 'The entire CI/CD pipeline is down. No one can deploy. A dependency server is unreachable and builds are queuing up. Everyone\'s looking at you.',
            choices: [
                {
                    label: 'Rebuild the pipeline from scratch',
                    hint: '+Skill (big), +Spec XP, -Morale',
                    apply: function (s) {
                        addStat(s, 'skill', 5); addStat(s, 'morale', -4); addSpecXP(s, 2);
                        return { lines: ['+5 Skill', '-4 Morale', '+2 Spec XP', 'You rebuild with better redundancy. 12-hour marathon but it\'s bulletproof now.'] };
                    }
                },
                {
                    label: 'Hotfix with manual deploy process',
                    hint: '+Rep, +Spec XP, temporary fix',
                    apply: function (s) {
                        addStat(s, 'reputation', 4); addStat(s, 'morale', -1); addSpecXP(s, 2);
                        return { lines: ['+4 Reputation', '-1 Morale', '+2 Spec XP', 'You write a manual deploy script. Team can ship again in 2 hours.'] };
                    }
                }
            ]
        },
        {
            id: 'cloudCostExplosion', name: 'Cloud Cost Explosion', prob: 0.05, spec: 'devops',
            text: 'The AWS bill tripled this month. Someone left GPU instances running, and auto-scaling went haywire. Finance is furious.',
            choices: [
                {
                    label: 'Deep audit and implement cost controls',
                    hint: '+Skill, +Rep, +Spec XP',
                    apply: function (s) {
                        addStat(s, 'skill', 3); addStat(s, 'reputation', 4); addSpecXP(s, 2);
                        return { lines: ['+3 Skill', '+4 Reputation', '+2 Spec XP', 'You find $40k/month in savings. Finance sends you a thank-you email.'] };
                    }
                },
                {
                    label: 'Set up automated spending alerts and limits',
                    hint: '+Skill, +Manager Rel, +Spec XP',
                    apply: function (s) {
                        addStat(s, 'skill', 2); addStat(s, 'managerRel', 4); addSpecXP(s, 2);
                        return { lines: ['+2 Skill', '+4 Manager Rel', '+2 Spec XP', 'You prevent future surprises. Proactive infrastructure governance.'] };
                    }
                }
            ]
        },
        // Data/ML
        {
            id: 'mlModelBias', name: 'ML Model Bias Discovered', prob: 0.06, spec: 'dataml',
            text: 'Your production ML model has a significant bias against certain demographics. The press might pick this up. The team needs your data expertise.',
            choices: [
                {
                    label: 'Full audit and retrain with balanced data',
                    hint: '+Skill (big), +Rep, +Spec XP, -Morale',
                    apply: function (s) {
                        addStat(s, 'skill', 5); addStat(s, 'reputation', 3); addStat(s, 'morale', -3); addSpecXP(s, 2);
                        return { lines: ['+5 Skill', '+3 Reputation', '-3 Morale', '+2 Spec XP', 'You retrain with fairness constraints. The model is slower but equitable.'] };
                    }
                },
                {
                    label: 'Document the limitation and add disclaimers',
                    hint: '+Rep, +Spec XP, quick fix',
                    apply: function (s) {
                        addStat(s, 'reputation', 2); addStat(s, 'morale', 2); addSpecXP(s, 2);
                        return { lines: ['+2 Reputation', '+2 Morale', '+2 Spec XP', 'You write transparent documentation. Not ideal but buys time for a proper fix.'] };
                    }
                }
            ]
        },
        {
            id: 'dataQualityCrisis', name: 'Data Quality Crisis', prob: 0.05, spec: 'dataml',
            text: 'Upstream data sources have been silently corrupted for weeks. Your dashboards are showing wrong numbers. Execs made decisions based on bad data.',
            choices: [
                {
                    label: 'Build data validation pipeline',
                    hint: '+Skill, +Rep, +Spec XP',
                    apply: function (s) {
                        addStat(s, 'skill', 4); addStat(s, 'reputation', 3); addSpecXP(s, 2);
                        return { lines: ['+4 Skill', '+3 Reputation', '+2 Spec XP', 'You add schema validation, anomaly detection, and data contracts.'] };
                    }
                },
                {
                    label: 'Manual data cleanup and incident report',
                    hint: '+Manager Rel, +Spec XP, tedious',
                    apply: function (s) {
                        addStat(s, 'managerRel', 4); addStat(s, 'morale', -2); addSpecXP(s, 2);
                        return { lines: ['+4 Manager Rel', '-2 Morale', '+2 Spec XP', 'You clean up the mess and write a thorough postmortem.'] };
                    }
                }
            ]
        },
        // Mobile
        {
            id: 'appStoreRejection', name: 'App Store Rejection', prob: 0.06, spec: 'mobile',
            text: 'Apple rejected your app update citing privacy violations. The release is blocked and marketing has already announced the feature.',
            choices: [
                {
                    label: 'Rewrite the flagged components for compliance',
                    hint: '+Skill, +Spec XP, -Morale',
                    apply: function (s) {
                        addStat(s, 'skill', 4); addStat(s, 'morale', -3); addSpecXP(s, 2);
                        return { lines: ['+4 Skill', '-3 Morale', '+2 Spec XP', 'You rewrite the data collection flow. Approved on resubmission.'] };
                    }
                },
                {
                    label: 'Appeal with detailed documentation',
                    hint: '+Rep, +Spec XP, risky',
                    apply: function (s) {
                        if (rand() < 0.5) {
                            addStat(s, 'reputation', 5); addSpecXP(s, 2);
                            return { lines: ['+5 Reputation', '+2 Spec XP', 'Apple accepts your appeal! Your detailed docs impressed the review team.'] };
                        }
                        addStat(s, 'reputation', -2); addStat(s, 'morale', -2); addSpecXP(s, 2);
                        return { lines: ['-2 Reputation', '-2 Morale', '+2 Spec XP', 'Appeal denied. You have to rewrite anyway and lost a week.'] };
                    }
                }
            ]
        },
        {
            id: 'crashRateSpike', name: 'Crash Rate Spike', prob: 0.05, spec: 'mobile',
            text: 'The latest release has a 5% crash rate. Users are leaving 1-star reviews. The crash logs point to a memory leak on older devices.',
            choices: [
                {
                    label: 'Emergency hotfix with memory optimization',
                    hint: '+Skill, +Rep, +Spec XP, -Morale',
                    apply: function (s) {
                        addStat(s, 'skill', 4); addStat(s, 'reputation', 3); addStat(s, 'morale', -2); addSpecXP(s, 2);
                        s.items.hotfixes++;
                        return { lines: ['+4 Skill', '+3 Reputation', '-2 Morale', '+1 Hotfix', '+2 Spec XP', 'You optimize memory usage and push a hotfix. Crash rate drops to 0.1%.'] };
                    }
                },
                {
                    label: 'Roll back to previous stable version',
                    hint: '+Morale, +Spec XP, -Rep',
                    apply: function (s) {
                        addStat(s, 'morale', 2); addStat(s, 'reputation', -2); addSpecXP(s, 2);
                        return { lines: ['+2 Morale', '-2 Reputation', '+2 Spec XP', 'You roll back. Stable but the new feature is delayed indefinitely.'] };
                    }
                }
            ]
        }
    ];

    // Career gate events
    var CAREER_EVENTS = {
        careerFork: {
            id: 'careerFork',
            name: 'Career Crossroads',
            once: true,
            text: 'You\'ve reached Senior Developer. Your VP pulls you aside: "We see leadership potential in you. But some of our best people stay deep in tech. Which path calls to you?"',
            getChoices: function () {
                return [
                    {
                        label: 'Stay on the IC track',
                        hint: 'Staff Engineer \u2192 Principal Engineer',
                        apply: function (st) {
                            st.meta.track = 'ic';
                            LEVELS = IC_LEVELS;
                            addStat(st, 'morale', 5);
                            addStat(st, 'skill', 3);
                            awardAchievement('took_ic_track');
                            return { lines: ['You choose the Individual Contributor path.', 'New goal: reach Principal Engineer!', '+5 Morale', '+3 Skill'] };
                        }
                    },
                    {
                        label: 'Move into Management',
                        hint: 'Tech Lead \u2192 Eng Manager \u2192 VP Eng',
                        apply: function (st) {
                            st.meta.track = 'mgmt';
                            LEVELS = MGMT_LEVELS;
                            addStat(st, 'morale', 5);
                            addStat(st, 'managerRel', 5);
                            awardAchievement('took_mgmt_track');
                            return { lines: ['You choose the Management path.', 'New goal: reach VP of Engineering!', '+5 Morale', '+5 Manager Rel'] };
                        }
                    }
                ];
            }
        },
        probationReview: {
            id: 'probationReview',
            name: '90-Day Probation Review',
            month: 3,
            once: true,
            text: 'It\'s your 3-month review. Your manager sits you down with a printed-out spreadsheet of your commits.',
            getChoices: function (s) {
                var positive = s.vars.skill >= 20 && s.vars.managerRel >= 40;
                if (positive) {
                    return [{
                        label: 'Accept feedback gracefully',
                        hint: 'Positive review!',
                        apply: function (st) {
                            addStat(st, 'morale', 5);
                            addStat(st, 'managerRel', 5);
                            st.meta.lastReview = 'positive';
                            return { lines: ['"Great start! Keep it up," your manager says.', '+5 Morale', '+5 Manager Rel', 'Review: Positive'] };
                        }
                    }];
                }
                return [{
                    label: 'Take the constructive feedback',
                    hint: 'Room to improve',
                    apply: function (st) {
                        addStat(st, 'morale', -3);
                        st.meta.lastReview = 'negative';
                        return { lines: ['"You need to ramp up faster," your manager says firmly.', '-3 Morale', 'Review: Needs Improvement'] };
                    }
                }];
            }
        },
        performanceReview: {
            id: 'performanceReview',
            name: 'Performance Review',
            interval: 6,
            text: 'It\'s performance review season. Time for the dreaded self-assessment and manager feedback.',
            getChoices: function (s) {
                var score = 0;
                if (s.vars.skill >= 30) score++;
                if (s.vars.reputation >= 20) score++;
                if (s.vars.managerRel >= 50) score++;
                if (s.items.prs >= 8) score++;
                var positive = score >= 3;
                if (positive) {
                    return [
                        {
                            label: 'Celebrate — you earned it',
                            hint: 'Positive review',
                            apply: function (st) {
                                addStat(st, 'morale', 6);
                                addStat(st, 'managerRel', 3);
                                st.meta.lastReview = 'positive';
                                st.meta.positiveReviews = (st.meta.positiveReviews || 0) + 1;
                                return { lines: ['"Exceeds expectations." Your manager is pleased.', '+6 Morale', '+3 Manager Rel', 'Review: Positive'] };
                            }
                        }
                    ];
                }
                return [
                    {
                        label: 'Accept the feedback and improve',
                        hint: 'Tough but fair',
                        apply: function (st) {
                            addStat(st, 'morale', -4);
                            st.meta.lastReview = 'negative';
                            if ((st.meta.consecutiveNeg || 0) >= 1) {
                                addStatus(st, 'pip', 3);
                                st.meta.consecutiveNeg = 0;
                                return { lines: ['"We need to see improvement." You\'re placed on a PIP.', '-4 Morale', 'Status: PIP (3 months)', 'Review: Negative'] };
                            }
                            st.meta.consecutiveNeg = (st.meta.consecutiveNeg || 0) + 1;
                            return { lines: ['"Meets some expectations." Room for improvement.', '-4 Morale', 'Review: Needs Improvement'] };
                        }
                    },
                    {
                        label: 'Dispute the review',
                        hint: 'Risky',
                        apply: function (st) {
                            if (rand() < 0.25) {
                                addStat(st, 'managerRel', -2);
                                st.meta.lastReview = 'positive';
                                st.meta.positiveReviews = (st.meta.positiveReviews || 0) + 1;
                                return { lines: ['After discussion, your rating is bumped up.', '-2 Manager Rel', 'Review: Adjusted to Positive'] };
                            }
                            addStat(st, 'managerRel', -6);
                            addStat(st, 'morale', -3);
                            st.meta.lastReview = 'negative';
                            st.meta.consecutiveNeg = (st.meta.consecutiveNeg || 0) + 1;
                            return { lines: ['Your manager doubles down. Atmosphere is now icy.', '-6 Manager Rel', '-3 Morale', 'Review: Negative'] };
                        }
                    }
                ];
            }
        },
        promotionConsideration: {
            id: 'promotionConsideration',
            name: 'Promotion Consideration',
            interval: 12,
            text: 'The promotion committee is convening. Your name is on the list.',
            getChoices: function (s) {
                var activeLevels = getActiveLevels(s);
                var currentId = activeLevels[s.levelIndex].id;

                // Determine promo req key based on track
                var reqKey = currentId;
                if (currentId === 'senior' && s.meta.track === 'ic') reqKey = 'senior_ic';
                else if (currentId === 'senior' && s.meta.track === 'mgmt') reqKey = 'senior_mgmt';

                var reqs = PROMO_REQS[reqKey];
                if (!reqs) {
                    return [{
                        label: 'You\'re already at the top!',
                        hint: 'Nothing to promote to',
                        apply: function () {
                            return { lines: ['You\'ve reached the pinnacle of your career path!'] };
                        }
                    }];
                }
                var met = true;
                var reasons = [];
                if (s.vars.skill < reqs.skill) { met = false; reasons.push('Skill ' + s.vars.skill + '/' + reqs.skill); }
                if (s.vars.reputation < reqs.reputation) { met = false; reasons.push('Rep ' + s.vars.reputation + '/' + reqs.reputation); }
                if (reqs.prs && s.items.prs < reqs.prs) { met = false; reasons.push('PRs ' + s.items.prs + '/' + reqs.prs); }
                if (reqs.features && s.items.features < reqs.features) { met = false; reasons.push('Features ' + s.items.features + '/' + reqs.features); }
                if (reqs.designDocs && s.items.designDocs < reqs.designDocs) { met = false; reasons.push('Docs ' + s.items.designDocs + '/' + reqs.designDocs); }
                if (reqs.mentorships && s.items.mentorships < reqs.mentorships) { met = false; reasons.push('Mentorships ' + s.items.mentorships + '/' + reqs.mentorships); }
                if (reqs.techTalks && s.items.techTalks < reqs.techTalks) { met = false; reasons.push('Talks ' + s.items.techTalks + '/' + reqs.techTalks); }
                if (reqs.patents && (s.items.patents || 0) < reqs.patents) { met = false; reasons.push('Patents ' + (s.items.patents || 0) + '/' + reqs.patents); }
                if (reqs.conferencetalks && (s.items.conferencetalks || 0) < reqs.conferencetalks) { met = false; reasons.push('Conf. Talks ' + (s.items.conferencetalks || 0) + '/' + reqs.conferencetalks); }
                if (reqs.managerRel && s.vars.managerRel < reqs.managerRel) { met = false; reasons.push('Mgr Rel ' + s.vars.managerRel + '/' + reqs.managerRel); }
                if (reqs.needsReview && s.meta.lastReview !== 'positive') { met = false; reasons.push('Need positive review'); }

                if (met) {
                    return [{
                        label: 'Accept the promotion!',
                        hint: 'You earned it',
                        apply: function (st) {
                            st.levelIndex++;
                            addStat(st, 'morale', 10);
                            addStat(st, 'reputation', 5);
                            var aLevels = getActiveLevels(st);

                            // At senior (index 2) without a track: trigger career fork
                            if (st.levelIndex === 2 && !st.meta.track) {
                                st.meta.pendingFork = true;
                                return { lines: ['Congratulations! You\'ve been promoted to ' + aLevels[st.levelIndex].name + '!', '+10 Morale', '+5 Reputation', 'A big decision awaits...'] };
                            }

                            // Win condition: IC levelIndex>=4 or Mgmt levelIndex>=5
                            if ((st.meta.track === 'ic' && st.levelIndex >= 4) ||
                                (st.meta.track === 'mgmt' && st.levelIndex >= 5)) {
                                st.meta.won = true;
                            }
                            return { lines: ['Congratulations! You\'ve been promoted to ' + aLevels[st.levelIndex].name + '!', '+10 Morale', '+5 Reputation'] };
                        }
                    }];
                }
                return [{
                    label: 'Understand what you need to improve',
                    hint: 'Not ready yet',
                    apply: function (st) {
                        addStat(st, 'morale', -3);
                        return { lines: ['Not this time. Missing: ' + reasons.join(', '), '-3 Morale'] };
                    }
                }];
            }
        }
    };

    // ==================== SECTION 4: GAME STATE ====================

    function newGameState(seed) {
        return {
            version: 6,
            seed: seed,
            month: 0,
            levelIndex: 0,
            company: null,
            spec: null,
            specXP: 0,
            specXPSpent: 0,
            vars: {
                morale: 70,
                skill: 15,
                reputation: 5,
                managerRel: 50
            },
            items: {
                prs: 0,
                features: 0,
                hotfixes: 0,
                designDocs: 0,
                techTalks: 0,
                blogPosts: 0,
                mentorships: 0,
                patents: 0,
                conferencetalks: 0
            },
            statuses: {},
            occurred: [],
            meta: {
                lastReview: null,
                positiveReviews: 0,
                consecutiveNeg: 0,
                techDebt: 0,
                ossContributions: 0,
                won: false,
                gameOver: false,
                gameOverReason: null,
                lowMoraleStreak: 0,
                totalEarnings: 0,
                jobHops: 0,
                companyHistory: [],
                savings: 0,
                purchases: [],
                worldEvent: null,
                worldEventRemaining: 0,
                worldEventCooldown: 0,
                worldEventHistory: [],
                perks: []
            }
        };
    }

    function clamp(val, min, max) {
        return Math.max(min, Math.min(max, val));
    }

    function addStat(s, key, amount) {
        s.vars[key] = clamp(s.vars[key] + amount, 0, 100);
    }

    function addStatus(s, id, duration) {
        // Chaos Engineer perk: bad status durations -1
        var def = STATUS_DEFS[id];
        if (def && def.type === 'bad' && duration > 1 && s.meta && s.meta.perks && s.meta.perks.indexOf('do_chaos_engineer') !== -1) {
            duration = Math.max(1, duration - 1);
        }
        s.statuses[id] = { remaining: duration };
    }

    function addSpecXP(s, amount) {
        s.specXP = clamp(s.specXP + amount, 0, 100);
    }

    // ---- Achievement persistence ----
    function loadAchievements() {
        try {
            var raw = localStorage.getItem('ds-achievements');
            if (!raw) return { unlocked: [] };
            var data = JSON.parse(raw);
            if (!data || !Array.isArray(data.unlocked)) return { unlocked: [] };
            return data;
        } catch (e) {
            return { unlocked: [] };
        }
    }

    function saveAchievements(data) {
        try {
            localStorage.setItem('ds-achievements', JSON.stringify(data));
        } catch (e) { /* storage full */ }
    }

    function isAchievementUnlocked(id) {
        var data = loadAchievements();
        return data.unlocked.indexOf(id) !== -1;
    }

    function awardAchievement(id) {
        var data = loadAchievements();
        if (data.unlocked.indexOf(id) !== -1) return;
        data.unlocked.push(id);
        saveAchievements(data);
        showAchievementToast(id);
    }

    function checkTickAchievements(s) {
        for (var i = 0; i < ACHIEVEMENTS.length; i++) {
            var ach = ACHIEVEMENTS[i];
            if (ach.check && ach.check(s)) {
                awardAchievement(ach.id);
            }
        }
    }

    // ---- Prestige persistence & logic ----
    function loadPrestige() {
        try {
            var raw = localStorage.getItem('ds-prestige');
            if (!raw) return { level: 0 };
            var data = JSON.parse(raw);
            if (!data || typeof data.level !== 'number') return { level: 0 };
            return data;
        } catch (e) {
            return { level: 0 };
        }
    }

    function savePrestige(data) {
        try {
            localStorage.setItem('ds-prestige', JSON.stringify(data));
        } catch (e) { /* storage full */ }
    }

    function getPrestigeLevel() {
        return loadPrestige().level;
    }

    function getPrestigeDef(level) {
        for (var i = 0; i < PRESTIGE_LEVELS.length; i++) {
            if (PRESTIGE_LEVELS[i].level === level) return PRESTIGE_LEVELS[i];
        }
        return null;
    }

    function applyPrestigeToState(s) {
        var pLevel = getPrestigeLevel();
        for (var i = 0; i < PRESTIGE_LEVELS.length; i++) {
            var p = PRESTIGE_LEVELS[i];
            if (p.level > pLevel) break;
            if (p.stat === 'savings') {
                s.meta.savings = (s.meta.savings || 0) + p.bonus;
            } else {
                s.vars[p.stat] = clamp(s.vars[p.stat] + p.bonus, 0, 100);
            }
        }
    }

    function doPrestige() {
        var data = loadPrestige();
        if (data.level >= PRESTIGE_MAX) return;
        data.level++;
        savePrestige(data);
        if (data.level === 1) awardAchievement('first_prestige');
        if (data.level === PRESTIGE_MAX) awardAchievement('max_prestige');
        startNewGame();
    }

    // ---- Lifetime Stats persistence ----
    function loadStats() {
        try {
            var raw = localStorage.getItem('ds-stats');
            if (!raw) return JSON.parse(JSON.stringify(STAT_DEFAULTS));
            var data = JSON.parse(raw);
            if (!data || typeof data.totalGames !== 'number') return JSON.parse(JSON.stringify(STAT_DEFAULTS));
            // Ensure all keys exist (forward-compat)
            var def = STAT_DEFAULTS;
            if (!data.endings) data.endings = JSON.parse(JSON.stringify(def.endings));
            if (!data.companyPicks) data.companyPicks = JSON.parse(JSON.stringify(def.companyPicks));
            if (!data.specPicks) data.specPicks = JSON.parse(JSON.stringify(def.specPicks));
            if (!data.trackPicks) data.trackPicks = JSON.parse(JSON.stringify(def.trackPicks));
            if (data.currentWinStreak === undefined) data.currentWinStreak = 0;
            if (data.bestWinStreak === undefined) data.bestWinStreak = 0;
            return data;
        } catch (e) {
            return JSON.parse(JSON.stringify(STAT_DEFAULTS));
        }
    }

    function saveStats(data) {
        try {
            localStorage.setItem('ds-stats', JSON.stringify(data));
        } catch (e) { /* storage full */ }
    }

    function recordGameStats(s, score) {
        var st = loadStats();
        var reason = s.meta.gameOverReason;
        var won = reason === 'won' || reason === 'startup' || reason === 'devAdvocate' || reason === 'startupExit';

        st.totalGames++;
        if (won) st.totalWins++;
        else st.totalLosses++;

        if (score > st.bestScore) st.bestScore = score;
        if (score < st.worstScore) st.worstScore = score;
        st.totalScore += score;

        st.totalMonthsPlayed += s.month;
        if (won && s.month < st.fastestWin) st.fastestWin = s.month;
        st.totalEarnings += (s.meta.totalEarnings || 0);

        var activeLevels = getActiveLevels(s);
        if (s.levelIndex > st.highestLevelIndex) {
            st.highestLevelIndex = s.levelIndex;
            st.highestLevelName = activeLevels[s.levelIndex].name;
        }

        // Endings
        if (reason && st.endings[reason] !== undefined) st.endings[reason]++;

        // Company picks
        if (s.company && st.companyPicks[s.company] !== undefined) st.companyPicks[s.company]++;

        // Spec picks
        if (s.spec && st.specPicks[s.spec] !== undefined) st.specPicks[s.spec]++;

        // Track picks
        if (s.meta.track && st.trackPicks[s.meta.track] !== undefined) st.trackPicks[s.meta.track]++;

        // Prestige
        if (getPrestigeLevel() > 0) st.totalPrestigeRuns++;

        // Win streak
        if (won) {
            st.currentWinStreak++;
            if (st.currentWinStreak > st.bestWinStreak) st.bestWinStreak = st.currentWinStreak;
        } else {
            st.currentWinStreak = 0;
        }

        saveStats(st);

        // Award stats-based achievements
        if (st.totalGames >= 10) awardAchievement('played_10');
        if (st.totalGames >= 25) awardAchievement('played_25');
        if (st.currentWinStreak >= 3) awardAchievement('win_streak_3');
        if (won && s.month <= 36) awardAchievement('speed_run');

        // All endings
        var allEndings = true;
        var endKeys = Object.keys(st.endings);
        for (var i = 0; i < endKeys.length; i++) {
            if (st.endings[endKeys[i]] === 0) { allEndings = false; break; }
        }
        if (allEndings) awardAchievement('all_endings');

        // All companies
        var allCompanies = true;
        var compKeys = Object.keys(st.companyPicks);
        for (var j = 0; j < compKeys.length; j++) {
            if (st.companyPicks[compKeys[j]] === 0) { allCompanies = false; break; }
        }
        if (allCompanies) awardAchievement('all_companies');
    }

    // ---- Skill Tree helpers ----
    function getSkillTree(specId) {
        return SKILL_TREES[specId] || [];
    }

    function hasPerk(s, perkId) {
        return s.meta && s.meta.perks && s.meta.perks.indexOf(perkId) !== -1;
    }

    function getPerkDef(specId, perkId) {
        var tree = getSkillTree(specId);
        for (var i = 0; i < tree.length; i++) {
            if (tree[i].id === perkId) return tree[i];
        }
        return null;
    }

    function getAvailableXP(s) {
        return s.specXP - (s.specXPSpent || 0);
    }

    function canUnlockPerk(s, perk) {
        if (hasPerk(s, perk.id)) return false;
        if (getAvailableXP(s) < perk.cost) return false;
        // Tier requirements
        var tree = getSkillTree(s.spec);
        if (perk.tier === 2) {
            var hasT1 = false;
            for (var i = 0; i < tree.length; i++) {
                if (tree[i].tier === 1 && hasPerk(s, tree[i].id)) { hasT1 = true; break; }
            }
            if (!hasT1) return false;
        }
        if (perk.tier === 3) {
            var hasT2 = false;
            for (var j = 0; j < tree.length; j++) {
                if (tree[j].tier === 2 && hasPerk(s, tree[j].id)) { hasT2 = true; break; }
            }
            if (!hasT2) return false;
        }
        return true;
    }

    function unlockPerk(s, perkId) {
        var perk = getPerkDef(s.spec, perkId);
        if (!perk || !canUnlockPerk(s, perk)) return false;
        s.meta.perks.push(perkId);
        s.specXPSpent = (s.specXPSpent || 0) + perk.cost;
        // Achievements
        if (s.meta.perks.length === 1) awardAchievement('first_perk');
        if (s.meta.perks.length >= 5) awardAchievement('full_tree');
        return true;
    }

    function applyPerkEffects(s) {
        if (!s.meta || !s.meta.perks || !s.spec) return;
        var tree = getSkillTree(s.spec);
        for (var i = 0; i < s.meta.perks.length; i++) {
            for (var j = 0; j < tree.length; j++) {
                if (tree[j].id === s.meta.perks[i] && tree[j].effect.type === 'monthly') {
                    addStat(s, tree[j].effect.stat, tree[j].effect.amount);
                }
            }
        }
    }

    function getYear(month) {
        return Math.floor(month / 12) + 1;
    }

    function getMonthName(month) {
        var names = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        return names[month % 12];
    }

    function totalItems(s) {
        var sum = 0;
        var keys = Object.keys(s.items);
        for (var i = 0; i < keys.length; i++) sum += s.items[keys[i]];
        return sum;
    }

    function getActiveLevels(s) {
        if (s.meta.track === 'ic') return IC_LEVELS;
        if (s.meta.track === 'mgmt') return MGMT_LEVELS;
        return BASE_LEVELS;
    }

    function syncLevels(s) {
        LEVELS = getActiveLevels(s);
    }

    function computeScore(s) {
        var base = (s.levelIndex * 1000) + (totalItems(s) * 50) + Math.max(0, (120 - s.month) * 5);
        if (s.meta.track === 'mgmt') base += 500;
        if (s.meta.gameOverReason === 'startup') base += 750;
        if (s.meta.gameOverReason === 'devAdvocate') base += 500;
        if (s.meta.gameOverReason === 'startupExit') base += 600;
        var ct = COMPANY_TYPES[s.company];
        if (ct) base += ct.scoreMod;
        // Phase 4: purchases + world events survived
        if (s.meta.purchases) base += s.meta.purchases.length * 25;
        if (s.meta.worldEventHistory) base += s.meta.worldEventHistory.length * 100;
        // Phase 5: specialization XP bonus
        if (s.specXP) base += s.specXP * 2;
        if (s.specXP >= 75) base += 150;
        // Phase 9: perk score modifiers
        if (s.meta && s.meta.perks && s.spec) {
            var pTree = getSkillTree(s.spec);
            for (var pi = 0; pi < s.meta.perks.length; pi++) {
                for (var pj = 0; pj < pTree.length; pj++) {
                    if (pTree[pj].id === s.meta.perks[pi] && pTree[pj].effect.type === 'scoreMod') {
                        base += pTree[pj].effect.amount;
                    }
                }
            }
        }
        // Phase 7: prestige multiplier
        var prestige = getPrestigeLevel();
        if (prestige > 0) base = Math.round(base * (1 + prestige * 0.1));
        return base;
    }

    // Serialize
    function serialize(s) {
        return JSON.stringify({
            v: s.version,
            seed: s.seed,
            month: s.month,
            li: s.levelIndex,
            company: s.company,
            spec: s.spec,
            specXP: s.specXP,
            specXPSpent: s.specXPSpent,
            vars: s.vars,
            items: s.items,
            sts: s.statuses,
            occ: s.occurred,
            meta: s.meta,
            rngCalls: rngCalls
        });
    }

    function deserialize(json) {
        var d = JSON.parse(json);
        var s = newGameState(d.seed);
        s.month = d.month;
        s.levelIndex = d.li;
        s.vars = d.vars;
        s.items = d.items;
        s.statuses = d.sts || {};
        s.occurred = d.occ || [];
        s.meta = d.meta || {};

        // v1→v2 compatibility: ensure new item fields exist
        if (s.items.patents === undefined) s.items.patents = 0;
        if (s.items.conferencetalks === undefined) s.items.conferencetalks = 0;

        // v1→v2 compatibility: ensure new meta fields exist
        if (s.meta.lowMoraleStreak === undefined) s.meta.lowMoraleStreak = 0;

        // v1 senior saves: default track if at senior+ without track
        if (s.levelIndex >= 2 && !s.meta.track && (!d.v || d.v < 2)) {
            s.meta.track = 'ic';
        }

        // v2→v3 compatibility: default company and new meta fields
        s.company = d.company || 'bigtech';
        if (s.meta.totalEarnings === undefined) s.meta.totalEarnings = 0;
        if (s.meta.jobHops === undefined) s.meta.jobHops = 0;
        if (!s.meta.companyHistory) s.meta.companyHistory = [];

        // v3→v4 compatibility: savings, purchases, world event fields
        if (s.meta.savings === undefined) s.meta.savings = 0;
        if (!s.meta.purchases) s.meta.purchases = [];
        if (s.meta.worldEvent === undefined) s.meta.worldEvent = null;
        if (s.meta.worldEventRemaining === undefined) s.meta.worldEventRemaining = 0;
        if (s.meta.worldEventCooldown === undefined) s.meta.worldEventCooldown = 0;
        if (!s.meta.worldEventHistory) s.meta.worldEventHistory = [];

        // v4→v5 compatibility: specialization fields
        s.spec = d.spec || null;
        s.specXP = d.specXP || 0;

        // v5→v6 compatibility: skill tree fields
        s.specXPSpent = d.specXPSpent || 0;
        if (!s.meta.perks) s.meta.perks = [];

        s.version = 6;

        // Sync LEVELS from saved track
        syncLevels(s);

        restoreRng(d.seed, d.rngCalls || 0);
        return s;
    }

    // ==================== SECTION 5: ENGINE ====================

    var state;
    var currentScreen = 'title';
    var eventQueue = [];
    var pendingTask = true;

    function applyCompanyEffects(s) {
        var ct = COMPANY_TYPES[s.company];
        if (!ct) return;
        // Passive monthly stat mods
        var mods = ct.monthlyMods;
        if (mods.skill) addStat(s, 'skill', mods.skill);
        if (mods.morale) addStat(s, 'morale', mods.morale);
        if (mods.reputation) addStat(s, 'reputation', mods.reputation);
        if (mods.managerRel) addStat(s, 'managerRel', mods.managerRel);
        // Salary accrual
        var monthlySalary = getMonthlySalary(s);
        s.meta.totalEarnings = (s.meta.totalEarnings || 0) + monthlySalary;
        // Savings accrual (30% default, 33% with Financial Advisor)
        var savingsRate = hasPurchase(s, 'financialAdvisor') ? 0.33 : 0.30;
        s.meta.savings = (s.meta.savings || 0) + Math.round(monthlySalary * savingsRate);
        // Remote-first: ensure remoteWork status persists
        if (s.company === 'remote' && !s.statuses.remoteWork) {
            addStatus(s, 'remoteWork', 99);
        }
    }

    function applyWorldEventEffects(s) {
        if (!s.meta.worldEvent) return;
        var we = getWorldEvent(s.meta.worldEvent);
        if (!we) return;
        // Apply global monthly mods (SRE Mindset perk halves penalties)
        var weHalve = hasPerk(s, 'do_sre_mindset');
        var gm = we.monthlyMods;
        if (gm.morale) addStat(s, 'morale', weHalve && gm.morale < 0 ? Math.ceil(gm.morale / 2) : gm.morale);
        if (gm.skill) addStat(s, 'skill', weHalve && gm.skill < 0 ? Math.ceil(gm.skill / 2) : gm.skill);
        if (gm.reputation) addStat(s, 'reputation', weHalve && gm.reputation < 0 ? Math.ceil(gm.reputation / 2) : gm.reputation);
        if (gm.managerRel) addStat(s, 'managerRel', weHalve && gm.managerRel < 0 ? Math.ceil(gm.managerRel / 2) : gm.managerRel);
        // Company-specific morale mod
        var cm = we.companyMods[s.company];
        if (cm && cm.moraleMod) addStat(s, 'morale', weHalve && cm.moraleMod < 0 ? Math.ceil(cm.moraleMod / 2) : cm.moraleMod);
        // Pandemic special: force remoteWork
        if (we.id === 'pandemic' && !s.statuses.remoteWork) {
            addStatus(s, 'remoteWork', 99);
        }
        // Decrement remaining
        s.meta.worldEventRemaining--;
        if (s.meta.worldEventRemaining <= 0) {
            endWorldEvent(s);
        }
    }

    function endWorldEvent(s) {
        var weId = s.meta.worldEvent;
        s.meta.worldEventHistory.push(weId);
        awardAchievement('survive_world_event');
        // Pandemic end: remove remoteWork unless remote company
        if (weId === 'pandemic' && s.company !== 'remote') {
            if (s.statuses.remoteWork) delete s.statuses.remoteWork;
        }
        s.meta.worldEvent = null;
        s.meta.worldEventRemaining = 0;
        s.meta.worldEventCooldown = randInt(6, 12);
        s.meta.worldEventJustEnded = weId;
    }

    function applyPurchaseEffects(s) {
        if (!s.meta.purchases) return;
        // Home Office: +1 Morale/month
        if (hasPurchase(s, 'homeOffice')) addStat(s, 'morale', 1);
        // Coworking Membership: +1 Rep/month
        if (hasPurchase(s, 'coworkingMembership')) addStat(s, 'reputation', 1);
    }

    function applySpecEffects(s) {
        if (!s.spec || !SPEC_TYPES[s.spec]) return;
        var mods = SPEC_TYPES[s.spec].monthlyMods;
        if (mods.morale) addStat(s, 'morale', mods.morale);
        if (mods.skill) addStat(s, 'skill', mods.skill);
        if (mods.reputation) addStat(s, 'reputation', mods.reputation);
        if (mods.managerRel) addStat(s, 'managerRel', mods.managerRel);
    }

    function applyStatusEffects(s) {
        var keys = Object.keys(s.statuses);
        for (var i = 0; i < keys.length; i++) {
            var id = keys[i];
            var def = STATUS_DEFS[id];
            if (!def) continue;
            var moraleMod = def.moraleMod;
            // Ergonomic Setup: halve crunchMode morale penalty
            if (id === 'crunchMode' && moraleMod < 0 && hasPurchase(s, 'ergonomicSetup')) {
                moraleMod = Math.ceil(moraleMod / 2);
            }
            // Zero Downtime perk: additional halve on crunch
            if (id === 'crunchMode' && moraleMod < 0 && hasPerk(s, 'be_zero_downtime')) {
                moraleMod = Math.ceil(moraleMod / 2);
            }
            if (moraleMod !== 0) {
                addStat(s, 'morale', moraleMod);
            }
            // Meditation App: extra decrement on burnout
            if (id === 'burnoutStatus' && hasPurchase(s, 'meditationApp')) {
                s.statuses[id].remaining--;
            }
            s.statuses[id].remaining--;
            if (s.statuses[id].remaining <= 0) {
                // PIP expired without improvement = fired (non-profit is more forgiving)
                if (id === 'pip') {
                    if (s.company !== 'nonprofit' && (s.vars.skill < 30 || s.vars.managerRel < 30)) {
                        s.meta.gameOver = true;
                        s.meta.gameOverReason = 'fired';
                    }
                }
                delete s.statuses[id];
            }
        }
        // Flow state: bonus skill on any gains this month (simplified: flat bonus)
        if (s.statuses.flowState) {
            addStat(s, 'skill', 2);
        }
        // Imposter syndrome: halve next reputation gain (tracked via flag)
        // Pixel Perfect perk: immune to imposter syndrome
        s.meta.imposterActive = !!s.statuses.imposterSyndrome && !hasPerk(s, 'fe_pixel_perfect');
        // Mentor bonus: +2 rep/month
        if (s.statuses.mentorBonus) {
            addStat(s, 'reputation', 2);
        }
        // Coach bonus: +2 managerRel/month
        if (s.statuses.coachBonus) {
            addStat(s, 'managerRel', 2);
        }
        // Job hunting: 20% chance of morale boost (external interest)
        if (s.statuses.jobHunting && rand() < 0.2) {
            addStat(s, 'morale', 3);
        }
        // Remote work: slight visibility cost
        if (s.statuses.remoteWork) {
            addStat(s, 'reputation', -1);
        }
    }

    function checkGameOver(s) {
        if (s.meta.gameOver) return true;

        // Serial job hopper: 5+ job switches = game over
        if ((s.meta.jobHops || 0) >= 5) {
            s.meta.gameOver = true;
            s.meta.gameOverReason = 'serialHopper';
            return true;
        }

        // Startup exit: startup company, 36+ months, high stats, 8% chance
        if (s.company === 'startup' && s.month >= 36 && s.vars.skill >= 70 && s.vars.reputation >= 60 && rand() < 0.08) {
            s.meta.gameOver = true;
            s.meta.gameOverReason = 'startupExit';
            return true;
        }

        // Track low morale streak for quitTech ending
        if (s.vars.morale < 15) {
            s.meta.lowMoraleStreak = (s.meta.lowMoraleStreak || 0) + 1;
        } else {
            s.meta.lowMoraleStreak = 0;
        }

        // Quit Tech: morale < 15 for 3+ consecutive months under crunchMode or badManager
        if (s.meta.lowMoraleStreak >= 3 && (s.statuses.crunchMode || s.statuses.badManager)) {
            s.meta.gameOver = true;
            s.meta.gameOverReason = 'quitTech';
            return true;
        }

        // Started Own Company: skill>=80, rep>=70, jobHunting + startupInterest
        if (s.vars.skill >= 80 && s.vars.reputation >= 70 && s.statuses.jobHunting && s.meta.startupInterest) {
            s.meta.gameOver = true;
            s.meta.gameOverReason = 'startup';
            return true;
        }

        // Developer Advocate: rep>=75, blogPosts>=5, techTalks>=3, conferencetalks>=2
        if (s.vars.reputation >= 75 && s.items.blogPosts >= 5 && s.items.techTalks >= 3 && s.items.conferencetalks >= 2) {
            s.meta.gameOver = true;
            s.meta.gameOverReason = 'devAdvocate';
            return true;
        }

        if (s.vars.morale <= 0) {
            s.meta.gameOver = true;
            s.meta.gameOverReason = 'burnout';
            return true;
        }
        if (s.month >= 120) {
            s.meta.gameOver = true;
            s.meta.gameOverReason = 'plateau';
            return true;
        }
        if (s.meta.won) {
            s.meta.gameOver = true;
            s.meta.gameOverReason = 'won';
            return true;
        }
        return false;
    }

    function gatherEvents(s) {
        var events = [];
        var ct = COMPANY_TYPES[s.company] || COMPANY_TYPES.bigtech;
        var probMult = ct.eventProbMult || {};

        // World event end display
        if (s.meta.worldEventJustEnded) {
            var endedWe = getWorldEvent(s.meta.worldEventJustEnded);
            s.meta.worldEventJustEnded = null;
            if (endedWe) {
                events.push({
                    type: 'worldEnd',
                    data: {
                        name: endedWe.icon + ' ' + endedWe.name + ' — Over',
                        text: endedWe.endText,
                        choices: [{
                            label: 'Back to normal',
                            hint: 'The crisis has passed',
                            apply: function () { return { lines: ['Things are returning to normal.'] }; }
                        }]
                    }
                });
            }
        }

        // World event triggering
        if (!s.meta.worldEvent && s.meta.worldEventCooldown <= 0 && s.month >= 6) {
            for (var wi = 0; wi < WORLD_EVENTS.length; wi++) {
                var wCandidate = WORLD_EVENTS[wi];
                // Prevent same event firing twice per game
                if (s.meta.worldEventHistory && s.meta.worldEventHistory.indexOf(wCandidate.id) !== -1) continue;
                if (rand() < wCandidate.triggerProb) {
                    s.meta.worldEvent = wCandidate.id;
                    s.meta.worldEventRemaining = randInt(wCandidate.durationRange[0], wCandidate.durationRange[1]);
                    events.push({ type: 'worldStart', data: wCandidate });
                    break;
                }
            }
        }
        // Cooldown decrement
        if (!s.meta.worldEvent && s.meta.worldEventCooldown > 0) {
            s.meta.worldEventCooldown--;
        }

        // Active world event modifiers for event probabilities
        var weEventMods = {};
        var wePromoSpeedMod = 1.0;
        var weCrunchMult = 1.0;
        if (s.meta.worldEvent) {
            var activeWe = getWorldEvent(s.meta.worldEvent);
            if (activeWe) {
                weEventMods = activeWe.eventProbMods || {};
                wePromoSpeedMod = activeWe.promoSpeedMod || 1.0;
                var weCm = activeWe.companyMods[s.company];
                if (weCm && weCm.crunchRiskMult) weCrunchMult = weCm.crunchRiskMult;
            }
        }

        // Career fork: inject when pendingFork is set
        if (s.meta.pendingFork && s.occurred.indexOf('careerFork') === -1) {
            events.push({ type: 'career', data: CAREER_EVENTS.careerFork });
            s.meta.pendingFork = false;
        }

        // Career gates
        if (s.month === 3 && s.occurred.indexOf('probationReview') === -1) {
            events.push({ type: 'career', data: CAREER_EVENTS.probationReview });
        }
        if (s.month > 3 && s.month % 6 === 0) {
            events.push({ type: 'career', data: CAREER_EVENTS.performanceReview });
        }
        // Promotion interval: adjusted by company promo speed and world event
        var promoInterval = Math.max(6, Math.floor(12 * ct.promoSpeedMult * wePromoSpeedMod));
        if (s.month >= promoInterval && s.month % promoInterval === 0 && s.meta.lastReview === 'positive') {
            events.push({ type: 'career', data: CAREER_EVENTS.promotionConsideration });
        }

        // Seasonal modifiers
        var calMonth = (s.month - 1) % 12;

        // Random events (max 1 per month to keep pacing good)
        var randomPicked = false;
        var shuffled = RANDOM_EVENTS.slice();
        // Simple shuffle
        for (var i = shuffled.length - 1; i > 0; i--) {
            var j = Math.floor(rand() * (i + 1));
            var tmp = shuffled[i];
            shuffled[i] = shuffled[j];
            shuffled[j] = tmp;
        }
        for (var k = 0; k < shuffled.length && !randomPicked; k++) {
            var ev = shuffled[k];
            if (ev.once && s.occurred.indexOf(ev.id) !== -1) continue;
            if (ev.condition && !ev.condition(s)) continue;
            if (ev.seasonal !== undefined && calMonth !== ev.seasonal) continue;

            // Base probability with company + world event multipliers
            var effectiveProb = ev.prob * (probMult[ev.id] !== undefined ? probMult[ev.id] : 1.0);
            if (weEventMods[ev.id] !== undefined) effectiveProb *= weEventMods[ev.id];
            // Sep (8): Conference season — 3x conferenceInvite probability
            if (ev.id === 'conferenceInvite' && calMonth === 8) effectiveProb *= 3;

            if (rand() < effectiveProb) {
                events.push({ type: 'random', data: ev });
                randomPicked = true;
            }
        }

        // Company-specific events (try if no regular random event picked)
        if (!randomPicked) {
            var companyPool = [];
            for (var ci = 0; ci < COMPANY_EVENTS.length; ci++) {
                var cev = COMPANY_EVENTS[ci];
                if (cev.company !== s.company) continue;
                if (cev.once && s.occurred.indexOf(cev.id) !== -1) continue;
                if (cev.condition && !cev.condition(s)) continue;
                companyPool.push(cev);
            }
            // Shuffle company pool
            for (var ci2 = companyPool.length - 1; ci2 > 0; ci2--) {
                var cj = Math.floor(rand() * (ci2 + 1));
                var ctmp = companyPool[ci2];
                companyPool[ci2] = companyPool[cj];
                companyPool[cj] = ctmp;
            }
            for (var ck = 0; ck < companyPool.length && !randomPicked; ck++) {
                var evProb = companyPool[ck].prob;
                if (weEventMods[companyPool[ck].id] !== undefined) evProb *= weEventMods[companyPool[ck].id];
                if (rand() < evProb) {
                    events.push({ type: 'random', data: companyPool[ck] });
                    randomPicked = true;
                }
            }
        }

        // Specialization events (try if no regular/company random event picked)
        if (!randomPicked && s.spec) {
            var specPool = [];
            for (var spi = 0; spi < SPEC_EVENTS.length; spi++) {
                var sev = SPEC_EVENTS[spi];
                if (sev.spec !== s.spec) continue;
                if (sev.once && s.occurred.indexOf(sev.id) !== -1) continue;
                if (sev.condition && !sev.condition(s)) continue;
                specPool.push(sev);
            }
            // Shuffle spec pool
            for (var spi2 = specPool.length - 1; spi2 > 0; spi2--) {
                var spj = Math.floor(rand() * (spi2 + 1));
                var sptmp = specPool[spi2];
                specPool[spi2] = specPool[spj];
                specPool[spj] = sptmp;
            }
            for (var spk = 0; spk < specPool.length && !randomPicked; spk++) {
                var spProb = specPool[spk].prob;
                // Expert level: 1.5x spec event probability
                if (getSpecLevelIndex(s.specXP) >= 2) spProb *= 1.5;
                if (weEventMods[specPool[spk].id] !== undefined) spProb *= weEventMods[specPool[spk].id];
                if (rand() < spProb) {
                    events.push({ type: 'random', data: specPool[spk] });
                    randomPicked = true;
                }
            }
        }

        // Oct-Nov (9-10): Q4 crunch risk (adjusted by company + world event)
        var crunchChance = 0.30 * ct.crunchRiskMult * weCrunchMult;
        if ((calMonth === 9 || calMonth === 10) && !s.statuses.crunchMode && rand() < crunchChance) {
            addStatus(s, 'crunchMode', 2);
        }

        return events;
    }

    function tick() {
        state.month++;
        applyCompanyEffects(state);
        applyWorldEventEffects(state);
        applyPurchaseEffects(state);
        applySpecEffects(state);
        applyPerkEffects(state);
        applyStatusEffects(state);
        checkTickAchievements(state);

        if (checkGameOver(state)) {
            showScreen('result');
            return;
        }

        // Gather events for this month
        eventQueue = gatherEvents(state);
        pendingTask = true;

        renderGame();
        processNextEvent();
    }

    function processNextEvent() {
        if (eventQueue.length > 0) {
            var ev = eventQueue.shift();
            showEvent(ev);
        } else if (pendingTask) {
            pendingTask = false;
            showMonthlyTasks();
        } else if (state.meta.pendingJobSwitch) {
            state.meta.pendingJobSwitch = false;
            showCompanySwitch();
        } else {
            // Month complete
            autoSave();
            tick();
        }
    }

    // ==================== SECTION 6: TYPEWRITER ====================

    var typewriterTimer = null;
    var typewriterDone = false;
    var typewriterCallback = null;
    var typewriterEl = null;
    var typewriterFullText = '';

    function typewrite(el, text, cb) {
        clearTypewriter();
        typewriterEl = el;
        typewriterFullText = text;
        typewriterDone = false;
        typewriterCallback = cb;
        el.textContent = '';
        el.classList.add('ds-message__text--typing');
        var idx = 0;
        typewriterTimer = setInterval(function () {
            if (idx < text.length) {
                el.textContent += text[idx];
                idx++;
            } else {
                finishTypewriter();
            }
        }, 18);
    }

    function skipTypewriter() {
        if (!typewriterDone && typewriterEl) {
            finishTypewriter();
        }
    }

    function finishTypewriter() {
        clearInterval(typewriterTimer);
        typewriterTimer = null;
        typewriterDone = true;
        if (typewriterEl) {
            typewriterEl.textContent = typewriterFullText;
            typewriterEl.classList.remove('ds-message__text--typing');
        }
        if (typewriterCallback) typewriterCallback();
    }

    function clearTypewriter() {
        if (typewriterTimer) clearInterval(typewriterTimer);
        typewriterTimer = null;
        typewriterDone = false;
        typewriterCallback = null;
    }

    // ==================== SECTION 7: UI RENDERING ====================

    function h(tag, cls, html) {
        var el = document.createElement(tag);
        if (cls) el.className = cls;
        if (html !== undefined) el.innerHTML = html;
        return el;
    }

    function showScreen(name) {
        currentScreen = name;
        root.style.opacity = '0';
        root.innerHTML = '';
        if (name === 'title') renderTitle();
        else if (name === 'companySelect') renderCompanySelect();
        else if (name === 'specSelect') renderSpecSelect();
        else if (name === 'game') renderGame();
        else if (name === 'result') renderResult();
        else if (name === 'leaderboard') renderLeaderboard();
        else if (name === 'achievements') renderAchievements();
        else if (name === 'stats') renderStats();
        requestAnimationFrame(function () { root.style.opacity = '1'; });
    }

    // --- Keyboard Navigation ---
    document.addEventListener('keydown', function (e) {
        // Modal open: Escape closes it
        var modal = document.querySelector('.ds-modal-overlay');
        if (modal) {
            if (e.key === 'Escape') {
                var closeBtn = modal.querySelector('.ds-modal__close .ds-btn');
                if (closeBtn) closeBtn.click();
            }
            return;
        }
        // Game screen: number keys select choices
        if (currentScreen === 'game') {
            var num = parseInt(e.key, 10);
            if (num >= 1 && num <= 9) {
                var choices = root.querySelectorAll('.ds-choice');
                if (choices.length >= num) {
                    choices[num - 1].click();
                }
            }
        }
        // Result screen: Enter submits score
        if (currentScreen === 'result' && e.key === 'Enter') {
            var submitBtn = root.querySelector('.ds-result__name .ds-btn');
            if (submitBtn && !submitBtn.disabled) submitBtn.click();
        }
    });

    // --- Title Screen ---
    function renderTitle() {
        var wrap = h('div', 'ds-title');

        wrap.appendChild(h('h1', 'ds-title__heading', '&gt;_ Dev Career Simulator'));
        wrap.appendChild(h('p', 'ds-title__sub', 'Can you reach the top of the tech ladder?'));
        wrap.appendChild(h('p', 'ds-title__tagline', 'A text-based career RPG. Each turn = 1 month.'));

        var pLevel = getPrestigeLevel();
        if (pLevel > 0) {
            var pDef = getPrestigeDef(pLevel);
            var stars = '';
            for (var pi = 1; pi <= PRESTIGE_MAX; pi++) stars += pi <= pLevel ? '\u2605' : '\u2606';
            var badgeCls = 'ds-prestige-badge' + (pLevel >= PRESTIGE_MAX ? ' ds-prestige-badge--max' : '');
            var badge = h('div', badgeCls);
            badge.innerHTML =
                '<span class="ds-prestige-badge__stars">' + stars + '</span>' +
                '<span class="ds-prestige-badge__label">Prestige ' + pLevel + '</span>' +
                '<span class="ds-prestige-badge__name">' + pDef.name + '</span>';
            wrap.appendChild(badge);
        }

        var rules = h('div', 'ds-title__rules');
        rules.innerHTML =
            '<p><strong>Goal:</strong> Reach Senior, then choose your path: IC (Staff \u2192 Principal) or Management (Tech Lead \u2192 VP Eng).</p>' +
            '<p><strong>Company:</strong> Choose your company type — startup, big tech, agency, remote-first, or non-profit. Each has unique events, salary, and pacing.</p>' +
            '<p><strong>Stats:</strong> Morale, Skill, Reputation, Manager Rel (0-100). Salary tracks your earnings.</p>' +
            '<p><strong>Lose if:</strong> Morale hits 0, get fired, hop jobs 5+ times, or 10 years pass.</p>' +
            '<p><strong>Special endings:</strong> Start a company, become a Dev Advocate, startup exit, quit tech, or serial job hop.</p>' +
            '<p><strong>Each month:</strong> Events happen, then you choose a task. Look for new jobs at mid-level+.</p>' +
            '<p><strong>World Events:</strong> Macro crises (recession, AI boom, pandemic...) reshape gameplay for months.</p>' +
            '<p><strong>Shop:</strong> Spend savings on upgrades — courses, coaching, ergonomic setup, and more.</p>' +
            '<p><strong>Specialization:</strong> Choose a tech focus (Frontend, Backend, DevOps, Data/ML, Mobile) for unique tasks, events, and salary bonuses.</p>' +
            '<p><strong>Promotions:</strong> Require meeting stat & item thresholds + a positive performance review.</p>';
        wrap.appendChild(rules);

        var buttons = h('div', 'ds-title__buttons');

        var newBtn = h('button', 'ds-btn ds-btn--primary', 'New Game');
        newBtn.addEventListener('click', function () { startNewGame(); });
        buttons.appendChild(newBtn);

        if (localStorage.getItem('ds-autosave')) {
            var contBtn = h('button', 'ds-btn', 'Continue');
            contBtn.addEventListener('click', function () { continueGame(); });
            buttons.appendChild(contBtn);
        }

        var lbBtn = h('button', 'ds-btn ds-btn--small', 'Leaderboard');
        lbBtn.addEventListener('click', function () { showScreen('leaderboard'); });
        buttons.appendChild(lbBtn);

        var achData = loadAchievements();
        var achBtn = h('button', 'ds-btn ds-btn--small', 'Achievements (' + achData.unlocked.length + '/' + ACHIEVEMENTS.length + ')');
        achBtn.addEventListener('click', function () { showScreen('achievements'); });
        buttons.appendChild(achBtn);

        var statsBtn = h('button', 'ds-btn ds-btn--small', 'Stats');
        statsBtn.addEventListener('click', function () { showScreen('stats'); });
        buttons.appendChild(statsBtn);

        wrap.appendChild(buttons);
        root.appendChild(wrap);
    }

    // --- Company Selection Screen ---
    function renderCompanySelect() {
        var wrap = h('div', 'ds-title');
        wrap.appendChild(h('h1', 'ds-title__heading', 'Choose Your Company'));
        wrap.appendChild(h('p', 'ds-title__sub', 'Where will you start your career?'));

        var grid = h('div', 'ds-company-grid');
        var companyIds = ['startup', 'bigtech', 'agency', 'remote', 'nonprofit'];
        for (var i = 0; i < companyIds.length; i++) {
            (function (compId) {
                var ct = COMPANY_TYPES[compId];
                var startSalary = Math.round(SALARY_TABLE.junior * ct.salaryMult);
                var card = h('button', 'ds-company-card');
                card.innerHTML =
                    '<div class="ds-company-card__icon">' + ct.icon + '</div>' +
                    '<div class="ds-company-card__name">' + ct.name + '</div>' +
                    '<div class="ds-company-card__desc">' + ct.desc + '</div>' +
                    '<div class="ds-company-card__salary">Starting: ' + formatSalary(startSalary) + '/yr</div>';
                card.addEventListener('click', function () {
                    applyCompanySelection(compId);
                });
                grid.appendChild(card);
            })(companyIds[i]);
        }
        wrap.appendChild(grid);
        root.appendChild(wrap);
    }

    function applyCompanySelection(compId) {
        var ct = COMPANY_TYPES[compId];
        state.company = compId;
        // Apply start overrides
        var overrides = ct.startOverrides;
        state.vars.morale = overrides.morale;
        state.vars.skill = overrides.skill;
        state.vars.reputation = overrides.reputation;
        state.vars.managerRel = overrides.managerRel;
        applyPrestigeToState(state);
        // Remote-first starts with remoteWork status
        if (compId === 'remote') {
            addStatus(state, 'remoteWork', 99);
        }
        showScreen('specSelect');
    }

    // --- Specialization Selection Screen ---
    function renderSpecSelect() {
        var wrap = h('div', 'ds-title');
        wrap.appendChild(h('h1', 'ds-title__heading', 'Choose Your Specialization'));
        wrap.appendChild(h('p', 'ds-title__sub', 'What\'s your technical focus?'));

        var grid = h('div', 'ds-company-grid');
        var specIds = ['frontend', 'backend', 'devops', 'dataml', 'mobile'];
        for (var i = 0; i < specIds.length; i++) {
            (function (specId) {
                var sp = SPEC_TYPES[specId];
                var salaryLabel = sp.salaryMult === 1.0 ? 'Base salary' : '+' + Math.round((sp.salaryMult - 1) * 100) + '% salary';
                var card = h('button', 'ds-company-card');
                card.innerHTML =
                    '<div class="ds-company-card__icon">' + sp.icon + '</div>' +
                    '<div class="ds-company-card__name">' + sp.name + '</div>' +
                    '<div class="ds-company-card__desc">' + sp.desc + '</div>' +
                    '<div class="ds-company-card__salary">' + salaryLabel + '</div>';
                card.addEventListener('click', function () {
                    applySpecSelection(specId);
                });
                grid.appendChild(card);
            })(specIds[i]);
        }
        wrap.appendChild(grid);
        root.appendChild(wrap);
    }

    function applySpecSelection(specId) {
        state.spec = specId;
        showScreen('game');
        setTimeout(function () { tick(); }, 100);
    }

    // --- Game Screen ---
    function renderGame() {
        if (currentScreen !== 'game') currentScreen = 'game';
        root.innerHTML = '';

        var wrap = h('div', 'ds-game');

        // Header
        var header = h('div', 'ds-header');
        var info = h('div', 'ds-header__info');
        var trackLabel = state.meta.track ? ' [' + (state.meta.track === 'ic' ? 'IC' : 'Mgmt') + ']' : '';
        var activeLevels = getActiveLevels(state);
        var ct = COMPANY_TYPES[state.company];
        var companyLabel = ct ? ' <span class="ds-header__company">' + ct.icon + ' ' + ct.name + '</span>' : '';
        var specLabel = '';
        if (state.spec && SPEC_TYPES[state.spec]) {
            var sp = SPEC_TYPES[state.spec];
            var specLvl = getSpecLevel(state.specXP);
            specLabel = ' <span class="ds-header__spec">' + sp.icon + ' ' + sp.name + ' (' + specLvl.name + ')</span>';
        }
        info.innerHTML =
            '<span>Month ' + state.month + ' (' + getMonthName(state.month - 1) + ', Year ' + getYear(state.month - 1) + ')</span>' +
            '<span class="ds-header__level">' + activeLevels[state.levelIndex].name + trackLabel + '</span>' +
            companyLabel + specLabel;
        header.appendChild(info);

        var actions = h('div', 'ds-header__actions');
        var shopBtn = h('button', 'ds-btn ds-btn--small', 'Shop');
        shopBtn.addEventListener('click', function () { showShopModal(false); });
        actions.appendChild(shopBtn);
        if (state.spec) {
            var treeBtn = h('button', 'ds-btn ds-btn--small', 'Skill Tree');
            treeBtn.addEventListener('click', function () { renderSkillTreeModal(); });
            actions.appendChild(treeBtn);
        }
        var saveBtn = h('button', 'ds-btn ds-btn--small', 'Save/Load');
        saveBtn.addEventListener('click', function () { showSaveLoadModal(); });
        actions.appendChild(saveBtn);
        header.appendChild(actions);
        wrap.appendChild(header);

        // World event banner
        if (state.meta.worldEvent) {
            var weData = getWorldEvent(state.meta.worldEvent);
            if (weData) {
                var banner = h('div', 'ds-world-event');
                banner.innerHTML = '<span class="ds-world-event__icon">' + weData.icon + '</span>' +
                    '<span class="ds-world-event__name">' + weData.name + '</span>' +
                    '<span class="ds-world-event__remaining">' + state.meta.worldEventRemaining + ' months remaining</span>';
                wrap.appendChild(banner);
            }
        }

        // Stats
        var stats = h('div', 'ds-stats');
        var statKeys = [
            { key: 'morale', label: 'Morale', cls: 'ds-stat--morale' },
            { key: 'skill', label: 'Skill', cls: 'ds-stat--skill' },
            { key: 'reputation', label: 'Reputation', cls: 'ds-stat--reputation' },
            { key: 'managerRel', label: 'Manager Rel', cls: 'ds-stat--manager' }
        ];
        for (var i = 0; i < statKeys.length; i++) {
            var sk = statKeys[i];
            var stat = h('div', 'ds-stat ' + sk.cls);
            stat.setAttribute('aria-label', sk.label + ': ' + state.vars[sk.key] + ' out of 100');
            stat.setAttribute('title', sk.label + ': ' + state.vars[sk.key] + '/100');
            stat.innerHTML =
                '<div class="ds-stat__label"><span>' + sk.label + '</span><span>' + state.vars[sk.key] + '/100</span></div>' +
                '<div class="ds-stat__bar"><div class="ds-stat__fill" style="width:' + state.vars[sk.key] + '%"></div></div>';
            stats.appendChild(stat);
        }
        wrap.appendChild(stats);

        // Spec XP bar
        if (state.spec && SPEC_TYPES[state.spec]) {
            var spData = SPEC_TYPES[state.spec];
            var spLevel = getSpecLevel(state.specXP);
            var specXPDiv = h('div', 'ds-spec-xp');
            specXPDiv.innerHTML =
                '<div class="ds-spec-xp__label"><span>' + spData.icon + ' ' + spData.name + ' XP</span><span>' + state.specXP + '/100 (' + spLevel.name + ')</span></div>' +
                '<div class="ds-stat__bar"><div class="ds-stat__fill ds-stat__fill--spec" style="width:' + state.specXP + '%"></div></div>';
            wrap.appendChild(specXPDiv);
        }

        // Message area
        var msg = h('div', 'ds-message');
        msg.setAttribute('id', 'ds-msg');
        msg.setAttribute('role', 'status');
        msg.setAttribute('aria-live', 'polite');
        msg.innerHTML = '<div class="ds-message__title" id="ds-msg-title"></div><div class="ds-message__text" id="ds-msg-text"></div>';
        var skip = h('div', 'ds-message__skip', 'click to skip');
        skip.style.display = 'none';
        skip.setAttribute('id', 'ds-skip');
        msg.appendChild(skip);
        msg.addEventListener('click', function () { skipTypewriter(); });
        wrap.appendChild(msg);

        // Choices area
        var choicesDiv = h('div', 'ds-choices');
        choicesDiv.setAttribute('id', 'ds-choices');
        wrap.appendChild(choicesDiv);

        // Items
        var itemsDiv = h('div', 'ds-items');
        itemsDiv.innerHTML = '<div class="ds-items__title">Items</div>';
        for (var j = 0; j < ITEM_DEFS.length; j++) {
            var def = ITEM_DEFS[j];
            if (def.minLevel > state.levelIndex) continue;
            var count = state.items[def.id] || 0;
            var badge = h('span', 'ds-badge');
            badge.innerHTML = def.icon + ' ' + def.name + ' <span class="ds-badge__count">' + count + '</span>';
            itemsDiv.appendChild(badge);
        }
        wrap.appendChild(itemsDiv);

        // Statuses
        var statusKeys = Object.keys(state.statuses);
        if (statusKeys.length > 0) {
            var statusDiv = h('div', 'ds-statuses');
            for (var k = 0; k < statusKeys.length; k++) {
                var sid = statusKeys[k];
                var sdef = STATUS_DEFS[sid];
                if (!sdef) continue;
                var cls = 'ds-status ds-status--' + sdef.type;
                var badge2 = h('span', cls);
                badge2.textContent = sdef.name + ' (' + state.statuses[sid].remaining + 'mo)';
                statusDiv.appendChild(badge2);
            }
            wrap.appendChild(statusDiv);
        }

        // Footer
        var footer = h('div', 'ds-footer');
        var annualSalary = getMonthlySalary(state) * 12;
        var totalEarnings = state.meta.totalEarnings || 0;
        var savings = state.meta.savings || 0;
        footer.innerHTML = '<span>Seed: ' + state.seed + '</span>' +
            '<span>Salary: ' + formatSalary(annualSalary) + '/yr</span>' +
            '<span>Earned: $' + Math.round(totalEarnings / 1000) + 'k</span>' +
            '<span>Savings: $' + Math.round(savings / 1000) + 'k</span>' +
            '<span>Score: ' + computeScore(state) + '</span>';
        wrap.appendChild(footer);

        root.appendChild(wrap);
    }

    // --- Show Event ---
    function showEvent(ev) {
        var data = ev.data;
        var titleEl = document.getElementById('ds-msg-title');
        var textEl = document.getElementById('ds-msg-text');
        var choicesEl = document.getElementById('ds-choices');
        var skipEl = document.getElementById('ds-skip');

        if (!titleEl || !textEl || !choicesEl) {
            renderGame();
            titleEl = document.getElementById('ds-msg-title');
            textEl = document.getElementById('ds-msg-text');
            choicesEl = document.getElementById('ds-choices');
            skipEl = document.getElementById('ds-skip');
        }

        // World event start: use startText and startChoices
        if (ev.type === 'worldStart') {
            titleEl.textContent = data.icon + ' ' + data.name;
            choicesEl.innerHTML = '';
            if (skipEl) skipEl.style.display = 'block';
            typewrite(textEl, data.startText, function () {
                if (skipEl) skipEl.style.display = 'none';
                renderChoices(choicesEl, data.startChoices);
            });
            return;
        }

        // World event end
        if (ev.type === 'worldEnd') {
            titleEl.textContent = data.name;
            choicesEl.innerHTML = '';
            if (skipEl) skipEl.style.display = 'block';
            typewrite(textEl, data.text, function () {
                if (skipEl) skipEl.style.display = 'none';
                renderChoices(choicesEl, data.choices);
            });
            return;
        }

        titleEl.textContent = data.name;
        choicesEl.innerHTML = '';
        if (skipEl) skipEl.style.display = 'block';

        // Mark once-events
        if (data.once) {
            state.occurred.push(data.id);
        }

        var choices;
        if (data.getChoices) {
            choices = data.getChoices(state);
        } else {
            choices = data.choices;
        }

        var eventText = typeof data.text === 'function' ? data.text(state) : data.text;
        typewrite(textEl, eventText, function () {
            if (skipEl) skipEl.style.display = 'none';
            renderChoices(choicesEl, choices);
        });
    }

    function renderChoices(container, choices) {
        container.innerHTML = '';
        for (var i = 0; i < choices.length; i++) {
            (function (choice, idx) {
                var btn = h('button', 'ds-choice');
                btn.innerHTML = '<div class="ds-choice__label">' + (idx + 1) + '. ' + choice.label + '</div>' +
                    (choice.hint ? '<div class="ds-choice__hint">' + choice.hint + '</div>' : '');
                btn.addEventListener('click', function () {
                    // Apply imposter syndrome effect
                    var oldRep = state.vars.reputation;
                    var result = choice.apply(state);
                    if (state.meta.imposterActive && state.vars.reputation > oldRep) {
                        var gain = state.vars.reputation - oldRep;
                        var halved = Math.floor(gain / 2);
                        state.vars.reputation = oldRep + halved;
                    }
                    showOutcome(container, result, function () {
                        processNextEvent();
                    });
                });
                container.appendChild(btn);
            })(choices[i], i);
        }
    }

    function showOutcome(container, result, cb) {
        container.innerHTML = '';
        var outcomeDiv = h('div', 'ds-outcome');
        for (var i = 0; i < result.lines.length; i++) {
            var line = result.lines[i];
            var cls = 'ds-outcome__line--neutral';
            if (line.charAt(0) === '+') cls = 'ds-outcome__line--pos';
            else if (line.charAt(0) === '-') cls = 'ds-outcome__line--neg';
            var p = h('div', cls, line);
            outcomeDiv.appendChild(p);
        }
        container.appendChild(outcomeDiv);

        // Re-render stats
        updateStatBars();

        var contBtn = h('button', 'ds-btn ds-btn--small', 'Continue');
        contBtn.addEventListener('click', function () {
            cb();
        });
        container.appendChild(contBtn);
    }

    function updateStatBars() {
        var fills = root.querySelectorAll('.ds-stat__fill');
        var labels = root.querySelectorAll('.ds-stat__label');
        var keys = ['morale', 'skill', 'reputation', 'managerRel'];
        for (var i = 0; i < fills.length && i < keys.length; i++) {
            fills[i].style.width = state.vars[keys[i]] + '%';
            var spans = labels[i].querySelectorAll('span');
            if (spans.length >= 2) {
                spans[1].textContent = state.vars[keys[i]] + '/100';
            }
        }
    }

    // --- Monthly Tasks ---
    function showMonthlyTasks() {
        var titleEl = document.getElementById('ds-msg-title');
        var textEl = document.getElementById('ds-msg-text');
        var choicesEl = document.getElementById('ds-choices');
        var skipEl = document.getElementById('ds-skip');

        if (!titleEl || !textEl || !choicesEl) {
            renderGame();
            titleEl = document.getElementById('ds-msg-title');
            textEl = document.getElementById('ds-msg-text');
            choicesEl = document.getElementById('ds-choices');
            skipEl = document.getElementById('ds-skip');
        }

        titleEl.textContent = 'Monthly Task';
        choicesEl.innerHTML = '';
        if (skipEl) skipEl.style.display = 'block';

        typewrite(textEl, 'What do you want to focus on this month?', function () {
            if (skipEl) skipEl.style.display = 'none';
            var available = [];
            for (var i = 0; i < MONTHLY_TASKS.length; i++) {
                if (MONTHLY_TASKS[i].minLevel <= state.levelIndex) {
                    available.push(MONTHLY_TASKS[i]);
                }
            }
            // Add company-specific tasks
            for (var j = 0; j < COMPANY_TASKS.length; j++) {
                if (COMPANY_TASKS[j].company === state.company && COMPANY_TASKS[j].minLevel <= state.levelIndex) {
                    available.push(COMPANY_TASKS[j]);
                }
            }
            // Add specialization tasks
            if (state.spec) {
                var specLvl = getSpecLevelIndex(state.specXP);
                for (var si = 0; si < SPEC_TASKS.length; si++) {
                    var st = SPEC_TASKS[si];
                    if (st.spec === state.spec && st.minLevel <= state.levelIndex && specLvl >= st.specLevel) {
                        available.push(st);
                    }
                }
            }
            renderTaskChoices(choicesEl, available);
        });
    }

    function renderTaskChoices(container, tasks) {
        container.innerHTML = '';
        for (var i = 0; i < tasks.length; i++) {
            (function (task, idx) {
                var btn = h('button', 'ds-choice');
                btn.innerHTML = '<div class="ds-choice__label">' + (idx + 1) + '. ' + task.name + '</div>' +
                    '<div class="ds-choice__hint">' + task.hint + '</div>';
                btn.addEventListener('click', function () {
                    var oldRep = state.vars.reputation;
                    var result = task.apply(state);
                    if (state.meta.imposterActive && state.vars.reputation > oldRep) {
                        var gain = state.vars.reputation - oldRep;
                        var halved = Math.floor(gain / 2);
                        state.vars.reputation = oldRep + halved;
                    }
                    // Chance to ship a feature on code/sideProject tasks
                    var featureChance = 0.15;
                    if (task.id === 'sideProject' && hasPurchase(state, 'sideProjectHosting')) featureChance *= 2;
                    if ((task.id === 'writeCode' || task.id === 'sideProject') && rand() < featureChance) {
                        state.items.features++;
                        result.lines.push('+1 Feature Shipped!');
                        // Feature bonus perks
                        if (state.meta.perks) {
                            var fTree = getSkillTree(state.spec);
                            for (var fi = 0; fi < fTree.length; fi++) {
                                if (fTree[fi].effect.type === 'featureBonus' && hasPerk(state, fTree[fi].id)) {
                                    addStat(state, fTree[fi].effect.stat, fTree[fi].effect.amount);
                                    result.lines.push('+' + fTree[fi].effect.amount + ' ' + fTree[fi].effect.stat.charAt(0).toUpperCase() + fTree[fi].effect.stat.slice(1) + ' (perk)');
                                }
                            }
                        }
                    }
                    // Spec XP: aligned task bonus
                    if (state.spec && SPEC_TYPES[state.spec]) {
                        var sp = SPEC_TYPES[state.spec];
                        if (sp.alignedTasks.indexOf(task.id) !== -1) {
                            addSpecXP(state, 1);
                            result.lines.push('+1 Spec XP (aligned task)');
                            var tb = sp.taskBonus;
                            var tbKeys = Object.keys(tb);
                            for (var ti = 0; ti < tbKeys.length; ti++) {
                                addStat(state, tbKeys[ti], tb[tbKeys[ti]]);
                                result.lines.push('+' + tb[tbKeys[ti]] + ' ' + tbKeys[ti].charAt(0).toUpperCase() + tbKeys[ti].slice(1) + ' (spec bonus)');
                            }
                            // Perk: taskBonus on aligned tasks
                            if (state.meta.perks) {
                                var atTree = getSkillTree(state.spec);
                                for (var ai = 0; ai < atTree.length; ai++) {
                                    if (atTree[ai].effect.type === 'taskBonus' && hasPerk(state, atTree[ai].id)) {
                                        addStat(state, atTree[ai].effect.stat, atTree[ai].effect.amount);
                                        result.lines.push('+' + atTree[ai].effect.amount + ' ' + atTree[ai].effect.stat.charAt(0).toUpperCase() + atTree[ai].effect.stat.slice(1) + ' (perk)');
                                    }
                                }
                            }
                        }
                        // Study always grants spec XP
                        if (task.id === 'study') {
                            addSpecXP(state, 1);
                            result.lines.push('+1 Spec XP (study)');
                            // Study XP bonus perk
                            if (hasPerk(state, 'dm_feature_engineer')) {
                                addSpecXP(state, 1);
                                result.lines.push('+1 Spec XP (perk)');
                            }
                        }
                        // Mentor XP bonus perk
                        if (task.id === 'mentor' && hasPerk(state, 'dm_research_lead')) {
                            addSpecXP(state, 2);
                            result.lines.push('+2 Spec XP (perk)');
                        }
                        // Context bonus perks (specific task bonuses)
                        if (state.meta.perks) {
                            var ctTree = getSkillTree(state.spec);
                            for (var ci = 0; ci < ctTree.length; ci++) {
                                if (ctTree[ci].effect.type === 'contextBonus' && ctTree[ci].effect.context === task.id && hasPerk(state, ctTree[ci].id)) {
                                    addStat(state, ctTree[ci].effect.stat, ctTree[ci].effect.amount);
                                    result.lines.push('+' + ctTree[ci].effect.amount + ' ' + ctTree[ci].effect.stat.charAt(0).toUpperCase() + ctTree[ci].effect.stat.slice(1) + ' (perk)');
                                }
                            }
                        }
                    }
                    showOutcome(container, result, function () {
                        processNextEvent();
                    });
                });
                container.appendChild(btn);
            })(tasks[i], i);
        }
    }

    // --- Company Switch ---
    function showCompanySwitch() {
        var titleEl = document.getElementById('ds-msg-title');
        var textEl = document.getElementById('ds-msg-text');
        var choicesEl = document.getElementById('ds-choices');
        var skipEl = document.getElementById('ds-skip');

        if (!titleEl || !textEl || !choicesEl) {
            renderGame();
            titleEl = document.getElementById('ds-msg-title');
            textEl = document.getElementById('ds-msg-text');
            choicesEl = document.getElementById('ds-choices');
            skipEl = document.getElementById('ds-skip');
        }

        titleEl.textContent = 'Job Offers';
        choicesEl.innerHTML = '';
        if (skipEl) skipEl.style.display = 'block';

        // Pick 2-3 random companies excluding current
        var otherCompanies = [];
        var companyIds = Object.keys(COMPANY_TYPES);
        for (var i = 0; i < companyIds.length; i++) {
            if (companyIds[i] !== state.company) otherCompanies.push(companyIds[i]);
        }
        // Shuffle
        for (var si = otherCompanies.length - 1; si > 0; si--) {
            var sj = Math.floor(rand() * (si + 1));
            var stmp = otherCompanies[si];
            otherCompanies[si] = otherCompanies[sj];
            otherCompanies[sj] = stmp;
        }
        var offers = otherCompanies.slice(0, randInt(2, 3));

        typewrite(textEl, 'You\'ve been exploring the market. Here are your offers:', function () {
            if (skipEl) skipEl.style.display = 'none';
            var choices = [];
            for (var oi = 0; oi < offers.length; oi++) {
                (function (compId) {
                    var ct = COMPANY_TYPES[compId];
                    var activeLevels = getActiveLevels(state);
                    var levelId = activeLevels[state.levelIndex].id;
                    var baseSalary = SALARY_TABLE[levelId] || 80000;
                    var offerSalary = Math.round(baseSalary * ct.salaryMult);
                    choices.push({
                        label: ct.icon + ' ' + ct.name + ' — ' + formatSalary(offerSalary) + '/yr',
                        hint: ct.desc,
                        apply: function (s) {
                            var oldCompany = s.company;
                            s.company = compId;
                            s.meta.jobHops = (s.meta.jobHops || 0) + 1;
                            s.meta.companyHistory.push({ company: oldCompany, month: s.month });
                            s.vars.managerRel = 50;
                            addStatus(s, 'newJobEnergy', 3);
                            if (s.statuses.badManager) delete s.statuses.badManager;
                            if (s.statuses.pip) delete s.statuses.pip;
                            // Remove remoteWork if leaving remote company
                            if (oldCompany === 'remote' && compId !== 'remote') {
                                if (s.statuses.remoteWork) delete s.statuses.remoteWork;
                            }
                            // Add remoteWork if joining remote company
                            if (compId === 'remote') {
                                addStatus(s, 'remoteWork', 99);
                            }
                            var r = { lines: ['Switched to ' + ct.name + '!', 'Manager Rel reset to 50', 'Gained: New Job Energy'] };
                            // Reputation penalty for serial hopping (3+ hops)
                            if (s.meta.jobHops >= 3) {
                                // Resume Service: skip rep penalty once
                                if (hasPurchase(s, 'resumeService') && !s.meta.resumeServiceUsed) {
                                    s.meta.resumeServiceUsed = true;
                                    r.lines.push('Resume Service absorbed the job hopper stigma!');
                                } else {
                                    var penalty = (s.meta.jobHops - 2) * 3;
                                    addStat(s, 'reputation', -penalty);
                                    r.lines.push('-' + penalty + ' Reputation (job hopper stigma)');
                                }
                            }
                            return r;
                        }
                    });
                })(offers[oi]);
            }
            // Stay option
            choices.push({
                label: 'Stay at current company',
                hint: 'The grass isn\'t always greener',
                apply: function (s) {
                    addStat(s, 'morale', 2);
                    return { lines: ['+2 Morale', 'You decide to stay. Loyalty has its rewards.'] };
                }
            });
            renderChoices(choicesEl, choices);
        });
    }

    // --- Result Screen ---
    function renderResult() {
        root.innerHTML = '';
        var wrap = h('div', 'ds-result');

        var reason = state.meta.gameOverReason;
        var won = reason === 'won' || reason === 'startup' || reason === 'devAdvocate' || reason === 'startupExit';
        var activeLevels = getActiveLevels(state);

        // Award ending achievements
        if (reason === 'burnout') awardAchievement('ending_burnout');
        else if (reason === 'fired') awardAchievement('ending_fired');
        else if (reason === 'quitTech') awardAchievement('ending_quit');
        else if (reason === 'startup') awardAchievement('ending_founder');
        else if (reason === 'devAdvocate') awardAchievement('ending_devadvocate');
        else if (reason === 'startupExit') awardAchievement('ending_exit');
        else if (reason === 'plateau') awardAchievement('ending_plateau');

        var heading = h('h1', 'ds-result__heading ' + (won ? 'ds-result__heading--win' : 'ds-result__heading--lose'));
        if (reason === 'won') {
            heading.textContent = 'YOU MADE IT!';
        } else if (reason === 'startup') {
            heading.textContent = 'FOUNDER MODE!';
        } else if (reason === 'devAdvocate') {
            heading.textContent = 'DEV ADVOCATE!';
        } else if (reason === 'startupExit') {
            heading.textContent = 'STARTUP EXIT!';
        } else if (reason === 'burnout') {
            heading.textContent = 'BURNOUT';
        } else if (reason === 'fired') {
            heading.textContent = 'FIRED';
        } else if (reason === 'quitTech') {
            heading.textContent = 'QUIT TECH';
        } else if (reason === 'serialHopper') {
            heading.textContent = 'SERIAL JOB HOPPER';
        } else {
            heading.textContent = '10-YEAR PLATEAU';
        }
        wrap.appendChild(heading);

        var sub = h('p', 'ds-result__sub');
        if (reason === 'won') {
            var topLevel = activeLevels[state.levelIndex].name;
            sub.textContent = 'You reached ' + topLevel + ' in ' + state.month + ' months!';
        } else if (reason === 'startup') {
            sub.textContent = 'You left to start your own company after ' + state.month + ' months! The startup dream is real.';
        } else if (reason === 'devAdvocate') {
            sub.textContent = 'Your reputation and content made you the perfect Developer Advocate! Month ' + state.month + '.';
        } else if (reason === 'startupExit') {
            sub.textContent = 'Your startup got acquired! After ' + state.month + ' months of hustle, the equity paid off.';
        } else if (reason === 'burnout') {
            sub.textContent = 'Your morale hit zero. You burned out after ' + state.month + ' months.';
        } else if (reason === 'fired') {
            sub.textContent = 'You were let go after failing your PIP. ' + state.month + ' months in.';
        } else if (reason === 'quitTech') {
            sub.textContent = 'Crushed by bad conditions, you left tech after ' + state.month + ' months. Time for a new chapter.';
        } else if (reason === 'serialHopper') {
            sub.textContent = 'You switched jobs ' + (state.meta.jobHops || 0) + ' times in ' + state.month + ' months. Nobody wants to hire a flight risk.';
        } else {
            sub.textContent = '10 years passed without reaching the top. Time to rethink.';
        }
        wrap.appendChild(sub);

        var score = computeScore(state);
        recordGameStats(state, score);
        var pLevel = getPrestigeLevel();
        var scoreLabel = 'Score: ' + score;
        if (pLevel > 0) scoreLabel += ' (\u00D7' + (1 + pLevel * 0.1).toFixed(1) + ' prestige)';
        wrap.appendChild(h('div', 'ds-result__score', scoreLabel));

        var trackInfo = state.meta.track ? ' (' + (state.meta.track === 'ic' ? 'IC Track' : 'Management Track') + ')' : '';
        var ct = COMPANY_TYPES[state.company];
        var companyName = ct ? ct.icon + ' ' + ct.name : '-';
        var totalEarnings = state.meta.totalEarnings || 0;
        var endSavings = state.meta.savings || 0;
        var purchaseCount = state.meta.purchases ? state.meta.purchases.length : 0;
        var worldEventsSurvived = state.meta.worldEventHistory ? state.meta.worldEventHistory.length : 0;
        var specDisplay = '-';
        if (state.spec && SPEC_TYPES[state.spec]) {
            var spd = SPEC_TYPES[state.spec];
            var spLvl = getSpecLevel(state.specXP);
            specDisplay = spd.icon + ' ' + spd.name + ' (' + spLvl.name + ', XP: ' + state.specXP + ')';
        }
        var statsDiv = h('div', 'ds-result__stats');
        statsDiv.innerHTML =
            '<div>Company: ' + companyName + '</div>' +
            '<div>Specialization: ' + specDisplay + '</div>' +
            '<div>Final Level: ' + activeLevels[state.levelIndex].name + trackInfo + '</div>' +
            '<div>Months: ' + state.month + ' | Job Switches: ' + (state.meta.jobHops || 0) + '</div>' +
            '<div>Total Earnings: $' + Math.round(totalEarnings / 1000) + 'k | Savings: $' + Math.round(endSavings / 1000) + 'k</div>' +
            '<div>Purchases: ' + purchaseCount + ' | World Events Survived: ' + worldEventsSurvived + '</div>' +
            '<div>Morale: ' + state.vars.morale + ' | Skill: ' + state.vars.skill + '</div>' +
            '<div>Reputation: ' + state.vars.reputation + ' | Manager Rel: ' + state.vars.managerRel + '</div>' +
            '<div>PRs: ' + state.items.prs + ' | Features: ' + state.items.features + ' | Hotfixes: ' + state.items.hotfixes + '</div>' +
            '<div>Design Docs: ' + state.items.designDocs + ' | Tech Talks: ' + state.items.techTalks + '</div>' +
            '<div>Blog Posts: ' + state.items.blogPosts + ' | Mentorships: ' + state.items.mentorships + '</div>' +
            '<div>Patents: ' + (state.items.patents || 0) + ' | Conf. Talks: ' + (state.items.conferencetalks || 0) + '</div>' +
            '<div>Perks: ' + (state.meta.perks ? state.meta.perks.length : 0) + '/6 unlocked</div>' +
            '<div>Achievements: ' + loadAchievements().unlocked.length + '/' + ACHIEVEMENTS.length + '</div>' +
            '<div>Prestige: ' + (pLevel > 0 ? 'Level ' + pLevel + ' \u2014 ' + getPrestigeDef(pLevel).name : 'None') + '</div>' +
            '<div style="margin-top:8px;color:var(--color-text-faint);">Seed: ' + state.seed + '</div>';
        wrap.appendChild(statsDiv);

        // Name entry
        var nameDiv = h('div', 'ds-result__name');
        var nameInput = h('input', 'ds-input');
        nameInput.setAttribute('type', 'text');
        nameInput.setAttribute('placeholder', 'Your name');
        nameInput.setAttribute('maxlength', '16');
        nameDiv.appendChild(nameInput);
        var submitBtn = h('button', 'ds-btn ds-btn--small', 'Submit Score');
        submitBtn.addEventListener('click', function () {
            var name = nameInput.value.trim() || 'Anonymous';
            addToLeaderboard(name, score, state);
            submitBtn.disabled = true;
            submitBtn.textContent = 'Submitted!';
        });
        nameDiv.appendChild(submitBtn);
        wrap.appendChild(nameDiv);

        // Prestige button (win only)
        if (won && pLevel < PRESTIGE_MAX) {
            var nextPDef = getPrestigeDef(pLevel + 1);
            var prestigeBtn = h('button', 'ds-btn ds-btn--prestige', 'Prestige+ \u2192 ' + nextPDef.name);
            prestigeBtn.addEventListener('click', function () { doPrestige(); });
            wrap.appendChild(prestigeBtn);
        } else if (won && pLevel >= PRESTIGE_MAX) {
            var maxBadge = h('div', 'ds-prestige-badge ds-prestige-badge--max');
            maxBadge.innerHTML =
                '<span class="ds-prestige-badge__stars">\u2605\u2605\u2605\u2605\u2605</span>' +
                '<span class="ds-prestige-badge__label">MAX PRESTIGE</span>' +
                '<span class="ds-prestige-badge__name">Legend</span>';
            wrap.appendChild(maxBadge);
        }

        // Buttons
        var btns = h('div', 'ds-result__buttons');
        var playBtn = h('button', 'ds-btn ds-btn--primary', 'Play Again');
        playBtn.addEventListener('click', function () {
            startNewGame(won ? null : state.seed);
        });
        btns.appendChild(playBtn);

        var lbBtn = h('button', 'ds-btn', 'Leaderboard');
        lbBtn.addEventListener('click', function () { showScreen('leaderboard'); });
        btns.appendChild(lbBtn);

        var titleBtn = h('button', 'ds-btn ds-btn--small', 'Title Screen');
        titleBtn.addEventListener('click', function () { showScreen('title'); });
        btns.appendChild(titleBtn);

        wrap.appendChild(btns);
        root.appendChild(wrap);

        // Clear autosave on game end
        localStorage.removeItem('ds-autosave');
        // Auto-focus name input
        setTimeout(function () { if (nameInput) nameInput.focus(); }, 100);
    }

    // --- Leaderboard Screen ---
    function renderLeaderboard() {
        root.innerHTML = '';
        var wrap = h('div', 'ds-leaderboard');
        wrap.appendChild(h('h2', 'ds-leaderboard__heading', 'Leaderboard'));

        var data = getLeaderboard();
        if (data.length === 0) {
            wrap.appendChild(h('div', 'ds-lb__empty', 'No scores yet. Go play!'));
        } else {
            var table = h('table', 'ds-lb__table');
            table.innerHTML = '<thead><tr><th class="ds-lb__rank">#</th><th>Name</th><th>Company</th><th>Level</th><th>Months</th><th class="ds-lb__prestige">P</th><th class="ds-lb__score">Score</th></tr></thead>';
            var tbody = h('tbody');
            for (var i = 0; i < data.length; i++) {
                var row = data[i];
                var companyDisplay = row.companyName || '-';
                var tr = h('tr');
                var rowPrestige = row.prestige || 0;
                var prestigeCell = rowPrestige > 0 ? '\u2B50' + rowPrestige : '-';
                tr.innerHTML =
                    '<td class="ds-lb__rank">' + (i + 1) + '</td>' +
                    '<td>' + escHtml(row.name) + '</td>' +
                    '<td>' + escHtml(companyDisplay) + '</td>' +
                    '<td>' + row.level + '</td>' +
                    '<td>' + row.months + '</td>' +
                    '<td class="ds-lb__prestige">' + prestigeCell + '</td>' +
                    '<td class="ds-lb__score">' + row.score + '</td>';
                tbody.appendChild(tr);
            }
            table.appendChild(tbody);
            wrap.appendChild(table);
        }

        var backDiv = h('div', 'ds-leaderboard__back');
        var backBtn = h('button', 'ds-btn', 'Back');
        backBtn.addEventListener('click', function () { showScreen('title'); });
        backDiv.appendChild(backBtn);
        wrap.appendChild(backDiv);

        root.appendChild(wrap);
    }

    // --- Achievements Screen ---
    function renderAchievements() {
        root.innerHTML = '';
        var wrap = h('div', 'ds-achievements-screen');
        wrap.appendChild(h('h2', 'ds-achievements-screen__heading', 'Achievements'));

        var data = loadAchievements();
        var grid = h('div', 'ds-ach-grid');
        for (var i = 0; i < ACHIEVEMENTS.length; i++) {
            var ach = ACHIEVEMENTS[i];
            var unlocked = data.unlocked.indexOf(ach.id) !== -1;
            var card = h('div', 'ds-ach-card' + (unlocked ? ' ds-ach-card--unlocked' : ''));
            card.innerHTML =
                '<div class="ds-ach-card__icon' + (unlocked ? '' : ' ds-ach-card__icon--locked') + '">' + (unlocked ? ach.icon : '\u2753') + '</div>' +
                '<div class="ds-ach-card__name">' + (unlocked ? escHtml(ach.name) : '???') + '</div>' +
                '<div class="' + (unlocked ? 'ds-ach-card__desc' : 'ds-ach-card__desc ds-ach-card__desc--hint') + '">' + (unlocked ? escHtml(ach.desc) : escHtml(ach.hint)) + '</div>';
            grid.appendChild(card);
        }
        wrap.appendChild(grid);

        var backDiv = h('div', 'ds-achievements-screen__back');
        var backBtn = h('button', 'ds-btn', 'Back');
        backBtn.addEventListener('click', function () { showScreen('title'); });
        backDiv.appendChild(backBtn);
        wrap.appendChild(backDiv);

        root.appendChild(wrap);
    }

    // --- Stats Screen ---
    function renderStats() {
        root.innerHTML = '';
        var wrap = h('div', 'ds-stats-screen');
        wrap.appendChild(h('h2', 'ds-stats-screen__heading', 'Lifetime Stats'));

        var st = loadStats();

        if (st.totalGames === 0) {
            wrap.appendChild(h('div', 'ds-lb__empty', 'No games played yet. Go play!'));
        } else {
            // Overview
            var overview = h('div', 'ds-stats-section');
            overview.appendChild(h('div', 'ds-stats-section__title', 'Overview'));
            var winRate = st.totalGames > 0 ? Math.round((st.totalWins / st.totalGames) * 100) : 0;
            var avgScore = st.totalGames > 0 ? Math.round(st.totalScore / st.totalGames) : 0;
            var oRows = [
                ['Total Games', st.totalGames],
                ['Wins', st.totalWins],
                ['Losses', st.totalLosses],
                ['Win Rate', winRate + '%'],
                ['Avg Score', avgScore],
                ['Best Score', st.bestScore]
            ];
            for (var i = 0; i < oRows.length; i++) {
                var row = h('div', 'ds-stats-row');
                row.innerHTML = '<span class="ds-stats-row__label">' + oRows[i][0] + '</span><span class="ds-stats-row__value">' + oRows[i][1] + '</span>';
                overview.appendChild(row);
            }
            wrap.appendChild(overview);

            // Records
            var records = h('div', 'ds-stats-section');
            records.appendChild(h('div', 'ds-stats-section__title', 'Records'));
            var fastWin = st.fastestWin < 999 ? st.fastestWin + ' months' : '-';
            var highLevel = st.highestLevelName || '-';
            var rRows = [
                ['Fastest Win', fastWin],
                ['Highest Level', highLevel],
                ['Best Win Streak', st.bestWinStreak],
                ['Total Earnings', '$' + Math.round(st.totalEarnings / 1000) + 'k']
            ];
            for (var ri = 0; ri < rRows.length; ri++) {
                var rr = h('div', 'ds-stats-row');
                rr.innerHTML = '<span class="ds-stats-row__label">' + rRows[ri][0] + '</span><span class="ds-stats-row__value">' + rRows[ri][1] + '</span>';
                records.appendChild(rr);
            }
            wrap.appendChild(records);

            // Endings
            var endings = h('div', 'ds-stats-section');
            endings.appendChild(h('div', 'ds-stats-section__title', 'Endings'));
            var endingNames = { burnout:'Burnout', fired:'Fired', won:'Won', startup:'Startup', devAdvocate:'Dev Advocate', startupExit:'Startup Exit', quitTech:'Quit Tech', serialHopper:'Serial Hopper', plateau:'Plateau' };
            var maxEnd = 1;
            var ek = Object.keys(st.endings);
            for (var ei = 0; ei < ek.length; ei++) { if (st.endings[ek[ei]] > maxEnd) maxEnd = st.endings[ek[ei]]; }
            for (var ej = 0; ej < ek.length; ej++) {
                var endRow = h('div', 'ds-stats-row');
                var barPct = Math.round((st.endings[ek[ej]] / maxEnd) * 100);
                endRow.innerHTML = '<span class="ds-stats-row__label">' + (endingNames[ek[ej]] || ek[ej]) + '</span>' +
                    '<span class="ds-stats-row__value"><span class="ds-stats-bar"><span class="ds-stats-bar__fill" style="width:' + barPct + '%"></span></span> ' + st.endings[ek[ej]] + '</span>';
                endings.appendChild(endRow);
            }
            wrap.appendChild(endings);

            // Preferences
            var prefs = h('div', 'ds-stats-section');
            prefs.appendChild(h('div', 'ds-stats-section__title', 'Preferences'));
            var favComp = '-', favCompMax = 0;
            var ck = Object.keys(st.companyPicks);
            for (var ci = 0; ci < ck.length; ci++) {
                if (st.companyPicks[ck[ci]] > favCompMax) { favCompMax = st.companyPicks[ck[ci]]; favComp = COMPANY_TYPES[ck[ci]] ? COMPANY_TYPES[ck[ci]].name : ck[ci]; }
            }
            var favSpec = '-', favSpecMax = 0;
            var sk = Object.keys(st.specPicks);
            for (var si = 0; si < sk.length; si++) {
                if (st.specPicks[sk[si]] > favSpecMax) { favSpecMax = st.specPicks[sk[si]]; favSpec = SPEC_TYPES[sk[si]] ? SPEC_TYPES[sk[si]].name : sk[si]; }
            }
            var pRows = [
                ['Favorite Company', favComp],
                ['Favorite Spec', favSpec],
                ['IC Runs', st.trackPicks.ic || 0],
                ['Mgmt Runs', st.trackPicks.mgmt || 0]
            ];
            for (var pi = 0; pi < pRows.length; pi++) {
                var pr = h('div', 'ds-stats-row');
                pr.innerHTML = '<span class="ds-stats-row__label">' + pRows[pi][0] + '</span><span class="ds-stats-row__value">' + pRows[pi][1] + '</span>';
                prefs.appendChild(pr);
            }
            wrap.appendChild(prefs);
        }

        var backDiv = h('div', 'ds-stats-screen__back');
        var backBtn = h('button', 'ds-btn', 'Back');
        backBtn.addEventListener('click', function () { showScreen('title'); });
        backDiv.appendChild(backBtn);
        wrap.appendChild(backDiv);

        root.appendChild(wrap);
    }

    function escHtml(str) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    }

    // --- Achievement Toast ---
    function showAchievementToast(id) {
        var def = getAchievementDef(id);
        if (!def) return;
        var existing = document.querySelectorAll('.ds-achievement-toast');
        var toast = document.createElement('div');
        toast.className = 'ds-achievement-toast';
        toast.setAttribute('role', 'alert');
        toast.style.bottom = (20 + existing.length * 80) + 'px';
        toast.innerHTML =
            '<span class="ds-achievement-toast__icon">' + def.icon + '</span>' +
            '<span class="ds-achievement-toast__label">' +
                '<span class="ds-achievement-toast__name">' + escHtml(def.name) + '</span>' +
                ' unlocked!' +
            '</span>';
        document.body.appendChild(toast);
        setTimeout(function () {
            toast.classList.add('ds-achievement-toast--hide');
            setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 400);
        }, 2800);
    }

    // --- Save/Load Modal ---
    function showSaveLoadModal() {
        var overlay = h('div', 'ds-modal-overlay');
        var modal = h('div', 'ds-modal');
        modal.appendChild(h('h3', 'ds-modal__heading', 'Save / Load'));

        var slots = h('div', 'ds-modal__slots');
        for (var i = 1; i <= 3; i++) {
            (function (slotNum) {
                var key = 'ds-save-' + slotNum;
                var data = localStorage.getItem(key);
                var slotDiv = h('div', 'ds-modal__slot');

                var info = h('div', data ? 'ds-modal__slot-info' : 'ds-modal__slot-info ds-modal__slot-info--empty');
                if (data) {
                    try {
                        var parsed = JSON.parse(data);
                        var slotTrack = parsed.meta && parsed.meta.track;
                        var slotLevels = slotTrack === 'ic' ? IC_LEVELS : (slotTrack === 'mgmt' ? MGMT_LEVELS : BASE_LEVELS);
                        var slotLevelName = slotLevels[parsed.li] ? slotLevels[parsed.li].name : 'Unknown';
                        var slotTrackLabel = slotTrack ? ' [' + (slotTrack === 'ic' ? 'IC' : 'Mgmt') + ']' : '';
                        var slotCompany = parsed.company && COMPANY_TYPES[parsed.company] ? COMPANY_TYPES[parsed.company].icon + ' ' : '';
                        info.textContent = 'Slot ' + slotNum + ': ' + slotCompany + 'Month ' + parsed.month + ', ' + slotLevelName + slotTrackLabel;
                    } catch (e) {
                        info.textContent = 'Slot ' + slotNum + ': Corrupted';
                    }
                } else {
                    info.textContent = 'Slot ' + slotNum + ': Empty';
                }
                slotDiv.appendChild(info);

                var actions = h('div', 'ds-modal__slot-actions');
                var saveBtn = h('button', 'ds-btn ds-btn--small', 'Save');
                saveBtn.addEventListener('click', function () {
                    localStorage.setItem(key, serialize(state));
                    overlay.remove();
                    showSaveLoadModal();
                });
                actions.appendChild(saveBtn);

                if (data) {
                    var loadBtn = h('button', 'ds-btn ds-btn--small', 'Load');
                    loadBtn.addEventListener('click', function () {
                        state = deserialize(data);
                        overlay.remove();
                        renderGame();
                    });
                    actions.appendChild(loadBtn);

                    var delBtn = h('button', 'ds-btn ds-btn--small ds-btn--danger', 'Del');
                    delBtn.addEventListener('click', function () {
                        localStorage.removeItem(key);
                        overlay.remove();
                        showSaveLoadModal();
                    });
                    actions.appendChild(delBtn);
                }

                slotDiv.appendChild(actions);
                slots.appendChild(slotDiv);
            })(i);
        }
        modal.appendChild(slots);

        var closeDiv = h('div', 'ds-modal__close');
        var closeBtn = h('button', 'ds-btn ds-btn--small', 'Close');
        closeBtn.addEventListener('click', function () { overlay.remove(); });
        closeDiv.appendChild(closeBtn);
        modal.appendChild(closeDiv);

        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) overlay.remove();
        });

        overlay.appendChild(modal);
        document.body.appendChild(overlay);
    }

    // --- Shop Modal ---
    function showShopModal(continueAfterClose) {
        var overlay = h('div', 'ds-modal-overlay');
        var modal = h('div', 'ds-modal ds-shop');
        modal.appendChild(h('h3', 'ds-modal__heading', 'Shop'));

        var savingsDisplay = h('div', 'ds-shop__savings');
        savingsDisplay.textContent = 'Savings: $' + Math.round((state.meta.savings || 0) / 1000) + 'k';
        modal.appendChild(savingsDisplay);

        var itemsList = h('div', 'ds-shop__items');
        for (var i = 0; i < SHOP_ITEMS.length; i++) {
            (function (item) {
                var owned = hasPurchase(state, item.id);
                var canAfford = (state.meta.savings || 0) >= item.cost;
                var row = h('div', 'ds-shop__item' + (owned ? ' ds-shop__item--owned' : ''));
                var infoDiv = h('div', 'ds-shop__item-info');
                infoDiv.innerHTML = '<strong>' + item.icon + ' ' + item.name + '</strong>' +
                    '<div style="font-size:var(--text-xs);color:var(--color-text-muted);">' + item.desc + '</div>';
                row.appendChild(infoDiv);

                var priceDiv = h('div', 'ds-shop__item-action');
                if (owned) {
                    priceDiv.innerHTML = '<span style="color:var(--color-text-faint);">OWNED</span>';
                } else {
                    var buyBtn = h('button', 'ds-btn ds-btn--small' + (canAfford ? '' : ' ds-btn--disabled'), '$' + Math.round(item.cost / 1000) + 'k');
                    if (canAfford) {
                        buyBtn.addEventListener('click', function () {
                            state.meta.savings -= item.cost;
                            if (!state.meta.purchases) state.meta.purchases = [];
                            state.meta.purchases.push(item.id);
                            if (state.meta.purchases.length === 1) awardAchievement('first_purchase');
                            if (item.apply) item.apply(state);
                            overlay.remove();
                            showShopModal(continueAfterClose);
                        });
                    } else {
                        buyBtn.disabled = true;
                    }
                    priceDiv.appendChild(buyBtn);
                }
                row.appendChild(priceDiv);
                itemsList.appendChild(row);
            })(SHOP_ITEMS[i]);
        }
        modal.appendChild(itemsList);

        var closeDiv = h('div', 'ds-modal__close');
        var closeBtn = h('button', 'ds-btn ds-btn--small', 'Close');
        closeBtn.addEventListener('click', function () {
            overlay.remove();
            renderGame();
            if (continueAfterClose) processNextEvent();
        });
        closeDiv.appendChild(closeBtn);
        modal.appendChild(closeDiv);

        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) {
                overlay.remove();
                renderGame();
                if (continueAfterClose) processNextEvent();
            }
        });

        overlay.appendChild(modal);
        document.body.appendChild(overlay);
    }

    // --- Skill Tree Modal ---
    function renderSkillTreeModal() {
        var overlay = h('div', 'ds-modal-overlay');
        var modal = h('div', 'ds-modal ds-skill-tree');

        var tree = getSkillTree(state.spec);
        var spDef = SPEC_TYPES[state.spec];
        var headerDiv = h('div', 'ds-skill-tree__header');
        headerDiv.innerHTML = '<span>' + spDef.icon + ' ' + spDef.name + ' Skill Tree</span>' +
            '<span class="ds-skill-tree__xp">Available XP: ' + getAvailableXP(state) + '</span>';
        modal.appendChild(headerDiv);

        var connector = h('div', 'ds-skill-tree__connector');

        for (var tier = 1; tier <= 3; tier++) {
            var tierLabel = h('div', 'ds-skill-tree__tier-label', 'Tier ' + tier);
            modal.appendChild(tierLabel);

            var tierRow = h('div', 'ds-skill-tree__tier');
            for (var i = 0; i < tree.length; i++) {
                if (tree[i].tier !== tier) continue;
                var perk = tree[i];
                var owned = hasPerk(state, perk.id);
                var affordable = canUnlockPerk(state, perk);
                var tierUnlocked = true;
                if (perk.tier === 2) {
                    tierUnlocked = false;
                    for (var t1 = 0; t1 < tree.length; t1++) {
                        if (tree[t1].tier === 1 && hasPerk(state, tree[t1].id)) { tierUnlocked = true; break; }
                    }
                }
                if (perk.tier === 3) {
                    tierUnlocked = false;
                    for (var t2 = 0; t2 < tree.length; t2++) {
                        if (tree[t2].tier === 2 && hasPerk(state, tree[t2].id)) { tierUnlocked = true; break; }
                    }
                }

                var cls = 'ds-perk';
                if (owned) cls += ' ds-perk--owned';
                else if (affordable) cls += ' ds-perk--affordable';
                else if (tierUnlocked) cls += ' ds-perk--expensive';
                else cls += ' ds-perk--locked';

                var perkEl = h('div', cls);
                perkEl.innerHTML =
                    '<div class="ds-perk__icon">' + perk.icon + '</div>' +
                    '<div class="ds-perk__name">' + perk.name + '</div>' +
                    '<div class="ds-perk__desc">' + perk.desc + '</div>' +
                    '<div class="ds-perk__cost">' + (owned ? '\u2713 Owned' : perk.cost + ' XP') + '</div>';

                if (affordable && !owned) {
                    (function (pid) {
                        perkEl.addEventListener('click', function () {
                            unlockPerk(state, pid);
                            overlay.remove();
                            renderSkillTreeModal();
                        });
                    })(perk.id);
                }

                tierRow.appendChild(perkEl);
            }
            modal.appendChild(tierRow);

            if (tier < 3) {
                modal.appendChild(connector.cloneNode(false));
            }
        }

        var closeDiv = h('div', 'ds-modal__close');
        var closeBtn = h('button', 'ds-btn ds-btn--small', 'Close');
        closeBtn.addEventListener('click', function () { overlay.remove(); renderGame(); });
        closeDiv.appendChild(closeBtn);
        modal.appendChild(closeDiv);

        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) { overlay.remove(); renderGame(); }
        });

        overlay.appendChild(modal);
        document.body.appendChild(overlay);
    }

    // ==================== SECTION 8: SAVE/LOAD ====================

    function autoSave() {
        try {
            localStorage.setItem('ds-autosave', serialize(state));
        } catch (e) {
            // Storage full, silently fail
        }
    }

    // ==================== SECTION 9: LEADERBOARD ====================

    function getLeaderboard() {
        try {
            return JSON.parse(localStorage.getItem('ds-leaderboard')) || [];
        } catch (e) {
            return [];
        }
    }

    function addToLeaderboard(name, score, s) {
        var board = getLeaderboard();
        var activeLevels = getActiveLevels(s);
        var ct = COMPANY_TYPES[s.company];
        var specName = s.spec && SPEC_TYPES[s.spec] ? SPEC_TYPES[s.spec].icon + ' ' + SPEC_TYPES[s.spec].name : '-';
        board.push({
            name: name,
            score: score,
            level: activeLevels[s.levelIndex].name,
            track: s.meta.track || null,
            companyName: ct ? ct.icon + ' ' + ct.name : '-',
            specName: specName,
            prestige: getPrestigeLevel(),
            months: s.month,
            seed: s.seed,
            date: new Date().toISOString().slice(0, 10)
        });
        board.sort(function (a, b) { return b.score - a.score; });
        if (board.length > 10) board = board.slice(0, 10);
        localStorage.setItem('ds-leaderboard', JSON.stringify(board));
    }

    // ==================== SECTION 10: INIT ====================

    function getSeedFromHash() {
        var match = window.location.hash.match(/seed=(\d+)/);
        return match ? parseInt(match[1], 10) : null;
    }

    function startNewGame(forceSeed) {
        var seed = forceSeed || getSeedFromHash() || Math.floor(Math.random() * 2147483647);
        initRng(seed);
        state = newGameState(seed);
        LEVELS = BASE_LEVELS;
        addStatus(state, 'newJobEnergy', 3);
        showScreen('companySelect');
    }

    function continueGame() {
        var data = localStorage.getItem('ds-autosave');
        if (data) {
            state = deserialize(data);
            showScreen('game');
            setTimeout(function () { tick(); }, 100);
        } else {
            startNewGame();
        }
    }

    // Initial render
    showScreen('title');

})();
